var He = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function wo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Eo(e) {
  if (e.__esModule) return e;
  var r = e.default;
  if (typeof r == "function") {
    var i = function o() {
      return this instanceof o ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    i.prototype = r.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(o) {
    var c = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(i, o, c.get ? c : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), i;
}
function So(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bi = { exports: {} }, Ae = bi.exports = {}, Ue, $e;
function Wr() {
  throw new Error("setTimeout has not been defined");
}
function Gr() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Ue = setTimeout : Ue = Wr;
  } catch {
    Ue = Wr;
  }
  try {
    typeof clearTimeout == "function" ? $e = clearTimeout : $e = Gr;
  } catch {
    $e = Gr;
  }
})();
function mi(e) {
  if (Ue === setTimeout)
    return setTimeout(e, 0);
  if ((Ue === Wr || !Ue) && setTimeout)
    return Ue = setTimeout, setTimeout(e, 0);
  try {
    return Ue(e, 0);
  } catch {
    try {
      return Ue.call(null, e, 0);
    } catch {
      return Ue.call(this, e, 0);
    }
  }
}
function _o(e) {
  if ($e === clearTimeout)
    return clearTimeout(e);
  if (($e === Gr || !$e) && clearTimeout)
    return $e = clearTimeout, clearTimeout(e);
  try {
    return $e(e);
  } catch {
    try {
      return $e.call(null, e);
    } catch {
      return $e.call(this, e);
    }
  }
}
var Ce = [], at = !1, ze, At = -1;
function Ao() {
  !at || !ze || (at = !1, ze.length ? Ce = ze.concat(Ce) : At = -1, Ce.length && wi());
}
function wi() {
  if (!at) {
    var e = mi(Ao);
    at = !0;
    for (var r = Ce.length; r; ) {
      for (ze = Ce, Ce = []; ++At < r; )
        ze && ze[At].run();
      At = -1, r = Ce.length;
    }
    ze = null, at = !1, _o(e);
  }
}
Ae.nextTick = function(e) {
  var r = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var i = 1; i < arguments.length; i++)
      r[i - 1] = arguments[i];
  Ce.push(new Ei(e, r)), Ce.length === 1 && !at && mi(wi);
};
function Ei(e, r) {
  this.fun = e, this.array = r;
}
Ei.prototype.run = function() {
  this.fun.apply(null, this.array);
};
Ae.title = "browser";
Ae.browser = !0;
Ae.env = {};
Ae.argv = [];
Ae.version = "";
Ae.versions = {};
function qe() {
}
Ae.on = qe;
Ae.addListener = qe;
Ae.once = qe;
Ae.off = qe;
Ae.removeListener = qe;
Ae.removeAllListeners = qe;
Ae.emit = qe;
Ae.prependListener = qe;
Ae.prependOnceListener = qe;
Ae.listeners = function(e) {
  return [];
};
Ae.binding = function(e) {
  throw new Error("process.binding is not supported");
};
Ae.cwd = function() {
  return "/";
};
Ae.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
Ae.umask = function() {
  return 0;
};
var Ro = bi.exports;
const re = /* @__PURE__ */ So(Ro);
var Pe = {}, $t = {};
$t.byteLength = jo;
$t.toByteArray = To;
$t.fromByteArray = Fo;
var ke = [], Ne = [], Oo = typeof Uint8Array < "u" ? Uint8Array : Array, Jt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Ze = 0, Po = Jt.length; Ze < Po; ++Ze)
  ke[Ze] = Jt[Ze], Ne[Jt.charCodeAt(Ze)] = Ze;
Ne[45] = 62;
Ne[95] = 63;
function Si(e) {
  var r = e.length;
  if (r % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var i = e.indexOf("=");
  i === -1 && (i = r);
  var o = i === r ? 0 : 4 - i % 4;
  return [i, o];
}
function jo(e) {
  var r = Si(e), i = r[0], o = r[1];
  return (i + o) * 3 / 4 - o;
}
function Io(e, r, i) {
  return (r + i) * 3 / 4 - i;
}
function To(e) {
  var r, i = Si(e), o = i[0], c = i[1], u = new Oo(Io(e, o, c)), h = 0, v = c > 0 ? o - 4 : o, b;
  for (b = 0; b < v; b += 4)
    r = Ne[e.charCodeAt(b)] << 18 | Ne[e.charCodeAt(b + 1)] << 12 | Ne[e.charCodeAt(b + 2)] << 6 | Ne[e.charCodeAt(b + 3)], u[h++] = r >> 16 & 255, u[h++] = r >> 8 & 255, u[h++] = r & 255;
  return c === 2 && (r = Ne[e.charCodeAt(b)] << 2 | Ne[e.charCodeAt(b + 1)] >> 4, u[h++] = r & 255), c === 1 && (r = Ne[e.charCodeAt(b)] << 10 | Ne[e.charCodeAt(b + 1)] << 4 | Ne[e.charCodeAt(b + 2)] >> 2, u[h++] = r >> 8 & 255, u[h++] = r & 255), u;
}
function Bo(e) {
  return ke[e >> 18 & 63] + ke[e >> 12 & 63] + ke[e >> 6 & 63] + ke[e & 63];
}
function xo(e, r, i) {
  for (var o, c = [], u = r; u < i; u += 3)
    o = (e[u] << 16 & 16711680) + (e[u + 1] << 8 & 65280) + (e[u + 2] & 255), c.push(Bo(o));
  return c.join("");
}
function Fo(e) {
  for (var r, i = e.length, o = i % 3, c = [], u = 16383, h = 0, v = i - o; h < v; h += u)
    c.push(xo(e, h, h + u > v ? v : h + u));
  return o === 1 ? (r = e[i - 1], c.push(
    ke[r >> 2] + ke[r << 4 & 63] + "=="
  )) : o === 2 && (r = (e[i - 2] << 8) + e[i - 1], c.push(
    ke[r >> 10] + ke[r >> 4 & 63] + ke[r << 2 & 63] + "="
  )), c.join("");
}
var Zr = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Zr.read = function(e, r, i, o, c) {
  var u, h, v = c * 8 - o - 1, b = (1 << v) - 1, R = b >> 1, l = -7, x = i ? c - 1 : 0, P = i ? -1 : 1, N = e[r + x];
  for (x += P, u = N & (1 << -l) - 1, N >>= -l, l += v; l > 0; u = u * 256 + e[r + x], x += P, l -= 8)
    ;
  for (h = u & (1 << -l) - 1, u >>= -l, l += o; l > 0; h = h * 256 + e[r + x], x += P, l -= 8)
    ;
  if (u === 0)
    u = 1 - R;
  else {
    if (u === b)
      return h ? NaN : (N ? -1 : 1) * (1 / 0);
    h = h + Math.pow(2, o), u = u - R;
  }
  return (N ? -1 : 1) * h * Math.pow(2, u - o);
};
Zr.write = function(e, r, i, o, c, u) {
  var h, v, b, R = u * 8 - c - 1, l = (1 << R) - 1, x = l >> 1, P = c === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, N = o ? 0 : u - 1, L = o ? 1 : -1, V = r < 0 || r === 0 && 1 / r < 0 ? 1 : 0;
  for (r = Math.abs(r), isNaN(r) || r === 1 / 0 ? (v = isNaN(r) ? 1 : 0, h = l) : (h = Math.floor(Math.log(r) / Math.LN2), r * (b = Math.pow(2, -h)) < 1 && (h--, b *= 2), h + x >= 1 ? r += P / b : r += P * Math.pow(2, 1 - x), r * b >= 2 && (h++, b /= 2), h + x >= l ? (v = 0, h = l) : h + x >= 1 ? (v = (r * b - 1) * Math.pow(2, c), h = h + x) : (v = r * Math.pow(2, x - 1) * Math.pow(2, c), h = 0)); c >= 8; e[i + N] = v & 255, N += L, v /= 256, c -= 8)
    ;
  for (h = h << c | v, R += c; R > 0; e[i + N] = h & 255, N += L, h /= 256, R -= 8)
    ;
  e[i + N - L] |= V * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const r = $t, i = Zr, o = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = l, e.SlowBuffer = $, e.INSPECT_MAX_BYTES = 50;
  const c = 2147483647;
  e.kMaxLength = c;
  const { Uint8Array: u, ArrayBuffer: h, SharedArrayBuffer: v } = globalThis;
  l.TYPED_ARRAY_SUPPORT = b(), !l.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function b() {
    try {
      const a = new u(1), t = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(t, u.prototype), Object.setPrototypeOf(a, t), a.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(l.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (l.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(l.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (l.isBuffer(this))
        return this.byteOffset;
    }
  });
  function R(a) {
    if (a > c)
      throw new RangeError('The value "' + a + '" is invalid for option "size"');
    const t = new u(a);
    return Object.setPrototypeOf(t, l.prototype), t;
  }
  function l(a, t, n) {
    if (typeof a == "number") {
      if (typeof t == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return L(a);
    }
    return x(a, t, n);
  }
  l.poolSize = 8192;
  function x(a, t, n) {
    if (typeof a == "string")
      return V(a, t);
    if (h.isView(a))
      return m(a);
    if (a == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof a
      );
    if (T(a, h) || a && T(a.buffer, h) || typeof v < "u" && (T(a, v) || a && T(a.buffer, v)))
      return w(a, t, n);
    if (typeof a == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const p = a.valueOf && a.valueOf();
    if (p != null && p !== a)
      return l.from(p, t, n);
    const A = j(a);
    if (A) return A;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof a[Symbol.toPrimitive] == "function")
      return l.from(a[Symbol.toPrimitive]("string"), t, n);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof a
    );
  }
  l.from = function(a, t, n) {
    return x(a, t, n);
  }, Object.setPrototypeOf(l.prototype, u.prototype), Object.setPrototypeOf(l, u);
  function P(a) {
    if (typeof a != "number")
      throw new TypeError('"size" argument must be of type number');
    if (a < 0)
      throw new RangeError('The value "' + a + '" is invalid for option "size"');
  }
  function N(a, t, n) {
    return P(a), a <= 0 ? R(a) : t !== void 0 ? typeof n == "string" ? R(a).fill(t, n) : R(a).fill(t) : R(a);
  }
  l.alloc = function(a, t, n) {
    return N(a, t, n);
  };
  function L(a) {
    return P(a), R(a < 0 ? 0 : M(a) | 0);
  }
  l.allocUnsafe = function(a) {
    return L(a);
  }, l.allocUnsafeSlow = function(a) {
    return L(a);
  };
  function V(a, t) {
    if ((typeof t != "string" || t === "") && (t = "utf8"), !l.isEncoding(t))
      throw new TypeError("Unknown encoding: " + t);
    const n = J(a, t) | 0;
    let p = R(n);
    const A = p.write(a, t);
    return A !== n && (p = p.slice(0, A)), p;
  }
  function W(a) {
    const t = a.length < 0 ? 0 : M(a.length) | 0, n = R(t);
    for (let p = 0; p < t; p += 1)
      n[p] = a[p] & 255;
    return n;
  }
  function m(a) {
    if (T(a, u)) {
      const t = new u(a);
      return w(t.buffer, t.byteOffset, t.byteLength);
    }
    return W(a);
  }
  function w(a, t, n) {
    if (t < 0 || a.byteLength < t)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (a.byteLength < t + (n || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let p;
    return t === void 0 && n === void 0 ? p = new u(a) : n === void 0 ? p = new u(a, t) : p = new u(a, t, n), Object.setPrototypeOf(p, l.prototype), p;
  }
  function j(a) {
    if (l.isBuffer(a)) {
      const t = M(a.length) | 0, n = R(t);
      return n.length === 0 || a.copy(n, 0, 0, t), n;
    }
    if (a.length !== void 0)
      return typeof a.length != "number" || Y(a.length) ? R(0) : W(a);
    if (a.type === "Buffer" && Array.isArray(a.data))
      return W(a.data);
  }
  function M(a) {
    if (a >= c)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + c.toString(16) + " bytes");
    return a | 0;
  }
  function $(a) {
    return +a != a && (a = 0), l.alloc(+a);
  }
  l.isBuffer = function(t) {
    return t != null && t._isBuffer === !0 && t !== l.prototype;
  }, l.compare = function(t, n) {
    if (T(t, u) && (t = l.from(t, t.offset, t.byteLength)), T(n, u) && (n = l.from(n, n.offset, n.byteLength)), !l.isBuffer(t) || !l.isBuffer(n))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (t === n) return 0;
    let p = t.length, A = n.length;
    for (let F = 0, k = Math.min(p, A); F < k; ++F)
      if (t[F] !== n[F]) {
        p = t[F], A = n[F];
        break;
      }
    return p < A ? -1 : A < p ? 1 : 0;
  }, l.isEncoding = function(t) {
    switch (String(t).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, l.concat = function(t, n) {
    if (!Array.isArray(t))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (t.length === 0)
      return l.alloc(0);
    let p;
    if (n === void 0)
      for (n = 0, p = 0; p < t.length; ++p)
        n += t[p].length;
    const A = l.allocUnsafe(n);
    let F = 0;
    for (p = 0; p < t.length; ++p) {
      let k = t[p];
      if (T(k, u))
        F + k.length > A.length ? (l.isBuffer(k) || (k = l.from(k)), k.copy(A, F)) : u.prototype.set.call(
          A,
          k,
          F
        );
      else if (l.isBuffer(k))
        k.copy(A, F);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      F += k.length;
    }
    return A;
  };
  function J(a, t) {
    if (l.isBuffer(a))
      return a.length;
    if (h.isView(a) || T(a, h))
      return a.byteLength;
    if (typeof a != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof a
      );
    const n = a.length, p = arguments.length > 2 && arguments[2] === !0;
    if (!p && n === 0) return 0;
    let A = !1;
    for (; ; )
      switch (t) {
        case "ascii":
        case "latin1":
        case "binary":
          return n;
        case "utf8":
        case "utf-8":
          return xe(a).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return n * 2;
        case "hex":
          return n >>> 1;
        case "base64":
          return Te(a).length;
        default:
          if (A)
            return p ? -1 : xe(a).length;
          t = ("" + t).toLowerCase(), A = !0;
      }
  }
  l.byteLength = J;
  function X(a, t, n) {
    let p = !1;
    if ((t === void 0 || t < 0) && (t = 0), t > this.length || ((n === void 0 || n > this.length) && (n = this.length), n <= 0) || (n >>>= 0, t >>>= 0, n <= t))
      return "";
    for (a || (a = "utf8"); ; )
      switch (a) {
        case "hex":
          return E(this, t, n);
        case "utf8":
        case "utf-8":
          return _e(this, t, n);
        case "ascii":
          return G(this, t, n);
        case "latin1":
        case "binary":
          return Q(this, t, n);
        case "base64":
          return we(this, t, n);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return I(this, t, n);
        default:
          if (p) throw new TypeError("Unknown encoding: " + a);
          a = (a + "").toLowerCase(), p = !0;
      }
  }
  l.prototype._isBuffer = !0;
  function Z(a, t, n) {
    const p = a[t];
    a[t] = a[n], a[n] = p;
  }
  l.prototype.swap16 = function() {
    const t = this.length;
    if (t % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let n = 0; n < t; n += 2)
      Z(this, n, n + 1);
    return this;
  }, l.prototype.swap32 = function() {
    const t = this.length;
    if (t % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let n = 0; n < t; n += 4)
      Z(this, n, n + 3), Z(this, n + 1, n + 2);
    return this;
  }, l.prototype.swap64 = function() {
    const t = this.length;
    if (t % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let n = 0; n < t; n += 8)
      Z(this, n, n + 7), Z(this, n + 1, n + 6), Z(this, n + 2, n + 5), Z(this, n + 3, n + 4);
    return this;
  }, l.prototype.toString = function() {
    const t = this.length;
    return t === 0 ? "" : arguments.length === 0 ? _e(this, 0, t) : X.apply(this, arguments);
  }, l.prototype.toLocaleString = l.prototype.toString, l.prototype.equals = function(t) {
    if (!l.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
    return this === t ? !0 : l.compare(this, t) === 0;
  }, l.prototype.inspect = function() {
    let t = "";
    const n = e.INSPECT_MAX_BYTES;
    return t = this.toString("hex", 0, n).replace(/(.{2})/g, "$1 ").trim(), this.length > n && (t += " ... "), "<Buffer " + t + ">";
  }, o && (l.prototype[o] = l.prototype.inspect), l.prototype.compare = function(t, n, p, A, F) {
    if (T(t, u) && (t = l.from(t, t.offset, t.byteLength)), !l.isBuffer(t))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof t
      );
    if (n === void 0 && (n = 0), p === void 0 && (p = t ? t.length : 0), A === void 0 && (A = 0), F === void 0 && (F = this.length), n < 0 || p > t.length || A < 0 || F > this.length)
      throw new RangeError("out of range index");
    if (A >= F && n >= p)
      return 0;
    if (A >= F)
      return -1;
    if (n >= p)
      return 1;
    if (n >>>= 0, p >>>= 0, A >>>= 0, F >>>= 0, this === t) return 0;
    let k = F - A, ne = p - n;
    const pe = Math.min(k, ne), ye = this.slice(A, F), Ee = t.slice(n, p);
    for (let ve = 0; ve < pe; ++ve)
      if (ye[ve] !== Ee[ve]) {
        k = ye[ve], ne = Ee[ve];
        break;
      }
    return k < ne ? -1 : ne < k ? 1 : 0;
  };
  function z(a, t, n, p, A) {
    if (a.length === 0) return -1;
    if (typeof n == "string" ? (p = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, Y(n) && (n = A ? 0 : a.length - 1), n < 0 && (n = a.length + n), n >= a.length) {
      if (A) return -1;
      n = a.length - 1;
    } else if (n < 0)
      if (A) n = 0;
      else return -1;
    if (typeof t == "string" && (t = l.from(t, p)), l.isBuffer(t))
      return t.length === 0 ? -1 : ce(a, t, n, p, A);
    if (typeof t == "number")
      return t = t & 255, typeof u.prototype.indexOf == "function" ? A ? u.prototype.indexOf.call(a, t, n) : u.prototype.lastIndexOf.call(a, t, n) : ce(a, [t], n, p, A);
    throw new TypeError("val must be string, number or Buffer");
  }
  function ce(a, t, n, p, A) {
    let F = 1, k = a.length, ne = t.length;
    if (p !== void 0 && (p = String(p).toLowerCase(), p === "ucs2" || p === "ucs-2" || p === "utf16le" || p === "utf-16le")) {
      if (a.length < 2 || t.length < 2)
        return -1;
      F = 2, k /= 2, ne /= 2, n /= 2;
    }
    function pe(Ee, ve) {
      return F === 1 ? Ee[ve] : Ee.readUInt16BE(ve * F);
    }
    let ye;
    if (A) {
      let Ee = -1;
      for (ye = n; ye < k; ye++)
        if (pe(a, ye) === pe(t, Ee === -1 ? 0 : ye - Ee)) {
          if (Ee === -1 && (Ee = ye), ye - Ee + 1 === ne) return Ee * F;
        } else
          Ee !== -1 && (ye -= ye - Ee), Ee = -1;
    } else
      for (n + ne > k && (n = k - ne), ye = n; ye >= 0; ye--) {
        let Ee = !0;
        for (let ve = 0; ve < ne; ve++)
          if (pe(a, ye + ve) !== pe(t, ve)) {
            Ee = !1;
            break;
          }
        if (Ee) return ye;
      }
    return -1;
  }
  l.prototype.includes = function(t, n, p) {
    return this.indexOf(t, n, p) !== -1;
  }, l.prototype.indexOf = function(t, n, p) {
    return z(this, t, n, p, !0);
  }, l.prototype.lastIndexOf = function(t, n, p) {
    return z(this, t, n, p, !1);
  };
  function de(a, t, n, p) {
    n = Number(n) || 0;
    const A = a.length - n;
    p ? (p = Number(p), p > A && (p = A)) : p = A;
    const F = t.length;
    p > F / 2 && (p = F / 2);
    let k;
    for (k = 0; k < p; ++k) {
      const ne = parseInt(t.substr(k * 2, 2), 16);
      if (Y(ne)) return k;
      a[n + k] = ne;
    }
    return k;
  }
  function ie(a, t, n, p) {
    return O(xe(t, a.length - n), a, n, p);
  }
  function he(a, t, n, p) {
    return O(Ie(t), a, n, p);
  }
  function Se(a, t, n, p) {
    return O(Te(t), a, n, p);
  }
  function Oe(a, t, n, p) {
    return O(Fe(t, a.length - n), a, n, p);
  }
  l.prototype.write = function(t, n, p, A) {
    if (n === void 0)
      A = "utf8", p = this.length, n = 0;
    else if (p === void 0 && typeof n == "string")
      A = n, p = this.length, n = 0;
    else if (isFinite(n))
      n = n >>> 0, isFinite(p) ? (p = p >>> 0, A === void 0 && (A = "utf8")) : (A = p, p = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const F = this.length - n;
    if ((p === void 0 || p > F) && (p = F), t.length > 0 && (p < 0 || n < 0) || n > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    A || (A = "utf8");
    let k = !1;
    for (; ; )
      switch (A) {
        case "hex":
          return de(this, t, n, p);
        case "utf8":
        case "utf-8":
          return ie(this, t, n, p);
        case "ascii":
        case "latin1":
        case "binary":
          return he(this, t, n, p);
        case "base64":
          return Se(this, t, n, p);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Oe(this, t, n, p);
        default:
          if (k) throw new TypeError("Unknown encoding: " + A);
          A = ("" + A).toLowerCase(), k = !0;
      }
  }, l.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function we(a, t, n) {
    return t === 0 && n === a.length ? r.fromByteArray(a) : r.fromByteArray(a.slice(t, n));
  }
  function _e(a, t, n) {
    n = Math.min(a.length, n);
    const p = [];
    let A = t;
    for (; A < n; ) {
      const F = a[A];
      let k = null, ne = F > 239 ? 4 : F > 223 ? 3 : F > 191 ? 2 : 1;
      if (A + ne <= n) {
        let pe, ye, Ee, ve;
        switch (ne) {
          case 1:
            F < 128 && (k = F);
            break;
          case 2:
            pe = a[A + 1], (pe & 192) === 128 && (ve = (F & 31) << 6 | pe & 63, ve > 127 && (k = ve));
            break;
          case 3:
            pe = a[A + 1], ye = a[A + 2], (pe & 192) === 128 && (ye & 192) === 128 && (ve = (F & 15) << 12 | (pe & 63) << 6 | ye & 63, ve > 2047 && (ve < 55296 || ve > 57343) && (k = ve));
            break;
          case 4:
            pe = a[A + 1], ye = a[A + 2], Ee = a[A + 3], (pe & 192) === 128 && (ye & 192) === 128 && (Ee & 192) === 128 && (ve = (F & 15) << 18 | (pe & 63) << 12 | (ye & 63) << 6 | Ee & 63, ve > 65535 && ve < 1114112 && (k = ve));
        }
      }
      k === null ? (k = 65533, ne = 1) : k > 65535 && (k -= 65536, p.push(k >>> 10 & 1023 | 55296), k = 56320 | k & 1023), p.push(k), A += ne;
    }
    return q(p);
  }
  const be = 4096;
  function q(a) {
    const t = a.length;
    if (t <= be)
      return String.fromCharCode.apply(String, a);
    let n = "", p = 0;
    for (; p < t; )
      n += String.fromCharCode.apply(
        String,
        a.slice(p, p += be)
      );
    return n;
  }
  function G(a, t, n) {
    let p = "";
    n = Math.min(a.length, n);
    for (let A = t; A < n; ++A)
      p += String.fromCharCode(a[A] & 127);
    return p;
  }
  function Q(a, t, n) {
    let p = "";
    n = Math.min(a.length, n);
    for (let A = t; A < n; ++A)
      p += String.fromCharCode(a[A]);
    return p;
  }
  function E(a, t, n) {
    const p = a.length;
    (!t || t < 0) && (t = 0), (!n || n < 0 || n > p) && (n = p);
    let A = "";
    for (let F = t; F < n; ++F)
      A += ee[a[F]];
    return A;
  }
  function I(a, t, n) {
    const p = a.slice(t, n);
    let A = "";
    for (let F = 0; F < p.length - 1; F += 2)
      A += String.fromCharCode(p[F] + p[F + 1] * 256);
    return A;
  }
  l.prototype.slice = function(t, n) {
    const p = this.length;
    t = ~~t, n = n === void 0 ? p : ~~n, t < 0 ? (t += p, t < 0 && (t = 0)) : t > p && (t = p), n < 0 ? (n += p, n < 0 && (n = 0)) : n > p && (n = p), n < t && (n = t);
    const A = this.subarray(t, n);
    return Object.setPrototypeOf(A, l.prototype), A;
  };
  function g(a, t, n) {
    if (a % 1 !== 0 || a < 0) throw new RangeError("offset is not uint");
    if (a + t > n) throw new RangeError("Trying to access beyond buffer length");
  }
  l.prototype.readUintLE = l.prototype.readUIntLE = function(t, n, p) {
    t = t >>> 0, n = n >>> 0, p || g(t, n, this.length);
    let A = this[t], F = 1, k = 0;
    for (; ++k < n && (F *= 256); )
      A += this[t + k] * F;
    return A;
  }, l.prototype.readUintBE = l.prototype.readUIntBE = function(t, n, p) {
    t = t >>> 0, n = n >>> 0, p || g(t, n, this.length);
    let A = this[t + --n], F = 1;
    for (; n > 0 && (F *= 256); )
      A += this[t + --n] * F;
    return A;
  }, l.prototype.readUint8 = l.prototype.readUInt8 = function(t, n) {
    return t = t >>> 0, n || g(t, 1, this.length), this[t];
  }, l.prototype.readUint16LE = l.prototype.readUInt16LE = function(t, n) {
    return t = t >>> 0, n || g(t, 2, this.length), this[t] | this[t + 1] << 8;
  }, l.prototype.readUint16BE = l.prototype.readUInt16BE = function(t, n) {
    return t = t >>> 0, n || g(t, 2, this.length), this[t] << 8 | this[t + 1];
  }, l.prototype.readUint32LE = l.prototype.readUInt32LE = function(t, n) {
    return t = t >>> 0, n || g(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + this[t + 3] * 16777216;
  }, l.prototype.readUint32BE = l.prototype.readUInt32BE = function(t, n) {
    return t = t >>> 0, n || g(t, 4, this.length), this[t] * 16777216 + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
  }, l.prototype.readBigUInt64LE = K(function(t) {
    t = t >>> 0, te(t, "offset");
    const n = this[t], p = this[t + 7];
    (n === void 0 || p === void 0) && oe(t, this.length - 8);
    const A = n + this[++t] * 2 ** 8 + this[++t] * 2 ** 16 + this[++t] * 2 ** 24, F = this[++t] + this[++t] * 2 ** 8 + this[++t] * 2 ** 16 + p * 2 ** 24;
    return BigInt(A) + (BigInt(F) << BigInt(32));
  }), l.prototype.readBigUInt64BE = K(function(t) {
    t = t >>> 0, te(t, "offset");
    const n = this[t], p = this[t + 7];
    (n === void 0 || p === void 0) && oe(t, this.length - 8);
    const A = n * 2 ** 24 + this[++t] * 2 ** 16 + this[++t] * 2 ** 8 + this[++t], F = this[++t] * 2 ** 24 + this[++t] * 2 ** 16 + this[++t] * 2 ** 8 + p;
    return (BigInt(A) << BigInt(32)) + BigInt(F);
  }), l.prototype.readIntLE = function(t, n, p) {
    t = t >>> 0, n = n >>> 0, p || g(t, n, this.length);
    let A = this[t], F = 1, k = 0;
    for (; ++k < n && (F *= 256); )
      A += this[t + k] * F;
    return F *= 128, A >= F && (A -= Math.pow(2, 8 * n)), A;
  }, l.prototype.readIntBE = function(t, n, p) {
    t = t >>> 0, n = n >>> 0, p || g(t, n, this.length);
    let A = n, F = 1, k = this[t + --A];
    for (; A > 0 && (F *= 256); )
      k += this[t + --A] * F;
    return F *= 128, k >= F && (k -= Math.pow(2, 8 * n)), k;
  }, l.prototype.readInt8 = function(t, n) {
    return t = t >>> 0, n || g(t, 1, this.length), this[t] & 128 ? (255 - this[t] + 1) * -1 : this[t];
  }, l.prototype.readInt16LE = function(t, n) {
    t = t >>> 0, n || g(t, 2, this.length);
    const p = this[t] | this[t + 1] << 8;
    return p & 32768 ? p | 4294901760 : p;
  }, l.prototype.readInt16BE = function(t, n) {
    t = t >>> 0, n || g(t, 2, this.length);
    const p = this[t + 1] | this[t] << 8;
    return p & 32768 ? p | 4294901760 : p;
  }, l.prototype.readInt32LE = function(t, n) {
    return t = t >>> 0, n || g(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
  }, l.prototype.readInt32BE = function(t, n) {
    return t = t >>> 0, n || g(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
  }, l.prototype.readBigInt64LE = K(function(t) {
    t = t >>> 0, te(t, "offset");
    const n = this[t], p = this[t + 7];
    (n === void 0 || p === void 0) && oe(t, this.length - 8);
    const A = this[t + 4] + this[t + 5] * 2 ** 8 + this[t + 6] * 2 ** 16 + (p << 24);
    return (BigInt(A) << BigInt(32)) + BigInt(n + this[++t] * 2 ** 8 + this[++t] * 2 ** 16 + this[++t] * 2 ** 24);
  }), l.prototype.readBigInt64BE = K(function(t) {
    t = t >>> 0, te(t, "offset");
    const n = this[t], p = this[t + 7];
    (n === void 0 || p === void 0) && oe(t, this.length - 8);
    const A = (n << 24) + // Overflow
    this[++t] * 2 ** 16 + this[++t] * 2 ** 8 + this[++t];
    return (BigInt(A) << BigInt(32)) + BigInt(this[++t] * 2 ** 24 + this[++t] * 2 ** 16 + this[++t] * 2 ** 8 + p);
  }), l.prototype.readFloatLE = function(t, n) {
    return t = t >>> 0, n || g(t, 4, this.length), i.read(this, t, !0, 23, 4);
  }, l.prototype.readFloatBE = function(t, n) {
    return t = t >>> 0, n || g(t, 4, this.length), i.read(this, t, !1, 23, 4);
  }, l.prototype.readDoubleLE = function(t, n) {
    return t = t >>> 0, n || g(t, 8, this.length), i.read(this, t, !0, 52, 8);
  }, l.prototype.readDoubleBE = function(t, n) {
    return t = t >>> 0, n || g(t, 8, this.length), i.read(this, t, !1, 52, 8);
  };
  function _(a, t, n, p, A, F) {
    if (!l.isBuffer(a)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (t > A || t < F) throw new RangeError('"value" argument is out of bounds');
    if (n + p > a.length) throw new RangeError("Index out of range");
  }
  l.prototype.writeUintLE = l.prototype.writeUIntLE = function(t, n, p, A) {
    if (t = +t, n = n >>> 0, p = p >>> 0, !A) {
      const ne = Math.pow(2, 8 * p) - 1;
      _(this, t, n, p, ne, 0);
    }
    let F = 1, k = 0;
    for (this[n] = t & 255; ++k < p && (F *= 256); )
      this[n + k] = t / F & 255;
    return n + p;
  }, l.prototype.writeUintBE = l.prototype.writeUIntBE = function(t, n, p, A) {
    if (t = +t, n = n >>> 0, p = p >>> 0, !A) {
      const ne = Math.pow(2, 8 * p) - 1;
      _(this, t, n, p, ne, 0);
    }
    let F = p - 1, k = 1;
    for (this[n + F] = t & 255; --F >= 0 && (k *= 256); )
      this[n + F] = t / k & 255;
    return n + p;
  }, l.prototype.writeUint8 = l.prototype.writeUInt8 = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 1, 255, 0), this[n] = t & 255, n + 1;
  }, l.prototype.writeUint16LE = l.prototype.writeUInt16LE = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 2, 65535, 0), this[n] = t & 255, this[n + 1] = t >>> 8, n + 2;
  }, l.prototype.writeUint16BE = l.prototype.writeUInt16BE = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 2, 65535, 0), this[n] = t >>> 8, this[n + 1] = t & 255, n + 2;
  }, l.prototype.writeUint32LE = l.prototype.writeUInt32LE = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 4, 4294967295, 0), this[n + 3] = t >>> 24, this[n + 2] = t >>> 16, this[n + 1] = t >>> 8, this[n] = t & 255, n + 4;
  }, l.prototype.writeUint32BE = l.prototype.writeUInt32BE = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 4, 4294967295, 0), this[n] = t >>> 24, this[n + 1] = t >>> 16, this[n + 2] = t >>> 8, this[n + 3] = t & 255, n + 4;
  };
  function f(a, t, n, p, A) {
    ue(t, p, A, a, n, 7);
    let F = Number(t & BigInt(4294967295));
    a[n++] = F, F = F >> 8, a[n++] = F, F = F >> 8, a[n++] = F, F = F >> 8, a[n++] = F;
    let k = Number(t >> BigInt(32) & BigInt(4294967295));
    return a[n++] = k, k = k >> 8, a[n++] = k, k = k >> 8, a[n++] = k, k = k >> 8, a[n++] = k, n;
  }
  function d(a, t, n, p, A) {
    ue(t, p, A, a, n, 7);
    let F = Number(t & BigInt(4294967295));
    a[n + 7] = F, F = F >> 8, a[n + 6] = F, F = F >> 8, a[n + 5] = F, F = F >> 8, a[n + 4] = F;
    let k = Number(t >> BigInt(32) & BigInt(4294967295));
    return a[n + 3] = k, k = k >> 8, a[n + 2] = k, k = k >> 8, a[n + 1] = k, k = k >> 8, a[n] = k, n + 8;
  }
  l.prototype.writeBigUInt64LE = K(function(t, n = 0) {
    return f(this, t, n, BigInt(0), BigInt("0xffffffffffffffff"));
  }), l.prototype.writeBigUInt64BE = K(function(t, n = 0) {
    return d(this, t, n, BigInt(0), BigInt("0xffffffffffffffff"));
  }), l.prototype.writeIntLE = function(t, n, p, A) {
    if (t = +t, n = n >>> 0, !A) {
      const pe = Math.pow(2, 8 * p - 1);
      _(this, t, n, p, pe - 1, -pe);
    }
    let F = 0, k = 1, ne = 0;
    for (this[n] = t & 255; ++F < p && (k *= 256); )
      t < 0 && ne === 0 && this[n + F - 1] !== 0 && (ne = 1), this[n + F] = (t / k >> 0) - ne & 255;
    return n + p;
  }, l.prototype.writeIntBE = function(t, n, p, A) {
    if (t = +t, n = n >>> 0, !A) {
      const pe = Math.pow(2, 8 * p - 1);
      _(this, t, n, p, pe - 1, -pe);
    }
    let F = p - 1, k = 1, ne = 0;
    for (this[n + F] = t & 255; --F >= 0 && (k *= 256); )
      t < 0 && ne === 0 && this[n + F + 1] !== 0 && (ne = 1), this[n + F] = (t / k >> 0) - ne & 255;
    return n + p;
  }, l.prototype.writeInt8 = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 1, 127, -128), t < 0 && (t = 255 + t + 1), this[n] = t & 255, n + 1;
  }, l.prototype.writeInt16LE = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 2, 32767, -32768), this[n] = t & 255, this[n + 1] = t >>> 8, n + 2;
  }, l.prototype.writeInt16BE = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 2, 32767, -32768), this[n] = t >>> 8, this[n + 1] = t & 255, n + 2;
  }, l.prototype.writeInt32LE = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 4, 2147483647, -2147483648), this[n] = t & 255, this[n + 1] = t >>> 8, this[n + 2] = t >>> 16, this[n + 3] = t >>> 24, n + 4;
  }, l.prototype.writeInt32BE = function(t, n, p) {
    return t = +t, n = n >>> 0, p || _(this, t, n, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), this[n] = t >>> 24, this[n + 1] = t >>> 16, this[n + 2] = t >>> 8, this[n + 3] = t & 255, n + 4;
  }, l.prototype.writeBigInt64LE = K(function(t, n = 0) {
    return f(this, t, n, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), l.prototype.writeBigInt64BE = K(function(t, n = 0) {
    return d(this, t, n, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function S(a, t, n, p, A, F) {
    if (n + p > a.length) throw new RangeError("Index out of range");
    if (n < 0) throw new RangeError("Index out of range");
  }
  function B(a, t, n, p, A) {
    return t = +t, n = n >>> 0, A || S(a, t, n, 4), i.write(a, t, n, p, 23, 4), n + 4;
  }
  l.prototype.writeFloatLE = function(t, n, p) {
    return B(this, t, n, !0, p);
  }, l.prototype.writeFloatBE = function(t, n, p) {
    return B(this, t, n, !1, p);
  };
  function U(a, t, n, p, A) {
    return t = +t, n = n >>> 0, A || S(a, t, n, 8), i.write(a, t, n, p, 52, 8), n + 8;
  }
  l.prototype.writeDoubleLE = function(t, n, p) {
    return U(this, t, n, !0, p);
  }, l.prototype.writeDoubleBE = function(t, n, p) {
    return U(this, t, n, !1, p);
  }, l.prototype.copy = function(t, n, p, A) {
    if (!l.isBuffer(t)) throw new TypeError("argument should be a Buffer");
    if (p || (p = 0), !A && A !== 0 && (A = this.length), n >= t.length && (n = t.length), n || (n = 0), A > 0 && A < p && (A = p), A === p || t.length === 0 || this.length === 0) return 0;
    if (n < 0)
      throw new RangeError("targetStart out of bounds");
    if (p < 0 || p >= this.length) throw new RangeError("Index out of range");
    if (A < 0) throw new RangeError("sourceEnd out of bounds");
    A > this.length && (A = this.length), t.length - n < A - p && (A = t.length - n + p);
    const F = A - p;
    return this === t && typeof u.prototype.copyWithin == "function" ? this.copyWithin(n, p, A) : u.prototype.set.call(
      t,
      this.subarray(p, A),
      n
    ), F;
  }, l.prototype.fill = function(t, n, p, A) {
    if (typeof t == "string") {
      if (typeof n == "string" ? (A = n, n = 0, p = this.length) : typeof p == "string" && (A = p, p = this.length), A !== void 0 && typeof A != "string")
        throw new TypeError("encoding must be a string");
      if (typeof A == "string" && !l.isEncoding(A))
        throw new TypeError("Unknown encoding: " + A);
      if (t.length === 1) {
        const k = t.charCodeAt(0);
        (A === "utf8" && k < 128 || A === "latin1") && (t = k);
      }
    } else typeof t == "number" ? t = t & 255 : typeof t == "boolean" && (t = Number(t));
    if (n < 0 || this.length < n || this.length < p)
      throw new RangeError("Out of range index");
    if (p <= n)
      return this;
    n = n >>> 0, p = p === void 0 ? this.length : p >>> 0, t || (t = 0);
    let F;
    if (typeof t == "number")
      for (F = n; F < p; ++F)
        this[F] = t;
    else {
      const k = l.isBuffer(t) ? t : l.from(t, A), ne = k.length;
      if (ne === 0)
        throw new TypeError('The value "' + t + '" is invalid for argument "value"');
      for (F = 0; F < p - n; ++F)
        this[F + n] = k[F % ne];
    }
    return this;
  };
  const s = {};
  function y(a, t, n) {
    s[a] = class extends n {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: t.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${a}]`, this.stack, delete this.name;
      }
      get code() {
        return a;
      }
      set code(A) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: A,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${a}]: ${this.message}`;
      }
    };
  }
  y(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(a) {
      return a ? `${a} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), y(
    "ERR_INVALID_ARG_TYPE",
    function(a, t) {
      return `The "${a}" argument must be of type number. Received type ${typeof t}`;
    },
    TypeError
  ), y(
    "ERR_OUT_OF_RANGE",
    function(a, t, n) {
      let p = `The value of "${a}" is out of range.`, A = n;
      return Number.isInteger(n) && Math.abs(n) > 2 ** 32 ? A = D(String(n)) : typeof n == "bigint" && (A = String(n), (n > BigInt(2) ** BigInt(32) || n < -(BigInt(2) ** BigInt(32))) && (A = D(A)), A += "n"), p += ` It must be ${t}. Received ${A}`, p;
    },
    RangeError
  );
  function D(a) {
    let t = "", n = a.length;
    const p = a[0] === "-" ? 1 : 0;
    for (; n >= p + 4; n -= 3)
      t = `_${a.slice(n - 3, n)}${t}`;
    return `${a.slice(0, n)}${t}`;
  }
  function H(a, t, n) {
    te(t, "offset"), (a[t] === void 0 || a[t + n] === void 0) && oe(t, a.length - (n + 1));
  }
  function ue(a, t, n, p, A, F) {
    if (a > n || a < t) {
      const k = typeof t == "bigint" ? "n" : "";
      let ne;
      throw t === 0 || t === BigInt(0) ? ne = `>= 0${k} and < 2${k} ** ${(F + 1) * 8}${k}` : ne = `>= -(2${k} ** ${(F + 1) * 8 - 1}${k}) and < 2 ** ${(F + 1) * 8 - 1}${k}`, new s.ERR_OUT_OF_RANGE("value", ne, a);
    }
    H(p, A, F);
  }
  function te(a, t) {
    if (typeof a != "number")
      throw new s.ERR_INVALID_ARG_TYPE(t, "number", a);
  }
  function oe(a, t, n) {
    throw Math.floor(a) !== a ? (te(a, n), new s.ERR_OUT_OF_RANGE("offset", "an integer", a)) : t < 0 ? new s.ERR_BUFFER_OUT_OF_BOUNDS() : new s.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${t}`,
      a
    );
  }
  const me = /[^+/0-9A-Za-z-_]/g;
  function C(a) {
    if (a = a.split("=")[0], a = a.trim().replace(me, ""), a.length < 2) return "";
    for (; a.length % 4 !== 0; )
      a = a + "=";
    return a;
  }
  function xe(a, t) {
    t = t || 1 / 0;
    let n;
    const p = a.length;
    let A = null;
    const F = [];
    for (let k = 0; k < p; ++k) {
      if (n = a.charCodeAt(k), n > 55295 && n < 57344) {
        if (!A) {
          if (n > 56319) {
            (t -= 3) > -1 && F.push(239, 191, 189);
            continue;
          } else if (k + 1 === p) {
            (t -= 3) > -1 && F.push(239, 191, 189);
            continue;
          }
          A = n;
          continue;
        }
        if (n < 56320) {
          (t -= 3) > -1 && F.push(239, 191, 189), A = n;
          continue;
        }
        n = (A - 55296 << 10 | n - 56320) + 65536;
      } else A && (t -= 3) > -1 && F.push(239, 191, 189);
      if (A = null, n < 128) {
        if ((t -= 1) < 0) break;
        F.push(n);
      } else if (n < 2048) {
        if ((t -= 2) < 0) break;
        F.push(
          n >> 6 | 192,
          n & 63 | 128
        );
      } else if (n < 65536) {
        if ((t -= 3) < 0) break;
        F.push(
          n >> 12 | 224,
          n >> 6 & 63 | 128,
          n & 63 | 128
        );
      } else if (n < 1114112) {
        if ((t -= 4) < 0) break;
        F.push(
          n >> 18 | 240,
          n >> 12 & 63 | 128,
          n >> 6 & 63 | 128,
          n & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return F;
  }
  function Ie(a) {
    const t = [];
    for (let n = 0; n < a.length; ++n)
      t.push(a.charCodeAt(n) & 255);
    return t;
  }
  function Fe(a, t) {
    let n, p, A;
    const F = [];
    for (let k = 0; k < a.length && !((t -= 2) < 0); ++k)
      n = a.charCodeAt(k), p = n >> 8, A = n % 256, F.push(A), F.push(p);
    return F;
  }
  function Te(a) {
    return r.toByteArray(C(a));
  }
  function O(a, t, n, p) {
    let A;
    for (A = 0; A < p && !(A + n >= t.length || A >= a.length); ++A)
      t[A + n] = a[A];
    return A;
  }
  function T(a, t) {
    return a instanceof t || a != null && a.constructor != null && a.constructor.name != null && a.constructor.name === t.name;
  }
  function Y(a) {
    return a !== a;
  }
  const ee = function() {
    const a = "0123456789abcdef", t = new Array(256);
    for (let n = 0; n < 16; ++n) {
      const p = n * 16;
      for (let A = 0; A < 16; ++A)
        t[p + A] = a[n] + a[A];
    }
    return t;
  }();
  function K(a) {
    return typeof BigInt > "u" ? ae : a;
  }
  function ae() {
    throw new Error("BigInt not supported");
  }
})(Pe);
const Qr = Pe.Buffer, No = Pe.Blob, Mo = Pe.BlobOptions, Lo = Pe.Buffer, Do = Pe.File, Uo = Pe.FileOptions, $o = Pe.INSPECT_MAX_BYTES, ko = Pe.SlowBuffer, Co = Pe.TranscodeEncoding, qo = Pe.atob, Wo = Pe.btoa, Go = Pe.constants, Vo = Pe.isAscii, Ho = Pe.isUtf8, zo = Pe.kMaxLength, Yo = Pe.kStringMaxLength, Jo = Pe.resolveObjectURL, Xo = Pe.transcode, Ko = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: No,
  BlobOptions: Mo,
  Buffer: Lo,
  File: Do,
  FileOptions: Uo,
  INSPECT_MAX_BYTES: $o,
  SlowBuffer: ko,
  TranscodeEncoding: Co,
  atob: qo,
  btoa: Wo,
  constants: Go,
  default: Qr,
  isAscii: Vo,
  isUtf8: Ho,
  kMaxLength: zo,
  kStringMaxLength: Yo,
  resolveObjectURL: Jo,
  transcode: Xo
}, Symbol.toStringTag, { value: "Module" })), kt = /* @__PURE__ */ Eo(Ko);
var Xt = { exports: {} }, Kt = {}, Le = {}, _i = {}, Ct = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var r = {}, i = Symbol("test"), o = Object(i);
  if (typeof i == "string" || Object.prototype.toString.call(i) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
    return !1;
  var c = 42;
  r[i] = c;
  for (i in r)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(r).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(r).length !== 0)
    return !1;
  var u = Object.getOwnPropertySymbols(r);
  if (u.length !== 1 || u[0] !== i || !Object.prototype.propertyIsEnumerable.call(r, i))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var h = Object.getOwnPropertyDescriptor(r, i);
    if (h.value !== c || h.enumerable !== !0)
      return !1;
  }
  return !0;
}, Zo = Ct, Ai = function() {
  return Zo() && !!Symbol.toStringTag;
}, vn = typeof Symbol < "u" && Symbol, Qo = Ct, Ri = function() {
  return typeof vn != "function" || typeof Symbol != "function" || typeof vn("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Qo();
}, ea = "Function.prototype.bind called on incompatible ", Zt = Array.prototype.slice, ta = Object.prototype.toString, ra = "[object Function]", na = function(r) {
  var i = this;
  if (typeof i != "function" || ta.call(i) !== ra)
    throw new TypeError(ea + i);
  for (var o = Zt.call(arguments, 1), c, u = function() {
    if (this instanceof c) {
      var l = i.apply(
        this,
        o.concat(Zt.call(arguments))
      );
      return Object(l) === l ? l : this;
    } else
      return i.apply(
        r,
        o.concat(Zt.call(arguments))
      );
  }, h = Math.max(0, i.length - o.length), v = [], b = 0; b < h; b++)
    v.push("$" + b);
  if (c = Function("binder", "return function (" + v.join(",") + "){ return binder.apply(this,arguments); }")(u), i.prototype) {
    var R = function() {
    };
    R.prototype = i.prototype, c.prototype = new R(), R.prototype = null;
  }
  return c;
}, ia = na, en = Function.prototype.bind || ia, oa = en, aa = oa.call(Function.call, Object.prototype.hasOwnProperty), se, lt = SyntaxError, Oi = Function, ut = TypeError, Qt = function(e) {
  try {
    return Oi('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, Ye = Object.getOwnPropertyDescriptor;
if (Ye)
  try {
    Ye({}, "");
  } catch {
    Ye = null;
  }
var er = function() {
  throw new ut();
}, ua = Ye ? function() {
  try {
    return arguments.callee, er;
  } catch {
    try {
      return Ye(arguments, "callee").get;
    } catch {
      return er;
    }
  }
}() : er, Qe = Ri(), Ge = Object.getPrototypeOf || function(e) {
  return e.__proto__;
}, nt = {}, fa = typeof Uint8Array > "u" ? se : Ge(Uint8Array), ft = {
  "%AggregateError%": typeof AggregateError > "u" ? se : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? se : ArrayBuffer,
  "%ArrayIteratorPrototype%": Qe ? Ge([][Symbol.iterator]()) : se,
  "%AsyncFromSyncIteratorPrototype%": se,
  "%AsyncFunction%": nt,
  "%AsyncGenerator%": nt,
  "%AsyncGeneratorFunction%": nt,
  "%AsyncIteratorPrototype%": nt,
  "%Atomics%": typeof Atomics > "u" ? se : Atomics,
  "%BigInt%": typeof BigInt > "u" ? se : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? se : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? se : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? se : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? se : FinalizationRegistry,
  "%Function%": Oi,
  "%GeneratorFunction%": nt,
  "%Int8Array%": typeof Int8Array > "u" ? se : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? se : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? se : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": Qe ? Ge(Ge([][Symbol.iterator]())) : se,
  "%JSON%": typeof JSON == "object" ? JSON : se,
  "%Map%": typeof Map > "u" ? se : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !Qe ? se : Ge((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? se : Promise,
  "%Proxy%": typeof Proxy > "u" ? se : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? se : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? se : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !Qe ? se : Ge((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? se : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": Qe ? Ge(""[Symbol.iterator]()) : se,
  "%Symbol%": Qe ? Symbol : se,
  "%SyntaxError%": lt,
  "%ThrowTypeError%": ua,
  "%TypedArray%": fa,
  "%TypeError%": ut,
  "%Uint8Array%": typeof Uint8Array > "u" ? se : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? se : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? se : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? se : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? se : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? se : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? se : WeakSet
}, sa = function e(r) {
  var i;
  if (r === "%AsyncFunction%")
    i = Qt("async function () {}");
  else if (r === "%GeneratorFunction%")
    i = Qt("function* () {}");
  else if (r === "%AsyncGeneratorFunction%")
    i = Qt("async function* () {}");
  else if (r === "%AsyncGenerator%") {
    var o = e("%AsyncGeneratorFunction%");
    o && (i = o.prototype);
  } else if (r === "%AsyncIteratorPrototype%") {
    var c = e("%AsyncGenerator%");
    c && (i = Ge(c.prototype));
  }
  return ft[r] = i, i;
}, bn = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, wt = en, xt = aa, ca = wt.call(Function.call, Array.prototype.concat), la = wt.call(Function.apply, Array.prototype.splice), mn = wt.call(Function.call, String.prototype.replace), Ft = wt.call(Function.call, String.prototype.slice), pa = wt.call(Function.call, RegExp.prototype.exec), ha = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ya = /\\(\\)?/g, da = function(r) {
  var i = Ft(r, 0, 1), o = Ft(r, -1);
  if (i === "%" && o !== "%")
    throw new lt("invalid intrinsic syntax, expected closing `%`");
  if (o === "%" && i !== "%")
    throw new lt("invalid intrinsic syntax, expected opening `%`");
  var c = [];
  return mn(r, ha, function(u, h, v, b) {
    c[c.length] = v ? mn(b, ya, "$1") : h || u;
  }), c;
}, ga = function(r, i) {
  var o = r, c;
  if (xt(bn, o) && (c = bn[o], o = "%" + c[0] + "%"), xt(ft, o)) {
    var u = ft[o];
    if (u === nt && (u = sa(o)), typeof u > "u" && !i)
      throw new ut("intrinsic " + r + " exists, but is not available. Please file an issue!");
    return {
      alias: c,
      name: o,
      value: u
    };
  }
  throw new lt("intrinsic " + r + " does not exist!");
}, tn = function(r, i) {
  if (typeof r != "string" || r.length === 0)
    throw new ut("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof i != "boolean")
    throw new ut('"allowMissing" argument must be a boolean');
  if (pa(/^%?[^%]*%?$/g, r) === null)
    throw new lt("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var o = da(r), c = o.length > 0 ? o[0] : "", u = ga("%" + c + "%", i), h = u.name, v = u.value, b = !1, R = u.alias;
  R && (c = R[0], la(o, ca([0, 1], R)));
  for (var l = 1, x = !0; l < o.length; l += 1) {
    var P = o[l], N = Ft(P, 0, 1), L = Ft(P, -1);
    if ((N === '"' || N === "'" || N === "`" || L === '"' || L === "'" || L === "`") && N !== L)
      throw new lt("property names with quotes must have matching quotes");
    if ((P === "constructor" || !x) && (b = !0), c += "." + P, h = "%" + c + "%", xt(ft, h))
      v = ft[h];
    else if (v != null) {
      if (!(P in v)) {
        if (!i)
          throw new ut("base intrinsic for " + r + " exists, but the property is not available.");
        return;
      }
      if (Ye && l + 1 >= o.length) {
        var V = Ye(v, P);
        x = !!V, x && "get" in V && !("originalValue" in V.get) ? v = V.get : v = v[P];
      } else
        x = xt(v, P), v = v[P];
      x && !b && (ft[h] = v);
    }
  }
  return v;
}, Pi = { exports: {} };
(function(e) {
  var r = en, i = tn, o = i("%Function.prototype.apply%"), c = i("%Function.prototype.call%"), u = i("%Reflect.apply%", !0) || r.call(c, o), h = i("%Object.getOwnPropertyDescriptor%", !0), v = i("%Object.defineProperty%", !0), b = i("%Math.max%");
  if (v)
    try {
      v({}, "a", { value: 1 });
    } catch {
      v = null;
    }
  e.exports = function(x) {
    var P = u(r, c, arguments);
    if (h && v) {
      var N = h(P, "length");
      N.configurable && v(
        P,
        "length",
        { value: 1 + b(0, x.length - (arguments.length - 1)) }
      );
    }
    return P;
  };
  var R = function() {
    return u(r, o, arguments);
  };
  v ? v(e.exports, "apply", { value: R }) : e.exports.apply = R;
})(Pi);
var ji = Pi.exports, Ii = tn, Ti = ji, va = Ti(Ii("String.prototype.indexOf")), Bi = function(r, i) {
  var o = Ii(r, !!i);
  return typeof o == "function" && va(r, ".prototype.") > -1 ? Ti(o) : o;
}, ba = Ai(), ma = Bi, Vr = ma("Object.prototype.toString"), qt = function(r) {
  return ba && r && typeof r == "object" && Symbol.toStringTag in r ? !1 : Vr(r) === "[object Arguments]";
}, xi = function(r) {
  return qt(r) ? !0 : r !== null && typeof r == "object" && typeof r.length == "number" && r.length >= 0 && Vr(r) !== "[object Array]" && Vr(r.callee) === "[object Function]";
}, wa = function() {
  return qt(arguments);
}();
qt.isLegacyArguments = xi;
var Ea = wa ? qt : xi, Sa = Object.prototype.toString, _a = Function.prototype.toString, Aa = /^\s*(?:function)?\*/, Fi = Ai(), tr = Object.getPrototypeOf, Ra = function() {
  if (!Fi)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, rr, Oa = function(r) {
  if (typeof r != "function")
    return !1;
  if (Aa.test(_a.call(r)))
    return !0;
  if (!Fi) {
    var i = Sa.call(r);
    return i === "[object GeneratorFunction]";
  }
  if (!tr)
    return !1;
  if (typeof rr > "u") {
    var o = Ra();
    rr = o ? tr(o) : !1;
  }
  return tr(r) === rr;
}, Ni = Function.prototype.toString, ot = typeof Reflect == "object" && Reflect !== null && Reflect.apply, Hr, Rt;
if (typeof ot == "function" && typeof Object.defineProperty == "function")
  try {
    Hr = Object.defineProperty({}, "length", {
      get: function() {
        throw Rt;
      }
    }), Rt = {}, ot(function() {
      throw 42;
    }, null, Hr);
  } catch (e) {
    e !== Rt && (ot = null);
  }
else
  ot = null;
var Pa = /^\s*class\b/, zr = function(r) {
  try {
    var i = Ni.call(r);
    return Pa.test(i);
  } catch {
    return !1;
  }
}, nr = function(r) {
  try {
    return zr(r) ? !1 : (Ni.call(r), !0);
  } catch {
    return !1;
  }
}, Ot = Object.prototype.toString, ja = "[object Object]", Ia = "[object Function]", Ta = "[object GeneratorFunction]", Ba = "[object HTMLAllCollection]", xa = "[object HTML document.all class]", Fa = "[object HTMLCollection]", Na = typeof Symbol == "function" && !!Symbol.toStringTag, Ma = !(0 in [,]), Yr = function() {
  return !1;
};
if (typeof document == "object") {
  var La = document.all;
  Ot.call(La) === Ot.call(document.all) && (Yr = function(r) {
    if ((Ma || !r) && (typeof r > "u" || typeof r == "object"))
      try {
        var i = Ot.call(r);
        return (i === Ba || i === xa || i === Fa || i === ja) && r("") == null;
      } catch {
      }
    return !1;
  });
}
var Da = ot ? function(r) {
  if (Yr(r))
    return !0;
  if (!r || typeof r != "function" && typeof r != "object")
    return !1;
  try {
    ot(r, null, Hr);
  } catch (i) {
    if (i !== Rt)
      return !1;
  }
  return !zr(r) && nr(r);
} : function(r) {
  if (Yr(r))
    return !0;
  if (!r || typeof r != "function" && typeof r != "object")
    return !1;
  if (Na)
    return nr(r);
  if (zr(r))
    return !1;
  var i = Ot.call(r);
  return i !== Ia && i !== Ta && !/^\[object HTML/.test(i) ? !1 : nr(r);
}, Ua = Da, $a = Object.prototype.toString, Mi = Object.prototype.hasOwnProperty, ka = function(r, i, o) {
  for (var c = 0, u = r.length; c < u; c++)
    Mi.call(r, c) && (o == null ? i(r[c], c, r) : i.call(o, r[c], c, r));
}, Ca = function(r, i, o) {
  for (var c = 0, u = r.length; c < u; c++)
    o == null ? i(r.charAt(c), c, r) : i.call(o, r.charAt(c), c, r);
}, qa = function(r, i, o) {
  for (var c in r)
    Mi.call(r, c) && (o == null ? i(r[c], c, r) : i.call(o, r[c], c, r));
}, Wa = function(r, i, o) {
  if (!Ua(i))
    throw new TypeError("iterator must be a function");
  var c;
  arguments.length >= 3 && (c = o), $a.call(r) === "[object Array]" ? ka(r, i, c) : typeof r == "string" ? Ca(r, i, c) : qa(r, i, c);
}, Ga = Wa, Va = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], ir = Va, Ha = typeof globalThis > "u" ? He : globalThis, za = function() {
  for (var r = [], i = 0; i < ir.length; i++)
    typeof Ha[ir[i]] == "function" && (r[r.length] = ir[i]);
  return r;
}, Li = { exports: {} }, Ya = "Function.prototype.bind called on incompatible ", Ja = Object.prototype.toString, Xa = Math.max, Ka = "[object Function]", wn = function(r, i) {
  for (var o = [], c = 0; c < r.length; c += 1)
    o[c] = r[c];
  for (var u = 0; u < i.length; u += 1)
    o[u + r.length] = i[u];
  return o;
}, Za = function(r, i) {
  for (var o = [], c = i, u = 0; c < r.length; c += 1, u += 1)
    o[u] = r[c];
  return o;
}, Qa = function(e, r) {
  for (var i = "", o = 0; o < e.length; o += 1)
    i += e[o], o + 1 < e.length && (i += r);
  return i;
}, eu = function(r) {
  var i = this;
  if (typeof i != "function" || Ja.apply(i) !== Ka)
    throw new TypeError(Ya + i);
  for (var o = Za(arguments, 1), c, u = function() {
    if (this instanceof c) {
      var l = i.apply(
        this,
        wn(o, arguments)
      );
      return Object(l) === l ? l : this;
    }
    return i.apply(
      r,
      wn(o, arguments)
    );
  }, h = Xa(0, i.length - o.length), v = [], b = 0; b < h; b++)
    v[b] = "$" + b;
  if (c = Function("binder", "return function (" + Qa(v, ",") + "){ return binder.apply(this,arguments); }")(u), i.prototype) {
    var R = function() {
    };
    R.prototype = i.prototype, c.prototype = new R(), R.prototype = null;
  }
  return c;
}, tu = eu, rn = Function.prototype.bind || tu, ru = Error, nu = EvalError, iu = RangeError, ou = ReferenceError, Di = SyntaxError, Wt = TypeError, au = URIError, or = {
  __proto__: null,
  foo: {}
}, uu = Object, fu = function() {
  return { __proto__: or }.foo === or.foo && !(or instanceof uu);
}, su = Function.prototype.call, cu = Object.prototype.hasOwnProperty, lu = rn, pu = lu.call(su, cu), fe, hu = ru, yu = nu, du = iu, gu = ou, pt = Di, st = Wt, vu = au, Ui = Function, ar = function(e) {
  try {
    return Ui('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, Je = Object.getOwnPropertyDescriptor;
if (Je)
  try {
    Je({}, "");
  } catch {
    Je = null;
  }
var ur = function() {
  throw new st();
}, bu = Je ? function() {
  try {
    return arguments.callee, ur;
  } catch {
    try {
      return Je(arguments, "callee").get;
    } catch {
      return ur;
    }
  }
}() : ur, et = Ri(), mu = fu(), je = Object.getPrototypeOf || (mu ? function(e) {
  return e.__proto__;
} : null), it = {}, wu = typeof Uint8Array > "u" || !je ? fe : je(Uint8Array), Xe = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? fe : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? fe : ArrayBuffer,
  "%ArrayIteratorPrototype%": et && je ? je([][Symbol.iterator]()) : fe,
  "%AsyncFromSyncIteratorPrototype%": fe,
  "%AsyncFunction%": it,
  "%AsyncGenerator%": it,
  "%AsyncGeneratorFunction%": it,
  "%AsyncIteratorPrototype%": it,
  "%Atomics%": typeof Atomics > "u" ? fe : Atomics,
  "%BigInt%": typeof BigInt > "u" ? fe : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? fe : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? fe : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? fe : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": hu,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": yu,
  "%Float32Array%": typeof Float32Array > "u" ? fe : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? fe : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? fe : FinalizationRegistry,
  "%Function%": Ui,
  "%GeneratorFunction%": it,
  "%Int8Array%": typeof Int8Array > "u" ? fe : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? fe : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? fe : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": et && je ? je(je([][Symbol.iterator]())) : fe,
  "%JSON%": typeof JSON == "object" ? JSON : fe,
  "%Map%": typeof Map > "u" ? fe : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !et || !je ? fe : je((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? fe : Promise,
  "%Proxy%": typeof Proxy > "u" ? fe : Proxy,
  "%RangeError%": du,
  "%ReferenceError%": gu,
  "%Reflect%": typeof Reflect > "u" ? fe : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? fe : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !et || !je ? fe : je((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? fe : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": et && je ? je(""[Symbol.iterator]()) : fe,
  "%Symbol%": et ? Symbol : fe,
  "%SyntaxError%": pt,
  "%ThrowTypeError%": bu,
  "%TypedArray%": wu,
  "%TypeError%": st,
  "%Uint8Array%": typeof Uint8Array > "u" ? fe : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? fe : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? fe : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? fe : Uint32Array,
  "%URIError%": vu,
  "%WeakMap%": typeof WeakMap > "u" ? fe : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? fe : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? fe : WeakSet
};
if (je)
  try {
    null.error;
  } catch (e) {
    var Eu = je(je(e));
    Xe["%Error.prototype%"] = Eu;
  }
var Su = function e(r) {
  var i;
  if (r === "%AsyncFunction%")
    i = ar("async function () {}");
  else if (r === "%GeneratorFunction%")
    i = ar("function* () {}");
  else if (r === "%AsyncGeneratorFunction%")
    i = ar("async function* () {}");
  else if (r === "%AsyncGenerator%") {
    var o = e("%AsyncGeneratorFunction%");
    o && (i = o.prototype);
  } else if (r === "%AsyncIteratorPrototype%") {
    var c = e("%AsyncGenerator%");
    c && je && (i = je(c.prototype));
  }
  return Xe[r] = i, i;
}, En = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Et = rn, Nt = pu, _u = Et.call(Function.call, Array.prototype.concat), Au = Et.call(Function.apply, Array.prototype.splice), Sn = Et.call(Function.call, String.prototype.replace), Mt = Et.call(Function.call, String.prototype.slice), Ru = Et.call(Function.call, RegExp.prototype.exec), Ou = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Pu = /\\(\\)?/g, ju = function(r) {
  var i = Mt(r, 0, 1), o = Mt(r, -1);
  if (i === "%" && o !== "%")
    throw new pt("invalid intrinsic syntax, expected closing `%`");
  if (o === "%" && i !== "%")
    throw new pt("invalid intrinsic syntax, expected opening `%`");
  var c = [];
  return Sn(r, Ou, function(u, h, v, b) {
    c[c.length] = v ? Sn(b, Pu, "$1") : h || u;
  }), c;
}, Iu = function(r, i) {
  var o = r, c;
  if (Nt(En, o) && (c = En[o], o = "%" + c[0] + "%"), Nt(Xe, o)) {
    var u = Xe[o];
    if (u === it && (u = Su(o)), typeof u > "u" && !i)
      throw new st("intrinsic " + r + " exists, but is not available. Please file an issue!");
    return {
      alias: c,
      name: o,
      value: u
    };
  }
  throw new pt("intrinsic " + r + " does not exist!");
}, St = function(r, i) {
  if (typeof r != "string" || r.length === 0)
    throw new st("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof i != "boolean")
    throw new st('"allowMissing" argument must be a boolean');
  if (Ru(/^%?[^%]*%?$/, r) === null)
    throw new pt("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var o = ju(r), c = o.length > 0 ? o[0] : "", u = Iu("%" + c + "%", i), h = u.name, v = u.value, b = !1, R = u.alias;
  R && (c = R[0], Au(o, _u([0, 1], R)));
  for (var l = 1, x = !0; l < o.length; l += 1) {
    var P = o[l], N = Mt(P, 0, 1), L = Mt(P, -1);
    if ((N === '"' || N === "'" || N === "`" || L === '"' || L === "'" || L === "`") && N !== L)
      throw new pt("property names with quotes must have matching quotes");
    if ((P === "constructor" || !x) && (b = !0), c += "." + P, h = "%" + c + "%", Nt(Xe, h))
      v = Xe[h];
    else if (v != null) {
      if (!(P in v)) {
        if (!i)
          throw new st("base intrinsic for " + r + " exists, but the property is not available.");
        return;
      }
      if (Je && l + 1 >= o.length) {
        var V = Je(v, P);
        x = !!V, x && "get" in V && !("originalValue" in V.get) ? v = V.get : v = v[P];
      } else
        x = Nt(v, P), v = v[P];
      x && !b && (Xe[h] = v);
    }
  }
  return v;
}, fr, _n;
function nn() {
  if (_n) return fr;
  _n = 1;
  var e = St, r = e("%Object.defineProperty%", !0) || !1;
  if (r)
    try {
      r({}, "a", { value: 1 });
    } catch {
      r = !1;
    }
  return fr = r, fr;
}
var Tu = St, Pt = Tu("%Object.getOwnPropertyDescriptor%", !0);
if (Pt)
  try {
    Pt([], "length");
  } catch {
    Pt = null;
  }
var on = Pt, An = nn(), Bu = Di, tt = Wt, Rn = on, $i = function(r, i, o) {
  if (!r || typeof r != "object" && typeof r != "function")
    throw new tt("`obj` must be an object or a function`");
  if (typeof i != "string" && typeof i != "symbol")
    throw new tt("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new tt("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new tt("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new tt("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new tt("`loose`, if provided, must be a boolean");
  var c = arguments.length > 3 ? arguments[3] : null, u = arguments.length > 4 ? arguments[4] : null, h = arguments.length > 5 ? arguments[5] : null, v = arguments.length > 6 ? arguments[6] : !1, b = !!Rn && Rn(r, i);
  if (An)
    An(r, i, {
      configurable: h === null && b ? b.configurable : !h,
      enumerable: c === null && b ? b.enumerable : !c,
      value: o,
      writable: u === null && b ? b.writable : !u
    });
  else if (v || !c && !u && !h)
    r[i] = o;
  else
    throw new Bu("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Jr = nn(), ki = function() {
  return !!Jr;
};
ki.hasArrayLengthDefineBug = function() {
  if (!Jr)
    return null;
  try {
    return Jr([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var xu = ki, Fu = St, On = $i, Nu = xu(), Pn = on, jn = Wt, Mu = Fu("%Math.floor%"), Lu = function(r, i) {
  if (typeof r != "function")
    throw new jn("`fn` is not a function");
  if (typeof i != "number" || i < 0 || i > 4294967295 || Mu(i) !== i)
    throw new jn("`length` must be a positive 32-bit integer");
  var o = arguments.length > 2 && !!arguments[2], c = !0, u = !0;
  if ("length" in r && Pn) {
    var h = Pn(r, "length");
    h && !h.configurable && (c = !1), h && !h.writable && (u = !1);
  }
  return (c || u || !o) && (Nu ? On(
    /** @type {Parameters<define>[0]} */
    r,
    "length",
    i,
    !0,
    !0
  ) : On(
    /** @type {Parameters<define>[0]} */
    r,
    "length",
    i
  )), r;
};
(function(e) {
  var r = rn, i = St, o = Lu, c = Wt, u = i("%Function.prototype.apply%"), h = i("%Function.prototype.call%"), v = i("%Reflect.apply%", !0) || r.call(h, u), b = nn(), R = i("%Math.max%");
  e.exports = function(P) {
    if (typeof P != "function")
      throw new c("a function is required");
    var N = v(r, h, arguments);
    return o(
      N,
      1 + R(0, P.length - (arguments.length - 1)),
      !0
    );
  };
  var l = function() {
    return v(r, u, arguments);
  };
  b ? b(e.exports, "apply", { value: l }) : e.exports.apply = l;
})(Li);
var an = Li.exports, Ci = St, qi = an, Du = qi(Ci("String.prototype.indexOf")), Wi = function(r, i) {
  var o = Ci(r, !!i);
  return typeof o == "function" && Du(r, ".prototype.") > -1 ? qi(o) : o;
}, sr, In;
function Uu() {
  if (In) return sr;
  In = 1;
  var e = Ct;
  return sr = function() {
    return e() && !!Symbol.toStringTag;
  }, sr;
}
var Lt = Ga, $u = za, Tn = an, un = Wi, jt = on, ku = un("Object.prototype.toString"), Gi = Uu()(), Bn = typeof globalThis > "u" ? He : globalThis, Xr = $u(), fn = un("String.prototype.slice"), cr = Object.getPrototypeOf, Cu = un("Array.prototype.indexOf", !0) || function(r, i) {
  for (var o = 0; o < r.length; o += 1)
    if (r[o] === i)
      return o;
  return -1;
}, Dt = { __proto__: null };
Gi && jt && cr ? Lt(Xr, function(e) {
  var r = new Bn[e]();
  if (Symbol.toStringTag in r) {
    var i = cr(r), o = jt(i, Symbol.toStringTag);
    if (!o) {
      var c = cr(i);
      o = jt(c, Symbol.toStringTag);
    }
    Dt["$" + e] = Tn(o.get);
  }
}) : Lt(Xr, function(e) {
  var r = new Bn[e](), i = r.slice || r.set;
  i && (Dt["$" + e] = Tn(i));
});
var qu = function(r) {
  var i = !1;
  return Lt(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    Dt,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(o, c) {
      if (!i)
        try {
          "$" + o(r) === c && (i = fn(c, 1));
        } catch {
        }
    }
  ), i;
}, Wu = function(r) {
  var i = !1;
  return Lt(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    Dt,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(o, c) {
      if (!i)
        try {
          o(r), i = fn(c, 1);
        } catch {
        }
    }
  ), i;
}, Vi = function(r) {
  if (!r || typeof r != "object")
    return !1;
  if (!Gi) {
    var i = fn(ku(r), 8, -1);
    return Cu(Xr, i) > -1 ? i : i !== "Object" ? !1 : Wu(r);
  }
  return jt ? qu(r) : null;
}, Gu = Vi, Vu = function(r) {
  return !!Gu(r);
};
(function(e) {
  var r = Ea, i = Oa, o = Vi, c = Vu;
  function u(C) {
    return C.call.bind(C);
  }
  var h = typeof BigInt < "u", v = typeof Symbol < "u", b = u(Object.prototype.toString), R = u(Number.prototype.valueOf), l = u(String.prototype.valueOf), x = u(Boolean.prototype.valueOf);
  if (h)
    var P = u(BigInt.prototype.valueOf);
  if (v)
    var N = u(Symbol.prototype.valueOf);
  function L(C, xe) {
    if (typeof C != "object")
      return !1;
    try {
      return xe(C), !0;
    } catch {
      return !1;
    }
  }
  e.isArgumentsObject = r, e.isGeneratorFunction = i, e.isTypedArray = c;
  function V(C) {
    return typeof Promise < "u" && C instanceof Promise || C !== null && typeof C == "object" && typeof C.then == "function" && typeof C.catch == "function";
  }
  e.isPromise = V;
  function W(C) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(C) : c(C) || I(C);
  }
  e.isArrayBufferView = W;
  function m(C) {
    return o(C) === "Uint8Array";
  }
  e.isUint8Array = m;
  function w(C) {
    return o(C) === "Uint8ClampedArray";
  }
  e.isUint8ClampedArray = w;
  function j(C) {
    return o(C) === "Uint16Array";
  }
  e.isUint16Array = j;
  function M(C) {
    return o(C) === "Uint32Array";
  }
  e.isUint32Array = M;
  function $(C) {
    return o(C) === "Int8Array";
  }
  e.isInt8Array = $;
  function J(C) {
    return o(C) === "Int16Array";
  }
  e.isInt16Array = J;
  function X(C) {
    return o(C) === "Int32Array";
  }
  e.isInt32Array = X;
  function Z(C) {
    return o(C) === "Float32Array";
  }
  e.isFloat32Array = Z;
  function z(C) {
    return o(C) === "Float64Array";
  }
  e.isFloat64Array = z;
  function ce(C) {
    return o(C) === "BigInt64Array";
  }
  e.isBigInt64Array = ce;
  function de(C) {
    return o(C) === "BigUint64Array";
  }
  e.isBigUint64Array = de;
  function ie(C) {
    return b(C) === "[object Map]";
  }
  ie.working = typeof Map < "u" && ie(/* @__PURE__ */ new Map());
  function he(C) {
    return typeof Map > "u" ? !1 : ie.working ? ie(C) : C instanceof Map;
  }
  e.isMap = he;
  function Se(C) {
    return b(C) === "[object Set]";
  }
  Se.working = typeof Set < "u" && Se(/* @__PURE__ */ new Set());
  function Oe(C) {
    return typeof Set > "u" ? !1 : Se.working ? Se(C) : C instanceof Set;
  }
  e.isSet = Oe;
  function we(C) {
    return b(C) === "[object WeakMap]";
  }
  we.working = typeof WeakMap < "u" && we(/* @__PURE__ */ new WeakMap());
  function _e(C) {
    return typeof WeakMap > "u" ? !1 : we.working ? we(C) : C instanceof WeakMap;
  }
  e.isWeakMap = _e;
  function be(C) {
    return b(C) === "[object WeakSet]";
  }
  be.working = typeof WeakSet < "u" && be(/* @__PURE__ */ new WeakSet());
  function q(C) {
    return be(C);
  }
  e.isWeakSet = q;
  function G(C) {
    return b(C) === "[object ArrayBuffer]";
  }
  G.working = typeof ArrayBuffer < "u" && G(new ArrayBuffer());
  function Q(C) {
    return typeof ArrayBuffer > "u" ? !1 : G.working ? G(C) : C instanceof ArrayBuffer;
  }
  e.isArrayBuffer = Q;
  function E(C) {
    return b(C) === "[object DataView]";
  }
  E.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && E(new DataView(new ArrayBuffer(1), 0, 1));
  function I(C) {
    return typeof DataView > "u" ? !1 : E.working ? E(C) : C instanceof DataView;
  }
  e.isDataView = I;
  var g = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function _(C) {
    return b(C) === "[object SharedArrayBuffer]";
  }
  function f(C) {
    return typeof g > "u" ? !1 : (typeof _.working > "u" && (_.working = _(new g())), _.working ? _(C) : C instanceof g);
  }
  e.isSharedArrayBuffer = f;
  function d(C) {
    return b(C) === "[object AsyncFunction]";
  }
  e.isAsyncFunction = d;
  function S(C) {
    return b(C) === "[object Map Iterator]";
  }
  e.isMapIterator = S;
  function B(C) {
    return b(C) === "[object Set Iterator]";
  }
  e.isSetIterator = B;
  function U(C) {
    return b(C) === "[object Generator]";
  }
  e.isGeneratorObject = U;
  function s(C) {
    return b(C) === "[object WebAssembly.Module]";
  }
  e.isWebAssemblyCompiledModule = s;
  function y(C) {
    return L(C, R);
  }
  e.isNumberObject = y;
  function D(C) {
    return L(C, l);
  }
  e.isStringObject = D;
  function H(C) {
    return L(C, x);
  }
  e.isBooleanObject = H;
  function ue(C) {
    return h && L(C, P);
  }
  e.isBigIntObject = ue;
  function te(C) {
    return v && L(C, N);
  }
  e.isSymbolObject = te;
  function oe(C) {
    return y(C) || D(C) || H(C) || ue(C) || te(C);
  }
  e.isBoxedPrimitive = oe;
  function me(C) {
    return typeof Uint8Array < "u" && (Q(C) || f(C));
  }
  e.isAnyArrayBuffer = me, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(C) {
    Object.defineProperty(e, C, {
      enumerable: !1,
      value: function() {
        throw new Error(C + " is not supported in userland");
      }
    });
  });
})(_i);
var Hu = function(r) {
  return r && typeof r == "object" && typeof r.copy == "function" && typeof r.fill == "function" && typeof r.readUInt8 == "function";
}, Kr = { exports: {} };
typeof Object.create == "function" ? Kr.exports = function(r, i) {
  i && (r.super_ = i, r.prototype = Object.create(i.prototype, {
    constructor: {
      value: r,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : Kr.exports = function(r, i) {
  if (i) {
    r.super_ = i;
    var o = function() {
    };
    o.prototype = i.prototype, r.prototype = new o(), r.prototype.constructor = r;
  }
};
var Ke = Kr.exports;
(function(e) {
  var r = Object.getOwnPropertyDescriptors || function(I) {
    for (var g = Object.keys(I), _ = {}, f = 0; f < g.length; f++)
      _[g[f]] = Object.getOwnPropertyDescriptor(I, g[f]);
    return _;
  }, i = /%[sdj%]/g;
  e.format = function(E) {
    if (!$(E)) {
      for (var I = [], g = 0; g < arguments.length; g++)
        I.push(h(arguments[g]));
      return I.join(" ");
    }
    for (var g = 1, _ = arguments, f = _.length, d = String(E).replace(i, function(B) {
      if (B === "%%") return "%";
      if (g >= f) return B;
      switch (B) {
        case "%s":
          return String(_[g++]);
        case "%d":
          return Number(_[g++]);
        case "%j":
          try {
            return JSON.stringify(_[g++]);
          } catch {
            return "[Circular]";
          }
        default:
          return B;
      }
    }), S = _[g]; g < f; S = _[++g])
      w(S) || !z(S) ? d += " " + S : d += " " + h(S);
    return d;
  }, e.deprecate = function(E, I) {
    if (typeof re < "u" && re.noDeprecation === !0)
      return E;
    if (typeof re > "u")
      return function() {
        return e.deprecate(E, I).apply(this, arguments);
      };
    var g = !1;
    function _() {
      if (!g) {
        if (re.throwDeprecation)
          throw new Error(I);
        re.traceDeprecation ? console.trace(I) : console.error(I), g = !0;
      }
      return E.apply(this, arguments);
    }
    return _;
  };
  var o = {}, c = /^$/;
  if (re.env.NODE_DEBUG) {
    var u = re.env.NODE_DEBUG;
    u = u.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), c = new RegExp("^" + u + "$", "i");
  }
  e.debuglog = function(E) {
    if (E = E.toUpperCase(), !o[E])
      if (c.test(E)) {
        var I = re.pid;
        o[E] = function() {
          var g = e.format.apply(e, arguments);
          console.error("%s %d: %s", E, I, g);
        };
      } else
        o[E] = function() {
        };
    return o[E];
  };
  function h(E, I) {
    var g = {
      seen: [],
      stylize: b
    };
    return arguments.length >= 3 && (g.depth = arguments[2]), arguments.length >= 4 && (g.colors = arguments[3]), m(I) ? g.showHidden = I : I && e._extend(g, I), X(g.showHidden) && (g.showHidden = !1), X(g.depth) && (g.depth = 2), X(g.colors) && (g.colors = !1), X(g.customInspect) && (g.customInspect = !0), g.colors && (g.stylize = v), l(g, E, g.depth);
  }
  e.inspect = h, h.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, h.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function v(E, I) {
    var g = h.styles[I];
    return g ? "\x1B[" + h.colors[g][0] + "m" + E + "\x1B[" + h.colors[g][1] + "m" : E;
  }
  function b(E, I) {
    return E;
  }
  function R(E) {
    var I = {};
    return E.forEach(function(g, _) {
      I[g] = !0;
    }), I;
  }
  function l(E, I, g) {
    if (E.customInspect && I && ie(I.inspect) && // Filter out the util module, it's inspect function is special
    I.inspect !== e.inspect && // Also filter out any prototype objects using the circular check.
    !(I.constructor && I.constructor.prototype === I)) {
      var _ = I.inspect(g, E);
      return $(_) || (_ = l(E, _, g)), _;
    }
    var f = x(E, I);
    if (f)
      return f;
    var d = Object.keys(I), S = R(d);
    if (E.showHidden && (d = Object.getOwnPropertyNames(I)), de(I) && (d.indexOf("message") >= 0 || d.indexOf("description") >= 0))
      return P(I);
    if (d.length === 0) {
      if (ie(I)) {
        var B = I.name ? ": " + I.name : "";
        return E.stylize("[Function" + B + "]", "special");
      }
      if (Z(I))
        return E.stylize(RegExp.prototype.toString.call(I), "regexp");
      if (ce(I))
        return E.stylize(Date.prototype.toString.call(I), "date");
      if (de(I))
        return P(I);
    }
    var U = "", s = !1, y = ["{", "}"];
    if (W(I) && (s = !0, y = ["[", "]"]), ie(I)) {
      var D = I.name ? ": " + I.name : "";
      U = " [Function" + D + "]";
    }
    if (Z(I) && (U = " " + RegExp.prototype.toString.call(I)), ce(I) && (U = " " + Date.prototype.toUTCString.call(I)), de(I) && (U = " " + P(I)), d.length === 0 && (!s || I.length == 0))
      return y[0] + U + y[1];
    if (g < 0)
      return Z(I) ? E.stylize(RegExp.prototype.toString.call(I), "regexp") : E.stylize("[Object]", "special");
    E.seen.push(I);
    var H;
    return s ? H = N(E, I, g, S, d) : H = d.map(function(ue) {
      return L(E, I, g, S, ue, s);
    }), E.seen.pop(), V(H, U, y);
  }
  function x(E, I) {
    if (X(I))
      return E.stylize("undefined", "undefined");
    if ($(I)) {
      var g = "'" + JSON.stringify(I).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return E.stylize(g, "string");
    }
    if (M(I))
      return E.stylize("" + I, "number");
    if (m(I))
      return E.stylize("" + I, "boolean");
    if (w(I))
      return E.stylize("null", "null");
  }
  function P(E) {
    return "[" + Error.prototype.toString.call(E) + "]";
  }
  function N(E, I, g, _, f) {
    for (var d = [], S = 0, B = I.length; S < B; ++S)
      be(I, String(S)) ? d.push(L(
        E,
        I,
        g,
        _,
        String(S),
        !0
      )) : d.push("");
    return f.forEach(function(U) {
      U.match(/^\d+$/) || d.push(L(
        E,
        I,
        g,
        _,
        U,
        !0
      ));
    }), d;
  }
  function L(E, I, g, _, f, d) {
    var S, B, U;
    if (U = Object.getOwnPropertyDescriptor(I, f) || { value: I[f] }, U.get ? U.set ? B = E.stylize("[Getter/Setter]", "special") : B = E.stylize("[Getter]", "special") : U.set && (B = E.stylize("[Setter]", "special")), be(_, f) || (S = "[" + f + "]"), B || (E.seen.indexOf(U.value) < 0 ? (w(g) ? B = l(E, U.value, null) : B = l(E, U.value, g - 1), B.indexOf(`
`) > -1 && (d ? B = B.split(`
`).map(function(s) {
      return "  " + s;
    }).join(`
`).slice(2) : B = `
` + B.split(`
`).map(function(s) {
      return "   " + s;
    }).join(`
`))) : B = E.stylize("[Circular]", "special")), X(S)) {
      if (d && f.match(/^\d+$/))
        return B;
      S = JSON.stringify("" + f), S.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (S = S.slice(1, -1), S = E.stylize(S, "name")) : (S = S.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), S = E.stylize(S, "string"));
    }
    return S + ": " + B;
  }
  function V(E, I, g) {
    var _ = E.reduce(function(f, d) {
      return d.indexOf(`
`) >= 0, f + d.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return _ > 60 ? g[0] + (I === "" ? "" : I + `
 `) + " " + E.join(`,
  `) + " " + g[1] : g[0] + I + " " + E.join(", ") + " " + g[1];
  }
  e.types = _i;
  function W(E) {
    return Array.isArray(E);
  }
  e.isArray = W;
  function m(E) {
    return typeof E == "boolean";
  }
  e.isBoolean = m;
  function w(E) {
    return E === null;
  }
  e.isNull = w;
  function j(E) {
    return E == null;
  }
  e.isNullOrUndefined = j;
  function M(E) {
    return typeof E == "number";
  }
  e.isNumber = M;
  function $(E) {
    return typeof E == "string";
  }
  e.isString = $;
  function J(E) {
    return typeof E == "symbol";
  }
  e.isSymbol = J;
  function X(E) {
    return E === void 0;
  }
  e.isUndefined = X;
  function Z(E) {
    return z(E) && Se(E) === "[object RegExp]";
  }
  e.isRegExp = Z, e.types.isRegExp = Z;
  function z(E) {
    return typeof E == "object" && E !== null;
  }
  e.isObject = z;
  function ce(E) {
    return z(E) && Se(E) === "[object Date]";
  }
  e.isDate = ce, e.types.isDate = ce;
  function de(E) {
    return z(E) && (Se(E) === "[object Error]" || E instanceof Error);
  }
  e.isError = de, e.types.isNativeError = de;
  function ie(E) {
    return typeof E == "function";
  }
  e.isFunction = ie;
  function he(E) {
    return E === null || typeof E == "boolean" || typeof E == "number" || typeof E == "string" || typeof E == "symbol" || // ES6 symbol
    typeof E > "u";
  }
  e.isPrimitive = he, e.isBuffer = Hu;
  function Se(E) {
    return Object.prototype.toString.call(E);
  }
  function Oe(E) {
    return E < 10 ? "0" + E.toString(10) : E.toString(10);
  }
  var we = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function _e() {
    var E = /* @__PURE__ */ new Date(), I = [
      Oe(E.getHours()),
      Oe(E.getMinutes()),
      Oe(E.getSeconds())
    ].join(":");
    return [E.getDate(), we[E.getMonth()], I].join(" ");
  }
  e.log = function() {
    console.log("%s - %s", _e(), e.format.apply(e, arguments));
  }, e.inherits = Ke, e._extend = function(E, I) {
    if (!I || !z(I)) return E;
    for (var g = Object.keys(I), _ = g.length; _--; )
      E[g[_]] = I[g[_]];
    return E;
  };
  function be(E, I) {
    return Object.prototype.hasOwnProperty.call(E, I);
  }
  var q = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  e.promisify = function(I) {
    if (typeof I != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (q && I[q]) {
      var g = I[q];
      if (typeof g != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(g, q, {
        value: g,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), g;
    }
    function g() {
      for (var _, f, d = new Promise(function(U, s) {
        _ = U, f = s;
      }), S = [], B = 0; B < arguments.length; B++)
        S.push(arguments[B]);
      S.push(function(U, s) {
        U ? f(U) : _(s);
      });
      try {
        I.apply(this, S);
      } catch (U) {
        f(U);
      }
      return d;
    }
    return Object.setPrototypeOf(g, Object.getPrototypeOf(I)), q && Object.defineProperty(g, q, {
      value: g,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      g,
      r(I)
    );
  }, e.promisify.custom = q;
  function G(E, I) {
    if (!E) {
      var g = new Error("Promise was rejected with a falsy value");
      g.reason = E, E = g;
    }
    return I(E);
  }
  function Q(E) {
    if (typeof E != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function I() {
      for (var g = [], _ = 0; _ < arguments.length; _++)
        g.push(arguments[_]);
      var f = g.pop();
      if (typeof f != "function")
        throw new TypeError("The last argument must be of type Function");
      var d = this, S = function() {
        return f.apply(d, arguments);
      };
      E.apply(this, g).then(
        function(B) {
          re.nextTick(S.bind(null, null, B));
        },
        function(B) {
          re.nextTick(G.bind(null, B, S));
        }
      );
    }
    return Object.setPrototypeOf(I, Object.getPrototypeOf(E)), Object.defineProperties(
      I,
      r(E)
    ), I;
  }
  e.callbackify = Q;
})(Le);
var xn;
function Hi() {
  if (xn) return Kt;
  xn = 1;
  function e(w) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
      return typeof j;
    } : function(j) {
      return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
    }, e(w);
  }
  function r(w, j, M) {
    return Object.defineProperty(w, "prototype", { writable: !1 }), w;
  }
  function i(w, j) {
    if (!(w instanceof j))
      throw new TypeError("Cannot call a class as a function");
  }
  function o(w, j) {
    if (typeof j != "function" && j !== null)
      throw new TypeError("Super expression must either be null or a function");
    w.prototype = Object.create(j && j.prototype, { constructor: { value: w, writable: !0, configurable: !0 } }), Object.defineProperty(w, "prototype", { writable: !1 }), j && c(w, j);
  }
  function c(w, j) {
    return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function($, J) {
      return $.__proto__ = J, $;
    }, c(w, j);
  }
  function u(w) {
    var j = b();
    return function() {
      var $ = R(w), J;
      if (j) {
        var X = R(this).constructor;
        J = Reflect.construct($, arguments, X);
      } else
        J = $.apply(this, arguments);
      return h(this, J);
    };
  }
  function h(w, j) {
    if (j && (e(j) === "object" || typeof j == "function"))
      return j;
    if (j !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return v(w);
  }
  function v(w) {
    if (w === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return w;
  }
  function b() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function R(w) {
    return R = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(M) {
      return M.__proto__ || Object.getPrototypeOf(M);
    }, R(w);
  }
  var l = {}, x, P;
  function N(w, j, M) {
    M || (M = Error);
    function $(X, Z, z) {
      return typeof j == "string" ? j : j(X, Z, z);
    }
    var J = /* @__PURE__ */ function(X) {
      o(z, X);
      var Z = u(z);
      function z(ce, de, ie) {
        var he;
        return i(this, z), he = Z.call(this, $(ce, de, ie)), he.code = w, he;
      }
      return r(z);
    }(M);
    l[w] = J;
  }
  function L(w, j) {
    if (Array.isArray(w)) {
      var M = w.length;
      return w = w.map(function($) {
        return String($);
      }), M > 2 ? "one of ".concat(j, " ").concat(w.slice(0, M - 1).join(", "), ", or ") + w[M - 1] : M === 2 ? "one of ".concat(j, " ").concat(w[0], " or ").concat(w[1]) : "of ".concat(j, " ").concat(w[0]);
    } else
      return "of ".concat(j, " ").concat(String(w));
  }
  function V(w, j, M) {
    return w.substr(0, j.length) === j;
  }
  function W(w, j, M) {
    return (M === void 0 || M > w.length) && (M = w.length), w.substring(M - j.length, M) === j;
  }
  function m(w, j, M) {
    return typeof M != "number" && (M = 0), M + j.length > w.length ? !1 : w.indexOf(j, M) !== -1;
  }
  return N("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), N("ERR_INVALID_ARG_TYPE", function(w, j, M) {
    x === void 0 && (x = Ut()), x(typeof w == "string", "'name' must be a string");
    var $;
    typeof j == "string" && V(j, "not ") ? ($ = "must not be", j = j.replace(/^not /, "")) : $ = "must be";
    var J;
    if (W(w, " argument"))
      J = "The ".concat(w, " ").concat($, " ").concat(L(j, "type"));
    else {
      var X = m(w, ".") ? "property" : "argument";
      J = 'The "'.concat(w, '" ').concat(X, " ").concat($, " ").concat(L(j, "type"));
    }
    return J += ". Received type ".concat(e(M)), J;
  }, TypeError), N("ERR_INVALID_ARG_VALUE", function(w, j) {
    var M = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    P === void 0 && (P = Le);
    var $ = P.inspect(j);
    return $.length > 128 && ($ = "".concat($.slice(0, 128), "...")), "The argument '".concat(w, "' ").concat(M, ". Received ").concat($);
  }, TypeError), N("ERR_INVALID_RETURN_VALUE", function(w, j, M) {
    var $;
    return M && M.constructor && M.constructor.name ? $ = "instance of ".concat(M.constructor.name) : $ = "type ".concat(e(M)), "Expected ".concat(w, ' to be returned from the "').concat(j, '"') + " function but got ".concat($, ".");
  }, TypeError), N("ERR_MISSING_ARGS", function() {
    for (var w = arguments.length, j = new Array(w), M = 0; M < w; M++)
      j[M] = arguments[M];
    x === void 0 && (x = Ut()), x(j.length > 0, "At least one arg needs to be specified");
    var $ = "The ", J = j.length;
    switch (j = j.map(function(X) {
      return '"'.concat(X, '"');
    }), J) {
      case 1:
        $ += "".concat(j[0], " argument");
        break;
      case 2:
        $ += "".concat(j[0], " and ").concat(j[1], " arguments");
        break;
      default:
        $ += j.slice(0, J - 1).join(", "), $ += ", and ".concat(j[J - 1], " arguments");
        break;
    }
    return "".concat($, " must be specified");
  }, TypeError), Kt.codes = l, Kt;
}
var lr, Fn;
function zu() {
  if (Fn) return lr;
  Fn = 1;
  function e(q, G) {
    var Q = Object.keys(q);
    if (Object.getOwnPropertySymbols) {
      var E = Object.getOwnPropertySymbols(q);
      G && (E = E.filter(function(I) {
        return Object.getOwnPropertyDescriptor(q, I).enumerable;
      })), Q.push.apply(Q, E);
    }
    return Q;
  }
  function r(q) {
    for (var G = 1; G < arguments.length; G++) {
      var Q = arguments[G] != null ? arguments[G] : {};
      G % 2 ? e(Object(Q), !0).forEach(function(E) {
        i(q, E, Q[E]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(Q)) : e(Object(Q)).forEach(function(E) {
        Object.defineProperty(q, E, Object.getOwnPropertyDescriptor(Q, E));
      });
    }
    return q;
  }
  function i(q, G, Q) {
    return G = h(G), G in q ? Object.defineProperty(q, G, { value: Q, enumerable: !0, configurable: !0, writable: !0 }) : q[G] = Q, q;
  }
  function o(q, G) {
    if (!(q instanceof G))
      throw new TypeError("Cannot call a class as a function");
  }
  function c(q, G) {
    for (var Q = 0; Q < G.length; Q++) {
      var E = G[Q];
      E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(q, h(E.key), E);
    }
  }
  function u(q, G, Q) {
    return G && c(q.prototype, G), Object.defineProperty(q, "prototype", { writable: !1 }), q;
  }
  function h(q) {
    var G = v(q, "string");
    return w(G) === "symbol" ? G : String(G);
  }
  function v(q, G) {
    if (w(q) !== "object" || q === null) return q;
    var Q = q[Symbol.toPrimitive];
    if (Q !== void 0) {
      var E = Q.call(q, G || "default");
      if (w(E) !== "object") return E;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (G === "string" ? String : Number)(q);
  }
  function b(q, G) {
    if (typeof G != "function" && G !== null)
      throw new TypeError("Super expression must either be null or a function");
    q.prototype = Object.create(G && G.prototype, { constructor: { value: q, writable: !0, configurable: !0 } }), Object.defineProperty(q, "prototype", { writable: !1 }), G && W(q, G);
  }
  function R(q) {
    var G = L();
    return function() {
      var E = m(q), I;
      if (G) {
        var g = m(this).constructor;
        I = Reflect.construct(E, arguments, g);
      } else
        I = E.apply(this, arguments);
      return l(this, I);
    };
  }
  function l(q, G) {
    if (G && (w(G) === "object" || typeof G == "function"))
      return G;
    if (G !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return x(q);
  }
  function x(q) {
    if (q === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return q;
  }
  function P(q) {
    var G = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return P = function(E) {
      if (E === null || !V(E)) return E;
      if (typeof E != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof G < "u") {
        if (G.has(E)) return G.get(E);
        G.set(E, I);
      }
      function I() {
        return N(E, arguments, m(this).constructor);
      }
      return I.prototype = Object.create(E.prototype, { constructor: { value: I, enumerable: !1, writable: !0, configurable: !0 } }), W(I, E);
    }, P(q);
  }
  function N(q, G, Q) {
    return L() ? N = Reflect.construct.bind() : N = function(I, g, _) {
      var f = [null];
      f.push.apply(f, g);
      var d = Function.bind.apply(I, f), S = new d();
      return _ && W(S, _.prototype), S;
    }, N.apply(null, arguments);
  }
  function L() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function V(q) {
    return Function.toString.call(q).indexOf("[native code]") !== -1;
  }
  function W(q, G) {
    return W = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(E, I) {
      return E.__proto__ = I, E;
    }, W(q, G);
  }
  function m(q) {
    return m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(Q) {
      return Q.__proto__ || Object.getPrototypeOf(Q);
    }, m(q);
  }
  function w(q) {
    "@babel/helpers - typeof";
    return w = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(G) {
      return typeof G;
    } : function(G) {
      return G && typeof Symbol == "function" && G.constructor === Symbol && G !== Symbol.prototype ? "symbol" : typeof G;
    }, w(q);
  }
  var j = Le, M = j.inspect, $ = Hi(), J = $.codes.ERR_INVALID_ARG_TYPE;
  function X(q, G, Q) {
    return (Q === void 0 || Q > q.length) && (Q = q.length), q.substring(Q - G.length, Q) === G;
  }
  function Z(q, G) {
    if (G = Math.floor(G), q.length == 0 || G == 0) return "";
    var Q = q.length * G;
    for (G = Math.floor(Math.log(G) / Math.log(2)); G; )
      q += q, G--;
    return q += q.substring(0, Q - q.length), q;
  }
  var z = "", ce = "", de = "", ie = "", he = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, Se = 10;
  function Oe(q) {
    var G = Object.keys(q), Q = Object.create(Object.getPrototypeOf(q));
    return G.forEach(function(E) {
      Q[E] = q[E];
    }), Object.defineProperty(Q, "message", {
      value: q.message
    }), Q;
  }
  function we(q) {
    return M(q, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function _e(q, G, Q) {
    var E = "", I = "", g = 0, _ = "", f = !1, d = we(q), S = d.split(`
`), B = we(G).split(`
`), U = 0, s = "";
    if (Q === "strictEqual" && w(q) === "object" && w(G) === "object" && q !== null && G !== null && (Q = "strictEqualObject"), S.length === 1 && B.length === 1 && S[0] !== B[0]) {
      var y = S[0].length + B[0].length;
      if (y <= Se) {
        if ((w(q) !== "object" || q === null) && (w(G) !== "object" || G === null) && (q !== 0 || G !== 0))
          return "".concat(he[Q], `

`) + "".concat(S[0], " !== ").concat(B[0], `
`);
      } else if (Q !== "strictEqualObject") {
        var D = re.stderr && re.stderr.isTTY ? re.stderr.columns : 80;
        if (y < D) {
          for (; S[0][U] === B[0][U]; )
            U++;
          U > 2 && (s = `
  `.concat(Z(" ", U), "^"), U = 0);
        }
      }
    }
    for (var H = S[S.length - 1], ue = B[B.length - 1]; H === ue && (U++ < 2 ? _ = `
  `.concat(H).concat(_) : E = H, S.pop(), B.pop(), !(S.length === 0 || B.length === 0)); )
      H = S[S.length - 1], ue = B[B.length - 1];
    var te = Math.max(S.length, B.length);
    if (te === 0) {
      var oe = d.split(`
`);
      if (oe.length > 30)
        for (oe[26] = "".concat(z, "...").concat(ie); oe.length > 27; )
          oe.pop();
      return "".concat(he.notIdentical, `

`).concat(oe.join(`
`), `
`);
    }
    U > 3 && (_ = `
`.concat(z, "...").concat(ie).concat(_), f = !0), E !== "" && (_ = `
  `.concat(E).concat(_), E = "");
    var me = 0, C = he[Q] + `
`.concat(ce, "+ actual").concat(ie, " ").concat(de, "- expected").concat(ie), xe = " ".concat(z, "...").concat(ie, " Lines skipped");
    for (U = 0; U < te; U++) {
      var Ie = U - g;
      if (S.length < U + 1)
        Ie > 1 && U > 2 && (Ie > 4 ? (I += `
`.concat(z, "...").concat(ie), f = !0) : Ie > 3 && (I += `
  `.concat(B[U - 2]), me++), I += `
  `.concat(B[U - 1]), me++), g = U, E += `
`.concat(de, "-").concat(ie, " ").concat(B[U]), me++;
      else if (B.length < U + 1)
        Ie > 1 && U > 2 && (Ie > 4 ? (I += `
`.concat(z, "...").concat(ie), f = !0) : Ie > 3 && (I += `
  `.concat(S[U - 2]), me++), I += `
  `.concat(S[U - 1]), me++), g = U, I += `
`.concat(ce, "+").concat(ie, " ").concat(S[U]), me++;
      else {
        var Fe = B[U], Te = S[U], O = Te !== Fe && (!X(Te, ",") || Te.slice(0, -1) !== Fe);
        O && X(Fe, ",") && Fe.slice(0, -1) === Te && (O = !1, Te += ","), O ? (Ie > 1 && U > 2 && (Ie > 4 ? (I += `
`.concat(z, "...").concat(ie), f = !0) : Ie > 3 && (I += `
  `.concat(S[U - 2]), me++), I += `
  `.concat(S[U - 1]), me++), g = U, I += `
`.concat(ce, "+").concat(ie, " ").concat(Te), E += `
`.concat(de, "-").concat(ie, " ").concat(Fe), me += 2) : (I += E, E = "", (Ie === 1 || U === 0) && (I += `
  `.concat(Te), me++));
      }
      if (me > 20 && U < te - 2)
        return "".concat(C).concat(xe, `
`).concat(I, `
`).concat(z, "...").concat(ie).concat(E, `
`) + "".concat(z, "...").concat(ie);
    }
    return "".concat(C).concat(f ? xe : "", `
`).concat(I).concat(E).concat(_).concat(s);
  }
  var be = /* @__PURE__ */ function(q, G) {
    b(E, q);
    var Q = R(E);
    function E(I) {
      var g;
      if (o(this, E), w(I) !== "object" || I === null)
        throw new J("options", "Object", I);
      var _ = I.message, f = I.operator, d = I.stackStartFn, S = I.actual, B = I.expected, U = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, _ != null)
        g = Q.call(this, String(_));
      else if (re.stderr && re.stderr.isTTY && (re.stderr && re.stderr.getColorDepth && re.stderr.getColorDepth() !== 1 ? (z = "\x1B[34m", ce = "\x1B[32m", ie = "\x1B[39m", de = "\x1B[31m") : (z = "", ce = "", ie = "", de = "")), w(S) === "object" && S !== null && w(B) === "object" && B !== null && "stack" in S && S instanceof Error && "stack" in B && B instanceof Error && (S = Oe(S), B = Oe(B)), f === "deepStrictEqual" || f === "strictEqual")
        g = Q.call(this, _e(S, B, f));
      else if (f === "notDeepStrictEqual" || f === "notStrictEqual") {
        var s = he[f], y = we(S).split(`
`);
        if (f === "notStrictEqual" && w(S) === "object" && S !== null && (s = he.notStrictEqualObject), y.length > 30)
          for (y[26] = "".concat(z, "...").concat(ie); y.length > 27; )
            y.pop();
        y.length === 1 ? g = Q.call(this, "".concat(s, " ").concat(y[0])) : g = Q.call(this, "".concat(s, `

`).concat(y.join(`
`), `
`));
      } else {
        var D = we(S), H = "", ue = he[f];
        f === "notDeepEqual" || f === "notEqual" ? (D = "".concat(he[f], `

`).concat(D), D.length > 1024 && (D = "".concat(D.slice(0, 1021), "..."))) : (H = "".concat(we(B)), D.length > 512 && (D = "".concat(D.slice(0, 509), "...")), H.length > 512 && (H = "".concat(H.slice(0, 509), "...")), f === "deepEqual" || f === "equal" ? D = "".concat(ue, `

`).concat(D, `

should equal

`) : H = " ".concat(f, " ").concat(H)), g = Q.call(this, "".concat(D).concat(H));
      }
      return Error.stackTraceLimit = U, g.generatedMessage = !_, Object.defineProperty(x(g), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), g.code = "ERR_ASSERTION", g.actual = S, g.expected = B, g.operator = f, Error.captureStackTrace && Error.captureStackTrace(x(g), d), g.stack, g.name = "AssertionError", l(g);
    }
    return u(E, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: G,
      value: function(g, _) {
        return M(this, r(r({}, _), {}, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), E;
  }(/* @__PURE__ */ P(Error), M.custom);
  return lr = be, lr;
}
var Nn = Object.prototype.toString, zi = function(r) {
  var i = Nn.call(r), o = i === "[object Arguments]";
  return o || (o = i !== "[object Array]" && r !== null && typeof r == "object" && typeof r.length == "number" && r.length >= 0 && Nn.call(r.callee) === "[object Function]"), o;
}, pr, Mn;
function Yu() {
  if (Mn) return pr;
  Mn = 1;
  var e;
  if (!Object.keys) {
    var r = Object.prototype.hasOwnProperty, i = Object.prototype.toString, o = zi, c = Object.prototype.propertyIsEnumerable, u = !c.call({ toString: null }, "toString"), h = c.call(function() {
    }, "prototype"), v = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], b = function(P) {
      var N = P.constructor;
      return N && N.prototype === P;
    }, R = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, l = function() {
      if (typeof window > "u")
        return !1;
      for (var P in window)
        try {
          if (!R["$" + P] && r.call(window, P) && window[P] !== null && typeof window[P] == "object")
            try {
              b(window[P]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), x = function(P) {
      if (typeof window > "u" || !l)
        return b(P);
      try {
        return b(P);
      } catch {
        return !1;
      }
    };
    e = function(N) {
      var L = N !== null && typeof N == "object", V = i.call(N) === "[object Function]", W = o(N), m = L && i.call(N) === "[object String]", w = [];
      if (!L && !V && !W)
        throw new TypeError("Object.keys called on a non-object");
      var j = h && V;
      if (m && N.length > 0 && !r.call(N, 0))
        for (var M = 0; M < N.length; ++M)
          w.push(String(M));
      if (W && N.length > 0)
        for (var $ = 0; $ < N.length; ++$)
          w.push(String($));
      else
        for (var J in N)
          !(j && J === "prototype") && r.call(N, J) && w.push(String(J));
      if (u)
        for (var X = x(N), Z = 0; Z < v.length; ++Z)
          !(X && v[Z] === "constructor") && r.call(N, v[Z]) && w.push(v[Z]);
      return w;
    };
  }
  return pr = e, pr;
}
var Ju = Array.prototype.slice, Xu = zi, Ln = Object.keys, It = Ln ? function(r) {
  return Ln(r);
} : Yu(), Dn = Object.keys;
It.shim = function() {
  if (Object.keys) {
    var r = function() {
      var i = Object.keys(arguments);
      return i && i.length === arguments.length;
    }(1, 2);
    r || (Object.keys = function(o) {
      return Xu(o) ? Dn(Ju.call(o)) : Dn(o);
    });
  } else
    Object.keys = It;
  return Object.keys || It;
};
var sn = It, Ku = sn, Yi = Ct(), Ji = Wi, Un = Object, Zu = Ji("Array.prototype.push"), $n = Ji("Object.prototype.propertyIsEnumerable"), Qu = Yi ? Object.getOwnPropertySymbols : null, ef = function(r, i) {
  if (r == null)
    throw new TypeError("target must be an object");
  var o = Un(r);
  if (arguments.length === 1)
    return o;
  for (var c = 1; c < arguments.length; ++c) {
    var u = Un(arguments[c]), h = Ku(u), v = Yi && (Object.getOwnPropertySymbols || Qu);
    if (v)
      for (var b = v(u), R = 0; R < b.length; ++R) {
        var l = b[R];
        $n(u, l) && Zu(h, l);
      }
    for (var x = 0; x < h.length; ++x) {
      var P = h[x];
      if ($n(u, P)) {
        var N = u[P];
        o[P] = N;
      }
    }
  }
  return o;
}, hr = ef, tf = function() {
  if (!Object.assign)
    return !1;
  for (var e = "abcdefghijklmnopqrst", r = e.split(""), i = {}, o = 0; o < r.length; ++o)
    i[r[o]] = r[o];
  var c = Object.assign({}, i), u = "";
  for (var h in c)
    u += h;
  return e !== u;
}, rf = function() {
  if (!Object.assign || !Object.preventExtensions)
    return !1;
  var e = Object.preventExtensions({ 1: 2 });
  try {
    Object.assign(e, "xy");
  } catch {
    return e[1] === "y";
  }
  return !1;
}, nf = function() {
  return !Object.assign || tf() || rf() ? hr : Object.assign;
}, kn = function(e) {
  return e !== e;
}, Xi = function(r, i) {
  return r === 0 && i === 0 ? 1 / r === 1 / i : !!(r === i || kn(r) && kn(i));
}, of = Xi, cn = function() {
  return typeof Object.is == "function" ? Object.is : of;
}, yr, Cn;
function Ki() {
  if (Cn) return yr;
  Cn = 1;
  var e = tn, r = e("%Object.defineProperty%", !0), i = function() {
    if (r)
      try {
        return r({}, "a", { value: 1 }), !0;
      } catch {
        return !1;
      }
    return !1;
  };
  return i.hasArrayLengthDefineBug = function() {
    if (!i())
      return null;
    try {
      return r([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, yr = i, yr;
}
var dr, qn;
function Zi() {
  if (qn) return dr;
  qn = 1;
  var e = sn, r = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", i = Object.prototype.toString, o = Array.prototype.concat, c = $i, u = function(R) {
    return typeof R == "function" && i.call(R) === "[object Function]";
  }, h = Ki()(), v = function(R, l, x, P) {
    if (l in R) {
      if (P === !0) {
        if (R[l] === x)
          return;
      } else if (!u(P) || !P())
        return;
    }
    h ? c(R, l, x, !0) : c(R, l, x);
  }, b = function(R, l) {
    var x = arguments.length > 2 ? arguments[2] : {}, P = e(l);
    r && (P = o.call(P, Object.getOwnPropertySymbols(l)));
    for (var N = 0; N < P.length; N += 1)
      v(R, P[N], l[P[N]], x[P[N]]);
  };
  return b.supportsDescriptors = !!h, dr = b, dr;
}
var gr, Wn;
function af() {
  if (Wn) return gr;
  Wn = 1;
  var e = cn, r = Zi();
  return gr = function() {
    var o = e();
    return r(Object, { is: o }, {
      is: function() {
        return Object.is !== o;
      }
    }), o;
  }, gr;
}
var vr, Gn;
function uf() {
  if (Gn) return vr;
  Gn = 1;
  var e = Zi(), r = an, i = Xi, o = cn, c = af(), u = r(o(), Object);
  return e(u, {
    getPolyfill: o,
    implementation: i,
    shim: c
  }), vr = u, vr;
}
var br, Vn;
function Qi() {
  if (Vn) return br;
  Vn = 1;
  var e = sn, r = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", i = Object.prototype.toString, o = Array.prototype.concat, c = Object.defineProperty, u = function(l) {
    return typeof l == "function" && i.call(l) === "[object Function]";
  }, h = Ki()(), v = c && h, b = function(l, x, P, N) {
    x in l && (!u(N) || !N()) || (v ? c(l, x, {
      configurable: !0,
      enumerable: !1,
      value: P,
      writable: !0
    }) : l[x] = P);
  }, R = function(l, x) {
    var P = arguments.length > 2 ? arguments[2] : {}, N = e(x);
    r && (N = o.call(N, Object.getOwnPropertySymbols(x)));
    for (var L = 0; L < N.length; L += 1)
      b(l, N[L], x[N[L]], P[N[L]]);
  };
  return R.supportsDescriptors = !!v, br = R, br;
}
var mr, Hn;
function eo() {
  return Hn || (Hn = 1, mr = function(r) {
    return r !== r;
  }), mr;
}
var wr, zn;
function to() {
  if (zn) return wr;
  zn = 1;
  var e = eo();
  return wr = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : e;
  }, wr;
}
var Er, Yn;
function ff() {
  if (Yn) return Er;
  Yn = 1;
  var e = Qi(), r = to();
  return Er = function() {
    var o = r();
    return e(Number, { isNaN: o }, {
      isNaN: function() {
        return Number.isNaN !== o;
      }
    }), o;
  }, Er;
}
var Sr, Jn;
function sf() {
  if (Jn) return Sr;
  Jn = 1;
  var e = ji, r = Qi(), i = eo(), o = to(), c = ff(), u = e(o(), Number);
  return r(u, {
    getPolyfill: o,
    implementation: i,
    shim: c
  }), Sr = u, Sr;
}
var _r, Xn;
function cf() {
  if (Xn) return _r;
  Xn = 1;
  function e(O, T) {
    return u(O) || c(O, T) || i(O, T) || r();
  }
  function r() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function i(O, T) {
    if (O) {
      if (typeof O == "string") return o(O, T);
      var Y = Object.prototype.toString.call(O).slice(8, -1);
      if (Y === "Object" && O.constructor && (Y = O.constructor.name), Y === "Map" || Y === "Set") return Array.from(O);
      if (Y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Y)) return o(O, T);
    }
  }
  function o(O, T) {
    (T == null || T > O.length) && (T = O.length);
    for (var Y = 0, ee = new Array(T); Y < T; Y++) ee[Y] = O[Y];
    return ee;
  }
  function c(O, T) {
    var Y = O == null ? null : typeof Symbol < "u" && O[Symbol.iterator] || O["@@iterator"];
    if (Y != null) {
      var ee, K, ae, a, t = [], n = !0, p = !1;
      try {
        if (ae = (Y = Y.call(O)).next, T !== 0) for (; !(n = (ee = ae.call(Y)).done) && (t.push(ee.value), t.length !== T); n = !0) ;
      } catch (A) {
        p = !0, K = A;
      } finally {
        try {
          if (!n && Y.return != null && (a = Y.return(), Object(a) !== a)) return;
        } finally {
          if (p) throw K;
        }
      }
      return t;
    }
  }
  function u(O) {
    if (Array.isArray(O)) return O;
  }
  function h(O) {
    "@babel/helpers - typeof";
    return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(T) {
      return typeof T;
    } : function(T) {
      return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
    }, h(O);
  }
  var v = /a/g.flags !== void 0, b = function(T) {
    var Y = [];
    return T.forEach(function(ee) {
      return Y.push(ee);
    }), Y;
  }, R = function(T) {
    var Y = [];
    return T.forEach(function(ee, K) {
      return Y.push([K, ee]);
    }), Y;
  }, l = Object.is ? Object.is : uf(), x = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, P = Number.isNaN ? Number.isNaN : sf();
  function N(O) {
    return O.call.bind(O);
  }
  var L = N(Object.prototype.hasOwnProperty), V = N(Object.prototype.propertyIsEnumerable), W = N(Object.prototype.toString), m = Le.types, w = m.isAnyArrayBuffer, j = m.isArrayBufferView, M = m.isDate, $ = m.isMap, J = m.isRegExp, X = m.isSet, Z = m.isNativeError, z = m.isBoxedPrimitive, ce = m.isNumberObject, de = m.isStringObject, ie = m.isBooleanObject, he = m.isBigIntObject, Se = m.isSymbolObject, Oe = m.isFloat32Array, we = m.isFloat64Array;
  function _e(O) {
    if (O.length === 0 || O.length > 10) return !0;
    for (var T = 0; T < O.length; T++) {
      var Y = O.charCodeAt(T);
      if (Y < 48 || Y > 57) return !0;
    }
    return O.length === 10 && O >= Math.pow(2, 32);
  }
  function be(O) {
    return Object.keys(O).filter(_e).concat(x(O).filter(Object.prototype.propertyIsEnumerable.bind(O)));
  }
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */
  function q(O, T) {
    if (O === T)
      return 0;
    for (var Y = O.length, ee = T.length, K = 0, ae = Math.min(Y, ee); K < ae; ++K)
      if (O[K] !== T[K]) {
        Y = O[K], ee = T[K];
        break;
      }
    return Y < ee ? -1 : ee < Y ? 1 : 0;
  }
  var G = !0, Q = !1, E = 0, I = 1, g = 2, _ = 3;
  function f(O, T) {
    return v ? O.source === T.source && O.flags === T.flags : RegExp.prototype.toString.call(O) === RegExp.prototype.toString.call(T);
  }
  function d(O, T) {
    if (O.byteLength !== T.byteLength)
      return !1;
    for (var Y = 0; Y < O.byteLength; Y++)
      if (O[Y] !== T[Y])
        return !1;
    return !0;
  }
  function S(O, T) {
    return O.byteLength !== T.byteLength ? !1 : q(new Uint8Array(O.buffer, O.byteOffset, O.byteLength), new Uint8Array(T.buffer, T.byteOffset, T.byteLength)) === 0;
  }
  function B(O, T) {
    return O.byteLength === T.byteLength && q(new Uint8Array(O), new Uint8Array(T)) === 0;
  }
  function U(O, T) {
    return ce(O) ? ce(T) && l(Number.prototype.valueOf.call(O), Number.prototype.valueOf.call(T)) : de(O) ? de(T) && String.prototype.valueOf.call(O) === String.prototype.valueOf.call(T) : ie(O) ? ie(T) && Boolean.prototype.valueOf.call(O) === Boolean.prototype.valueOf.call(T) : he(O) ? he(T) && BigInt.prototype.valueOf.call(O) === BigInt.prototype.valueOf.call(T) : Se(T) && Symbol.prototype.valueOf.call(O) === Symbol.prototype.valueOf.call(T);
  }
  function s(O, T, Y, ee) {
    if (O === T)
      return O !== 0 ? !0 : Y ? l(O, T) : !0;
    if (Y) {
      if (h(O) !== "object")
        return typeof O == "number" && P(O) && P(T);
      if (h(T) !== "object" || O === null || T === null || Object.getPrototypeOf(O) !== Object.getPrototypeOf(T))
        return !1;
    } else {
      if (O === null || h(O) !== "object")
        return T === null || h(T) !== "object" ? O == T : !1;
      if (T === null || h(T) !== "object")
        return !1;
    }
    var K = W(O), ae = W(T);
    if (K !== ae)
      return !1;
    if (Array.isArray(O)) {
      if (O.length !== T.length)
        return !1;
      var a = be(O), t = be(T);
      return a.length !== t.length ? !1 : D(O, T, Y, ee, I, a);
    }
    if (K === "[object Object]" && (!$(O) && $(T) || !X(O) && X(T)))
      return !1;
    if (M(O)) {
      if (!M(T) || Date.prototype.getTime.call(O) !== Date.prototype.getTime.call(T))
        return !1;
    } else if (J(O)) {
      if (!J(T) || !f(O, T))
        return !1;
    } else if (Z(O) || O instanceof Error) {
      if (O.message !== T.message || O.name !== T.name)
        return !1;
    } else if (j(O)) {
      if (!Y && (Oe(O) || we(O))) {
        if (!d(O, T))
          return !1;
      } else if (!S(O, T))
        return !1;
      var n = be(O), p = be(T);
      return n.length !== p.length ? !1 : D(O, T, Y, ee, E, n);
    } else {
      if (X(O))
        return !X(T) || O.size !== T.size ? !1 : D(O, T, Y, ee, g);
      if ($(O))
        return !$(T) || O.size !== T.size ? !1 : D(O, T, Y, ee, _);
      if (w(O)) {
        if (!B(O, T))
          return !1;
      } else if (z(O) && !U(O, T))
        return !1;
    }
    return D(O, T, Y, ee, E);
  }
  function y(O, T) {
    return T.filter(function(Y) {
      return V(O, Y);
    });
  }
  function D(O, T, Y, ee, K, ae) {
    if (arguments.length === 5) {
      ae = Object.keys(O);
      var a = Object.keys(T);
      if (ae.length !== a.length)
        return !1;
    }
    for (var t = 0; t < ae.length; t++)
      if (!L(T, ae[t]))
        return !1;
    if (Y && arguments.length === 5) {
      var n = x(O);
      if (n.length !== 0) {
        var p = 0;
        for (t = 0; t < n.length; t++) {
          var A = n[t];
          if (V(O, A)) {
            if (!V(T, A))
              return !1;
            ae.push(A), p++;
          } else if (V(T, A))
            return !1;
        }
        var F = x(T);
        if (n.length !== F.length && y(T, F).length !== p)
          return !1;
      } else {
        var k = x(T);
        if (k.length !== 0 && y(T, k).length !== 0)
          return !1;
      }
    }
    if (ae.length === 0 && (K === E || K === I && O.length === 0 || O.size === 0))
      return !0;
    if (ee === void 0)
      ee = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var ne = ee.val1.get(O);
      if (ne !== void 0) {
        var pe = ee.val2.get(T);
        if (pe !== void 0)
          return ne === pe;
      }
      ee.position++;
    }
    ee.val1.set(O, ee.position), ee.val2.set(T, ee.position);
    var ye = Ie(O, T, Y, ae, ee, K);
    return ee.val1.delete(O), ee.val2.delete(T), ye;
  }
  function H(O, T, Y, ee) {
    for (var K = b(O), ae = 0; ae < K.length; ae++) {
      var a = K[ae];
      if (s(T, a, Y, ee))
        return O.delete(a), !0;
    }
    return !1;
  }
  function ue(O) {
    switch (h(O)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        O = +O;
      case "number":
        if (P(O))
          return !1;
    }
    return !0;
  }
  function te(O, T, Y) {
    var ee = ue(Y);
    return ee ?? (T.has(ee) && !O.has(ee));
  }
  function oe(O, T, Y, ee, K) {
    var ae = ue(Y);
    if (ae != null)
      return ae;
    var a = T.get(ae);
    return a === void 0 && !T.has(ae) || !s(ee, a, !1, K) ? !1 : !O.has(ae) && s(ee, a, !1, K);
  }
  function me(O, T, Y, ee) {
    for (var K = null, ae = b(O), a = 0; a < ae.length; a++) {
      var t = ae[a];
      if (h(t) === "object" && t !== null)
        K === null && (K = /* @__PURE__ */ new Set()), K.add(t);
      else if (!T.has(t)) {
        if (Y || !te(O, T, t))
          return !1;
        K === null && (K = /* @__PURE__ */ new Set()), K.add(t);
      }
    }
    if (K !== null) {
      for (var n = b(T), p = 0; p < n.length; p++) {
        var A = n[p];
        if (h(A) === "object" && A !== null) {
          if (!H(K, A, Y, ee)) return !1;
        } else if (!Y && !O.has(A) && !H(K, A, Y, ee))
          return !1;
      }
      return K.size === 0;
    }
    return !0;
  }
  function C(O, T, Y, ee, K, ae) {
    for (var a = b(O), t = 0; t < a.length; t++) {
      var n = a[t];
      if (s(Y, n, K, ae) && s(ee, T.get(n), K, ae))
        return O.delete(n), !0;
    }
    return !1;
  }
  function xe(O, T, Y, ee) {
    for (var K = null, ae = R(O), a = 0; a < ae.length; a++) {
      var t = e(ae[a], 2), n = t[0], p = t[1];
      if (h(n) === "object" && n !== null)
        K === null && (K = /* @__PURE__ */ new Set()), K.add(n);
      else {
        var A = T.get(n);
        if (A === void 0 && !T.has(n) || !s(p, A, Y, ee)) {
          if (Y || !oe(O, T, n, p, ee)) return !1;
          K === null && (K = /* @__PURE__ */ new Set()), K.add(n);
        }
      }
    }
    if (K !== null) {
      for (var F = R(T), k = 0; k < F.length; k++) {
        var ne = e(F[k], 2), pe = ne[0], ye = ne[1];
        if (h(pe) === "object" && pe !== null) {
          if (!C(K, O, pe, ye, Y, ee)) return !1;
        } else if (!Y && (!O.has(pe) || !s(O.get(pe), ye, !1, ee)) && !C(K, O, pe, ye, !1, ee))
          return !1;
      }
      return K.size === 0;
    }
    return !0;
  }
  function Ie(O, T, Y, ee, K, ae) {
    var a = 0;
    if (ae === g) {
      if (!me(O, T, Y, K))
        return !1;
    } else if (ae === _) {
      if (!xe(O, T, Y, K))
        return !1;
    } else if (ae === I)
      for (; a < O.length; a++)
        if (L(O, a)) {
          if (!L(T, a) || !s(O[a], T[a], Y, K))
            return !1;
        } else {
          if (L(T, a))
            return !1;
          for (var t = Object.keys(O); a < t.length; a++) {
            var n = t[a];
            if (!L(T, n) || !s(O[n], T[n], Y, K))
              return !1;
          }
          return t.length === Object.keys(T).length;
        }
    for (a = 0; a < ee.length; a++) {
      var p = ee[a];
      if (!s(O[p], T[p], Y, K))
        return !1;
    }
    return !0;
  }
  function Fe(O, T) {
    return s(O, T, Q);
  }
  function Te(O, T) {
    return s(O, T, G);
  }
  return _r = {
    isDeepEqual: Fe,
    isDeepStrictEqual: Te
  }, _r;
}
var Kn;
function Ut() {
  if (Kn) return Xt.exports;
  Kn = 1;
  function e(g) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
      return typeof _;
    } : function(_) {
      return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
    }, e(g);
  }
  function r(g, _, f) {
    return Object.defineProperty(g, "prototype", { writable: !1 }), g;
  }
  function i(g, _) {
    if (!(g instanceof _))
      throw new TypeError("Cannot call a class as a function");
  }
  var o = Hi(), c = o.codes, u = c.ERR_AMBIGUOUS_ARGUMENT, h = c.ERR_INVALID_ARG_TYPE, v = c.ERR_INVALID_ARG_VALUE, b = c.ERR_INVALID_RETURN_VALUE, R = c.ERR_MISSING_ARGS, l = zu(), x = Le, P = x.inspect, N = Le.types, L = N.isPromise, V = N.isRegExp, W = nf(), m = cn(), w = Bi("RegExp.prototype.test"), j, M;
  function $() {
    var g = cf();
    j = g.isDeepEqual, M = g.isDeepStrictEqual;
  }
  var J = !1, X = Xt.exports = ie, Z = {};
  function z(g) {
    throw g.message instanceof Error ? g.message : new l(g);
  }
  function ce(g, _, f, d, S) {
    var B = arguments.length, U;
    if (B === 0)
      U = "Failed";
    else if (B === 1)
      f = g, g = void 0;
    else {
      if (J === !1) {
        J = !0;
        var s = re.emitWarning ? re.emitWarning : console.warn.bind(console);
        s("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      B === 2 && (d = "!=");
    }
    if (f instanceof Error) throw f;
    var y = {
      actual: g,
      expected: _,
      operator: d === void 0 ? "fail" : d,
      stackStartFn: S || ce
    };
    f !== void 0 && (y.message = f);
    var D = new l(y);
    throw U && (D.message = U, D.generatedMessage = !0), D;
  }
  X.fail = ce, X.AssertionError = l;
  function de(g, _, f, d) {
    if (!f) {
      var S = !1;
      if (_ === 0)
        S = !0, d = "No value argument passed to `assert.ok()`";
      else if (d instanceof Error)
        throw d;
      var B = new l({
        actual: f,
        expected: !0,
        message: d,
        operator: "==",
        stackStartFn: g
      });
      throw B.generatedMessage = S, B;
    }
  }
  function ie() {
    for (var g = arguments.length, _ = new Array(g), f = 0; f < g; f++)
      _[f] = arguments[f];
    de.apply(void 0, [ie, _.length].concat(_));
  }
  X.ok = ie, X.equal = function g(_, f, d) {
    if (arguments.length < 2)
      throw new R("actual", "expected");
    _ != f && z({
      actual: _,
      expected: f,
      message: d,
      operator: "==",
      stackStartFn: g
    });
  }, X.notEqual = function g(_, f, d) {
    if (arguments.length < 2)
      throw new R("actual", "expected");
    _ == f && z({
      actual: _,
      expected: f,
      message: d,
      operator: "!=",
      stackStartFn: g
    });
  }, X.deepEqual = function g(_, f, d) {
    if (arguments.length < 2)
      throw new R("actual", "expected");
    j === void 0 && $(), j(_, f) || z({
      actual: _,
      expected: f,
      message: d,
      operator: "deepEqual",
      stackStartFn: g
    });
  }, X.notDeepEqual = function g(_, f, d) {
    if (arguments.length < 2)
      throw new R("actual", "expected");
    j === void 0 && $(), j(_, f) && z({
      actual: _,
      expected: f,
      message: d,
      operator: "notDeepEqual",
      stackStartFn: g
    });
  }, X.deepStrictEqual = function g(_, f, d) {
    if (arguments.length < 2)
      throw new R("actual", "expected");
    j === void 0 && $(), M(_, f) || z({
      actual: _,
      expected: f,
      message: d,
      operator: "deepStrictEqual",
      stackStartFn: g
    });
  }, X.notDeepStrictEqual = he;
  function he(g, _, f) {
    if (arguments.length < 2)
      throw new R("actual", "expected");
    j === void 0 && $(), M(g, _) && z({
      actual: g,
      expected: _,
      message: f,
      operator: "notDeepStrictEqual",
      stackStartFn: he
    });
  }
  X.strictEqual = function g(_, f, d) {
    if (arguments.length < 2)
      throw new R("actual", "expected");
    m(_, f) || z({
      actual: _,
      expected: f,
      message: d,
      operator: "strictEqual",
      stackStartFn: g
    });
  }, X.notStrictEqual = function g(_, f, d) {
    if (arguments.length < 2)
      throw new R("actual", "expected");
    m(_, f) && z({
      actual: _,
      expected: f,
      message: d,
      operator: "notStrictEqual",
      stackStartFn: g
    });
  };
  var Se = /* @__PURE__ */ r(function g(_, f, d) {
    var S = this;
    i(this, g), f.forEach(function(B) {
      B in _ && (d !== void 0 && typeof d[B] == "string" && V(_[B]) && w(_[B], d[B]) ? S[B] = d[B] : S[B] = _[B]);
    });
  });
  function Oe(g, _, f, d, S, B) {
    if (!(f in g) || !M(g[f], _[f])) {
      if (!d) {
        var U = new Se(g, S), s = new Se(_, S, g), y = new l({
          actual: U,
          expected: s,
          operator: "deepStrictEqual",
          stackStartFn: B
        });
        throw y.actual = g, y.expected = _, y.operator = B.name, y;
      }
      z({
        actual: g,
        expected: _,
        message: d,
        operator: B.name,
        stackStartFn: B
      });
    }
  }
  function we(g, _, f, d) {
    if (typeof _ != "function") {
      if (V(_)) return w(_, g);
      if (arguments.length === 2)
        throw new h("expected", ["Function", "RegExp"], _);
      if (e(g) !== "object" || g === null) {
        var S = new l({
          actual: g,
          expected: _,
          message: f,
          operator: "deepStrictEqual",
          stackStartFn: d
        });
        throw S.operator = d.name, S;
      }
      var B = Object.keys(_);
      if (_ instanceof Error)
        B.push("name", "message");
      else if (B.length === 0)
        throw new v("error", _, "may not be an empty object");
      return j === void 0 && $(), B.forEach(function(U) {
        typeof g[U] == "string" && V(_[U]) && w(_[U], g[U]) || Oe(g, _, U, f, B, d);
      }), !0;
    }
    return _.prototype !== void 0 && g instanceof _ ? !0 : Error.isPrototypeOf(_) ? !1 : _.call({}, g) === !0;
  }
  function _e(g) {
    if (typeof g != "function")
      throw new h("fn", "Function", g);
    try {
      g();
    } catch (_) {
      return _;
    }
    return Z;
  }
  function be(g) {
    return L(g) || g !== null && e(g) === "object" && typeof g.then == "function" && typeof g.catch == "function";
  }
  function q(g) {
    return Promise.resolve().then(function() {
      var _;
      if (typeof g == "function") {
        if (_ = g(), !be(_))
          throw new b("instance of Promise", "promiseFn", _);
      } else if (be(g))
        _ = g;
      else
        throw new h("promiseFn", ["Function", "Promise"], g);
      return Promise.resolve().then(function() {
        return _;
      }).then(function() {
        return Z;
      }).catch(function(f) {
        return f;
      });
    });
  }
  function G(g, _, f, d) {
    if (typeof f == "string") {
      if (arguments.length === 4)
        throw new h("error", ["Object", "Error", "Function", "RegExp"], f);
      if (e(_) === "object" && _ !== null) {
        if (_.message === f)
          throw new u("error/message", 'The error message "'.concat(_.message, '" is identical to the message.'));
      } else if (_ === f)
        throw new u("error/message", 'The error "'.concat(_, '" is identical to the message.'));
      d = f, f = void 0;
    } else if (f != null && e(f) !== "object" && typeof f != "function")
      throw new h("error", ["Object", "Error", "Function", "RegExp"], f);
    if (_ === Z) {
      var S = "";
      f && f.name && (S += " (".concat(f.name, ")")), S += d ? ": ".concat(d) : ".";
      var B = g.name === "rejects" ? "rejection" : "exception";
      z({
        actual: void 0,
        expected: f,
        operator: g.name,
        message: "Missing expected ".concat(B).concat(S),
        stackStartFn: g
      });
    }
    if (f && !we(_, f, d, g))
      throw _;
  }
  function Q(g, _, f, d) {
    if (_ !== Z) {
      if (typeof f == "string" && (d = f, f = void 0), !f || we(_, f)) {
        var S = d ? ": ".concat(d) : ".", B = g.name === "doesNotReject" ? "rejection" : "exception";
        z({
          actual: _,
          expected: f,
          operator: g.name,
          message: "Got unwanted ".concat(B).concat(S, `
`) + 'Actual message: "'.concat(_ && _.message, '"'),
          stackStartFn: g
        });
      }
      throw _;
    }
  }
  X.throws = function g(_) {
    for (var f = arguments.length, d = new Array(f > 1 ? f - 1 : 0), S = 1; S < f; S++)
      d[S - 1] = arguments[S];
    G.apply(void 0, [g, _e(_)].concat(d));
  }, X.rejects = function g(_) {
    for (var f = arguments.length, d = new Array(f > 1 ? f - 1 : 0), S = 1; S < f; S++)
      d[S - 1] = arguments[S];
    return q(_).then(function(B) {
      return G.apply(void 0, [g, B].concat(d));
    });
  }, X.doesNotThrow = function g(_) {
    for (var f = arguments.length, d = new Array(f > 1 ? f - 1 : 0), S = 1; S < f; S++)
      d[S - 1] = arguments[S];
    Q.apply(void 0, [g, _e(_)].concat(d));
  }, X.doesNotReject = function g(_) {
    for (var f = arguments.length, d = new Array(f > 1 ? f - 1 : 0), S = 1; S < f; S++)
      d[S - 1] = arguments[S];
    return q(_).then(function(B) {
      return Q.apply(void 0, [g, B].concat(d));
    });
  }, X.ifError = function g(_) {
    if (_ != null) {
      var f = "ifError got unwanted exception: ";
      e(_) === "object" && typeof _.message == "string" ? _.message.length === 0 && _.constructor ? f += _.constructor.name : f += _.message : f += P(_);
      var d = new l({
        actual: _,
        expected: null,
        operator: "ifError",
        message: f,
        stackStartFn: g
      }), S = _.stack;
      if (typeof S == "string") {
        var B = S.split(`
`);
        B.shift();
        for (var U = d.stack.split(`
`), s = 0; s < B.length; s++) {
          var y = U.indexOf(B[s]);
          if (y !== -1) {
            U = U.slice(0, y);
            break;
          }
        }
        d.stack = "".concat(U.join(`
`), `
`).concat(B.join(`
`));
      }
      throw d;
    }
  };
  function E(g, _, f, d, S) {
    if (!V(_))
      throw new h("regexp", "RegExp", _);
    var B = S === "match";
    if (typeof g != "string" || w(_, g) !== B) {
      if (f instanceof Error)
        throw f;
      var U = !f;
      f = f || (typeof g != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(e(g), " (").concat(P(g), ")") : (B ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(P(_), `. Input:

`).concat(P(g), `
`));
      var s = new l({
        actual: g,
        expected: _,
        message: f,
        operator: S,
        stackStartFn: d
      });
      throw s.generatedMessage = U, s;
    }
  }
  X.match = function g(_, f, d) {
    E(_, f, d, g, "match");
  }, X.doesNotMatch = function g(_, f, d) {
    E(_, f, d, g, "doesNotMatch");
  };
  function I() {
    for (var g = arguments.length, _ = new Array(g), f = 0; f < g; f++)
      _[f] = arguments[f];
    de.apply(void 0, [I, _.length].concat(_));
  }
  return X.strict = W(I, X, {
    equal: X.strictEqual,
    deepEqual: X.deepStrictEqual,
    notEqual: X.notStrictEqual,
    notDeepEqual: X.notDeepStrictEqual
  }), X.strict.strict = X.strict, Xt.exports;
}
var ln = { exports: {} }, ct = typeof Reflect == "object" ? Reflect : null, Zn = ct && typeof ct.apply == "function" ? ct.apply : function(r, i, o) {
  return Function.prototype.apply.call(r, i, o);
}, Tt;
ct && typeof ct.ownKeys == "function" ? Tt = ct.ownKeys : Object.getOwnPropertySymbols ? Tt = function(r) {
  return Object.getOwnPropertyNames(r).concat(Object.getOwnPropertySymbols(r));
} : Tt = function(r) {
  return Object.getOwnPropertyNames(r);
};
function lf(e) {
  console && console.warn && console.warn(e);
}
var ro = Number.isNaN || function(r) {
  return r !== r;
};
function ge() {
  ge.init.call(this);
}
ln.exports = ge;
ln.exports.once = df;
ge.EventEmitter = ge;
ge.prototype._events = void 0;
ge.prototype._eventsCount = 0;
ge.prototype._maxListeners = void 0;
var Qn = 10;
function Gt(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(ge, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Qn;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || ro(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    Qn = e;
  }
});
ge.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
ge.prototype.setMaxListeners = function(r) {
  if (typeof r != "number" || r < 0 || ro(r))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + r + ".");
  return this._maxListeners = r, this;
};
function no(e) {
  return e._maxListeners === void 0 ? ge.defaultMaxListeners : e._maxListeners;
}
ge.prototype.getMaxListeners = function() {
  return no(this);
};
ge.prototype.emit = function(r) {
  for (var i = [], o = 1; o < arguments.length; o++) i.push(arguments[o]);
  var c = r === "error", u = this._events;
  if (u !== void 0)
    c = c && u.error === void 0;
  else if (!c)
    return !1;
  if (c) {
    var h;
    if (i.length > 0 && (h = i[0]), h instanceof Error)
      throw h;
    var v = new Error("Unhandled error." + (h ? " (" + h.message + ")" : ""));
    throw v.context = h, v;
  }
  var b = u[r];
  if (b === void 0)
    return !1;
  if (typeof b == "function")
    Zn(b, this, i);
  else
    for (var R = b.length, l = fo(b, R), o = 0; o < R; ++o)
      Zn(l[o], this, i);
  return !0;
};
function io(e, r, i, o) {
  var c, u, h;
  if (Gt(i), u = e._events, u === void 0 ? (u = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (u.newListener !== void 0 && (e.emit(
    "newListener",
    r,
    i.listener ? i.listener : i
  ), u = e._events), h = u[r]), h === void 0)
    h = u[r] = i, ++e._eventsCount;
  else if (typeof h == "function" ? h = u[r] = o ? [i, h] : [h, i] : o ? h.unshift(i) : h.push(i), c = no(e), c > 0 && h.length > c && !h.warned) {
    h.warned = !0;
    var v = new Error("Possible EventEmitter memory leak detected. " + h.length + " " + String(r) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    v.name = "MaxListenersExceededWarning", v.emitter = e, v.type = r, v.count = h.length, lf(v);
  }
  return e;
}
ge.prototype.addListener = function(r, i) {
  return io(this, r, i, !1);
};
ge.prototype.on = ge.prototype.addListener;
ge.prototype.prependListener = function(r, i) {
  return io(this, r, i, !0);
};
function pf() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function oo(e, r, i) {
  var o = { fired: !1, wrapFn: void 0, target: e, type: r, listener: i }, c = pf.bind(o);
  return c.listener = i, o.wrapFn = c, c;
}
ge.prototype.once = function(r, i) {
  return Gt(i), this.on(r, oo(this, r, i)), this;
};
ge.prototype.prependOnceListener = function(r, i) {
  return Gt(i), this.prependListener(r, oo(this, r, i)), this;
};
ge.prototype.removeListener = function(r, i) {
  var o, c, u, h, v;
  if (Gt(i), c = this._events, c === void 0)
    return this;
  if (o = c[r], o === void 0)
    return this;
  if (o === i || o.listener === i)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete c[r], c.removeListener && this.emit("removeListener", r, o.listener || i));
  else if (typeof o != "function") {
    for (u = -1, h = o.length - 1; h >= 0; h--)
      if (o[h] === i || o[h].listener === i) {
        v = o[h].listener, u = h;
        break;
      }
    if (u < 0)
      return this;
    u === 0 ? o.shift() : hf(o, u), o.length === 1 && (c[r] = o[0]), c.removeListener !== void 0 && this.emit("removeListener", r, v || i);
  }
  return this;
};
ge.prototype.off = ge.prototype.removeListener;
ge.prototype.removeAllListeners = function(r) {
  var i, o, c;
  if (o = this._events, o === void 0)
    return this;
  if (o.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : o[r] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete o[r]), this;
  if (arguments.length === 0) {
    var u = Object.keys(o), h;
    for (c = 0; c < u.length; ++c)
      h = u[c], h !== "removeListener" && this.removeAllListeners(h);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (i = o[r], typeof i == "function")
    this.removeListener(r, i);
  else if (i !== void 0)
    for (c = i.length - 1; c >= 0; c--)
      this.removeListener(r, i[c]);
  return this;
};
function ao(e, r, i) {
  var o = e._events;
  if (o === void 0)
    return [];
  var c = o[r];
  return c === void 0 ? [] : typeof c == "function" ? i ? [c.listener || c] : [c] : i ? yf(c) : fo(c, c.length);
}
ge.prototype.listeners = function(r) {
  return ao(this, r, !0);
};
ge.prototype.rawListeners = function(r) {
  return ao(this, r, !1);
};
ge.listenerCount = function(e, r) {
  return typeof e.listenerCount == "function" ? e.listenerCount(r) : uo.call(e, r);
};
ge.prototype.listenerCount = uo;
function uo(e) {
  var r = this._events;
  if (r !== void 0) {
    var i = r[e];
    if (typeof i == "function")
      return 1;
    if (i !== void 0)
      return i.length;
  }
  return 0;
}
ge.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Tt(this._events) : [];
};
function fo(e, r) {
  for (var i = new Array(r), o = 0; o < r; ++o)
    i[o] = e[o];
  return i;
}
function hf(e, r) {
  for (; r + 1 < e.length; r++)
    e[r] = e[r + 1];
  e.pop();
}
function yf(e) {
  for (var r = new Array(e.length), i = 0; i < r.length; ++i)
    r[i] = e[i].listener || e[i];
  return r;
}
function df(e, r) {
  return new Promise(function(i, o) {
    function c(h) {
      e.removeListener(r, u), o(h);
    }
    function u() {
      typeof e.removeListener == "function" && e.removeListener("error", c), i([].slice.call(arguments));
    }
    so(e, r, u, { once: !0 }), r !== "error" && gf(e, c, { once: !0 });
  });
}
function gf(e, r, i) {
  typeof e.on == "function" && so(e, "error", r, i);
}
function so(e, r, i, o) {
  if (typeof e.on == "function")
    o.once ? e.once(r, i) : e.on(r, i);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(r, function c(u) {
      o.once && e.removeEventListener(r, c), i(u);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var pn = ln.exports, Ar, ei;
function co() {
  return ei || (ei = 1, Ar = pn.EventEmitter), Ar;
}
var Rr, ti;
function vf() {
  if (ti) return Rr;
  ti = 1;
  function e(L, V) {
    var W = Object.keys(L);
    if (Object.getOwnPropertySymbols) {
      var m = Object.getOwnPropertySymbols(L);
      V && (m = m.filter(function(w) {
        return Object.getOwnPropertyDescriptor(L, w).enumerable;
      })), W.push.apply(W, m);
    }
    return W;
  }
  function r(L) {
    for (var V = 1; V < arguments.length; V++) {
      var W = arguments[V] != null ? arguments[V] : {};
      V % 2 ? e(Object(W), !0).forEach(function(m) {
        i(L, m, W[m]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(L, Object.getOwnPropertyDescriptors(W)) : e(Object(W)).forEach(function(m) {
        Object.defineProperty(L, m, Object.getOwnPropertyDescriptor(W, m));
      });
    }
    return L;
  }
  function i(L, V, W) {
    return V = h(V), V in L ? Object.defineProperty(L, V, { value: W, enumerable: !0, configurable: !0, writable: !0 }) : L[V] = W, L;
  }
  function o(L, V) {
    if (!(L instanceof V))
      throw new TypeError("Cannot call a class as a function");
  }
  function c(L, V) {
    for (var W = 0; W < V.length; W++) {
      var m = V[W];
      m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(L, h(m.key), m);
    }
  }
  function u(L, V, W) {
    return V && c(L.prototype, V), Object.defineProperty(L, "prototype", { writable: !1 }), L;
  }
  function h(L) {
    var V = v(L, "string");
    return typeof V == "symbol" ? V : String(V);
  }
  function v(L, V) {
    if (typeof L != "object" || L === null) return L;
    var W = L[Symbol.toPrimitive];
    if (W !== void 0) {
      var m = W.call(L, V || "default");
      if (typeof m != "object") return m;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (V === "string" ? String : Number)(L);
  }
  var b = kt, R = b.Buffer, l = Le, x = l.inspect, P = x && x.custom || "inspect";
  function N(L, V, W) {
    R.prototype.copy.call(L, V, W);
  }
  return Rr = /* @__PURE__ */ function() {
    function L() {
      o(this, L), this.head = null, this.tail = null, this.length = 0;
    }
    return u(L, [{
      key: "push",
      value: function(W) {
        var m = {
          data: W,
          next: null
        };
        this.length > 0 ? this.tail.next = m : this.head = m, this.tail = m, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(W) {
        var m = {
          data: W,
          next: this.head
        };
        this.length === 0 && (this.tail = m), this.head = m, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var W = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, W;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(W) {
        if (this.length === 0) return "";
        for (var m = this.head, w = "" + m.data; m = m.next; ) w += W + m.data;
        return w;
      }
    }, {
      key: "concat",
      value: function(W) {
        if (this.length === 0) return R.alloc(0);
        for (var m = R.allocUnsafe(W >>> 0), w = this.head, j = 0; w; )
          N(w.data, m, j), j += w.data.length, w = w.next;
        return m;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(W, m) {
        var w;
        return W < this.head.data.length ? (w = this.head.data.slice(0, W), this.head.data = this.head.data.slice(W)) : W === this.head.data.length ? w = this.shift() : w = m ? this._getString(W) : this._getBuffer(W), w;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(W) {
        var m = this.head, w = 1, j = m.data;
        for (W -= j.length; m = m.next; ) {
          var M = m.data, $ = W > M.length ? M.length : W;
          if ($ === M.length ? j += M : j += M.slice(0, W), W -= $, W === 0) {
            $ === M.length ? (++w, m.next ? this.head = m.next : this.head = this.tail = null) : (this.head = m, m.data = M.slice($));
            break;
          }
          ++w;
        }
        return this.length -= w, j;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(W) {
        var m = R.allocUnsafe(W), w = this.head, j = 1;
        for (w.data.copy(m), W -= w.data.length; w = w.next; ) {
          var M = w.data, $ = W > M.length ? M.length : W;
          if (M.copy(m, m.length - W, 0, $), W -= $, W === 0) {
            $ === M.length ? (++j, w.next ? this.head = w.next : this.head = this.tail = null) : (this.head = w, w.data = M.slice($));
            break;
          }
          ++j;
        }
        return this.length -= j, m;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: P,
      value: function(W, m) {
        return x(this, r(r({}, m), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), L;
  }(), Rr;
}
var Or, ri;
function lo() {
  if (ri) return Or;
  ri = 1;
  function e(h, v) {
    var b = this, R = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
    return R || l ? (v ? v(h) : h && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, re.nextTick(c, this, h)) : re.nextTick(c, this, h)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(h || null, function(x) {
      !v && x ? b._writableState ? b._writableState.errorEmitted ? re.nextTick(i, b) : (b._writableState.errorEmitted = !0, re.nextTick(r, b, x)) : re.nextTick(r, b, x) : v ? (re.nextTick(i, b), v(x)) : re.nextTick(i, b);
    }), this);
  }
  function r(h, v) {
    c(h, v), i(h);
  }
  function i(h) {
    h._writableState && !h._writableState.emitClose || h._readableState && !h._readableState.emitClose || h.emit("close");
  }
  function o() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function c(h, v) {
    h.emit("error", v);
  }
  function u(h, v) {
    var b = h._readableState, R = h._writableState;
    b && b.autoDestroy || R && R.autoDestroy ? h.destroy(v) : h.emit("error", v);
  }
  return Or = {
    destroy: e,
    undestroy: o,
    errorOrDestroy: u
  }, Or;
}
var Pr = {}, ni;
function yt() {
  if (ni) return Pr;
  ni = 1;
  function e(v, b) {
    v.prototype = Object.create(b.prototype), v.prototype.constructor = v, v.__proto__ = b;
  }
  var r = {};
  function i(v, b, R) {
    R || (R = Error);
    function l(P, N, L) {
      return typeof b == "string" ? b : b(P, N, L);
    }
    var x = /* @__PURE__ */ function(P) {
      e(N, P);
      function N(L, V, W) {
        return P.call(this, l(L, V, W)) || this;
      }
      return N;
    }(R);
    x.prototype.name = R.name, x.prototype.code = v, r[v] = x;
  }
  function o(v, b) {
    if (Array.isArray(v)) {
      var R = v.length;
      return v = v.map(function(l) {
        return String(l);
      }), R > 2 ? "one of ".concat(b, " ").concat(v.slice(0, R - 1).join(", "), ", or ") + v[R - 1] : R === 2 ? "one of ".concat(b, " ").concat(v[0], " or ").concat(v[1]) : "of ".concat(b, " ").concat(v[0]);
    } else
      return "of ".concat(b, " ").concat(String(v));
  }
  function c(v, b, R) {
    return v.substr(0, b.length) === b;
  }
  function u(v, b, R) {
    return (R === void 0 || R > v.length) && (R = v.length), v.substring(R - b.length, R) === b;
  }
  function h(v, b, R) {
    return typeof R != "number" && (R = 0), R + b.length > v.length ? !1 : v.indexOf(b, R) !== -1;
  }
  return i("ERR_INVALID_OPT_VALUE", function(v, b) {
    return 'The value "' + b + '" is invalid for option "' + v + '"';
  }, TypeError), i("ERR_INVALID_ARG_TYPE", function(v, b, R) {
    var l;
    typeof b == "string" && c(b, "not ") ? (l = "must not be", b = b.replace(/^not /, "")) : l = "must be";
    var x;
    if (u(v, " argument"))
      x = "The ".concat(v, " ").concat(l, " ").concat(o(b, "type"));
    else {
      var P = h(v, ".") ? "property" : "argument";
      x = 'The "'.concat(v, '" ').concat(P, " ").concat(l, " ").concat(o(b, "type"));
    }
    return x += ". Received type ".concat(typeof R), x;
  }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function(v) {
    return "The " + v + " method is not implemented";
  }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function(v) {
    return "Cannot call " + v + " after a stream was destroyed";
  }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function(v) {
    return "Unknown encoding: " + v;
  }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), Pr.codes = r, Pr;
}
var jr, ii;
function po() {
  if (ii) return jr;
  ii = 1;
  var e = yt().codes.ERR_INVALID_OPT_VALUE;
  function r(o, c, u) {
    return o.highWaterMark != null ? o.highWaterMark : c ? o[u] : null;
  }
  function i(o, c, u, h) {
    var v = r(c, h, u);
    if (v != null) {
      if (!(isFinite(v) && Math.floor(v) === v) || v < 0) {
        var b = h ? u : "highWaterMark";
        throw new e(b, v);
      }
      return Math.floor(v);
    }
    return o.objectMode ? 16 : 16 * 1024;
  }
  return jr = {
    getHighWaterMark: i
  }, jr;
}
var Ir, oi;
function bf() {
  if (oi) return Ir;
  oi = 1, Ir = e;
  function e(i, o) {
    if (r("noDeprecation"))
      return i;
    var c = !1;
    function u() {
      if (!c) {
        if (r("throwDeprecation"))
          throw new Error(o);
        r("traceDeprecation") ? console.trace(o) : console.warn(o), c = !0;
      }
      return i.apply(this, arguments);
    }
    return u;
  }
  function r(i) {
    try {
      if (!He.localStorage) return !1;
    } catch {
      return !1;
    }
    var o = He.localStorage[i];
    return o == null ? !1 : String(o).toLowerCase() === "true";
  }
  return Ir;
}
var Tr, ai;
function ho() {
  if (ai) return Tr;
  ai = 1, Tr = Z;
  function e(f) {
    var d = this;
    this.next = null, this.entry = null, this.finish = function() {
      _(d, f);
    };
  }
  var r;
  Z.WritableState = J;
  var i = {
    deprecate: bf()
  }, o = co(), c = kt.Buffer, u = (typeof He < "u" ? He : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function h(f) {
    return c.from(f);
  }
  function v(f) {
    return c.isBuffer(f) || f instanceof u;
  }
  var b = lo(), R = po(), l = R.getHighWaterMark, x = yt().codes, P = x.ERR_INVALID_ARG_TYPE, N = x.ERR_METHOD_NOT_IMPLEMENTED, L = x.ERR_MULTIPLE_CALLBACK, V = x.ERR_STREAM_CANNOT_PIPE, W = x.ERR_STREAM_DESTROYED, m = x.ERR_STREAM_NULL_VALUES, w = x.ERR_STREAM_WRITE_AFTER_END, j = x.ERR_UNKNOWN_ENCODING, M = b.errorOrDestroy;
  Ke(Z, o);
  function $() {
  }
  function J(f, d, S) {
    r = r || ht(), f = f || {}, typeof S != "boolean" && (S = d instanceof r), this.objectMode = !!f.objectMode, S && (this.objectMode = this.objectMode || !!f.writableObjectMode), this.highWaterMark = l(this, f, "writableHighWaterMark", S), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var B = f.decodeStrings === !1;
    this.decodeStrings = !B, this.defaultEncoding = f.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(U) {
      we(d, U);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = f.emitClose !== !1, this.autoDestroy = !!f.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  J.prototype.getBuffer = function() {
    for (var d = this.bufferedRequest, S = []; d; )
      S.push(d), d = d.next;
    return S;
  }, function() {
    try {
      Object.defineProperty(J.prototype, "buffer", {
        get: i.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var X;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (X = Function.prototype[Symbol.hasInstance], Object.defineProperty(Z, Symbol.hasInstance, {
    value: function(d) {
      return X.call(this, d) ? !0 : this !== Z ? !1 : d && d._writableState instanceof J;
    }
  })) : X = function(d) {
    return d instanceof this;
  };
  function Z(f) {
    r = r || ht();
    var d = this instanceof r;
    if (!d && !X.call(Z, this)) return new Z(f);
    this._writableState = new J(f, this, d), this.writable = !0, f && (typeof f.write == "function" && (this._write = f.write), typeof f.writev == "function" && (this._writev = f.writev), typeof f.destroy == "function" && (this._destroy = f.destroy), typeof f.final == "function" && (this._final = f.final)), o.call(this);
  }
  Z.prototype.pipe = function() {
    M(this, new V());
  };
  function z(f, d) {
    var S = new w();
    M(f, S), re.nextTick(d, S);
  }
  function ce(f, d, S, B) {
    var U;
    return S === null ? U = new m() : typeof S != "string" && !d.objectMode && (U = new P("chunk", ["string", "Buffer"], S)), U ? (M(f, U), re.nextTick(B, U), !1) : !0;
  }
  Z.prototype.write = function(f, d, S) {
    var B = this._writableState, U = !1, s = !B.objectMode && v(f);
    return s && !c.isBuffer(f) && (f = h(f)), typeof d == "function" && (S = d, d = null), s ? d = "buffer" : d || (d = B.defaultEncoding), typeof S != "function" && (S = $), B.ending ? z(this, S) : (s || ce(this, B, f, S)) && (B.pendingcb++, U = ie(this, B, s, f, d, S)), U;
  }, Z.prototype.cork = function() {
    this._writableState.corked++;
  }, Z.prototype.uncork = function() {
    var f = this._writableState;
    f.corked && (f.corked--, !f.writing && !f.corked && !f.bufferProcessing && f.bufferedRequest && q(this, f));
  }, Z.prototype.setDefaultEncoding = function(d) {
    if (typeof d == "string" && (d = d.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((d + "").toLowerCase()) > -1)) throw new j(d);
    return this._writableState.defaultEncoding = d, this;
  }, Object.defineProperty(Z.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function de(f, d, S) {
    return !f.objectMode && f.decodeStrings !== !1 && typeof d == "string" && (d = c.from(d, S)), d;
  }
  Object.defineProperty(Z.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function ie(f, d, S, B, U, s) {
    if (!S) {
      var y = de(d, B, U);
      B !== y && (S = !0, U = "buffer", B = y);
    }
    var D = d.objectMode ? 1 : B.length;
    d.length += D;
    var H = d.length < d.highWaterMark;
    if (H || (d.needDrain = !0), d.writing || d.corked) {
      var ue = d.lastBufferedRequest;
      d.lastBufferedRequest = {
        chunk: B,
        encoding: U,
        isBuf: S,
        callback: s,
        next: null
      }, ue ? ue.next = d.lastBufferedRequest : d.bufferedRequest = d.lastBufferedRequest, d.bufferedRequestCount += 1;
    } else
      he(f, d, !1, D, B, U, s);
    return H;
  }
  function he(f, d, S, B, U, s, y) {
    d.writelen = B, d.writecb = y, d.writing = !0, d.sync = !0, d.destroyed ? d.onwrite(new W("write")) : S ? f._writev(U, d.onwrite) : f._write(U, s, d.onwrite), d.sync = !1;
  }
  function Se(f, d, S, B, U) {
    --d.pendingcb, S ? (re.nextTick(U, B), re.nextTick(I, f, d), f._writableState.errorEmitted = !0, M(f, B)) : (U(B), f._writableState.errorEmitted = !0, M(f, B), I(f, d));
  }
  function Oe(f) {
    f.writing = !1, f.writecb = null, f.length -= f.writelen, f.writelen = 0;
  }
  function we(f, d) {
    var S = f._writableState, B = S.sync, U = S.writecb;
    if (typeof U != "function") throw new L();
    if (Oe(S), d) Se(f, S, B, d, U);
    else {
      var s = G(S) || f.destroyed;
      !s && !S.corked && !S.bufferProcessing && S.bufferedRequest && q(f, S), B ? re.nextTick(_e, f, S, s, U) : _e(f, S, s, U);
    }
  }
  function _e(f, d, S, B) {
    S || be(f, d), d.pendingcb--, B(), I(f, d);
  }
  function be(f, d) {
    d.length === 0 && d.needDrain && (d.needDrain = !1, f.emit("drain"));
  }
  function q(f, d) {
    d.bufferProcessing = !0;
    var S = d.bufferedRequest;
    if (f._writev && S && S.next) {
      var B = d.bufferedRequestCount, U = new Array(B), s = d.corkedRequestsFree;
      s.entry = S;
      for (var y = 0, D = !0; S; )
        U[y] = S, S.isBuf || (D = !1), S = S.next, y += 1;
      U.allBuffers = D, he(f, d, !0, d.length, U, "", s.finish), d.pendingcb++, d.lastBufferedRequest = null, s.next ? (d.corkedRequestsFree = s.next, s.next = null) : d.corkedRequestsFree = new e(d), d.bufferedRequestCount = 0;
    } else {
      for (; S; ) {
        var H = S.chunk, ue = S.encoding, te = S.callback, oe = d.objectMode ? 1 : H.length;
        if (he(f, d, !1, oe, H, ue, te), S = S.next, d.bufferedRequestCount--, d.writing)
          break;
      }
      S === null && (d.lastBufferedRequest = null);
    }
    d.bufferedRequest = S, d.bufferProcessing = !1;
  }
  Z.prototype._write = function(f, d, S) {
    S(new N("_write()"));
  }, Z.prototype._writev = null, Z.prototype.end = function(f, d, S) {
    var B = this._writableState;
    return typeof f == "function" ? (S = f, f = null, d = null) : typeof d == "function" && (S = d, d = null), f != null && this.write(f, d), B.corked && (B.corked = 1, this.uncork()), B.ending || g(this, B, S), this;
  }, Object.defineProperty(Z.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function G(f) {
    return f.ending && f.length === 0 && f.bufferedRequest === null && !f.finished && !f.writing;
  }
  function Q(f, d) {
    f._final(function(S) {
      d.pendingcb--, S && M(f, S), d.prefinished = !0, f.emit("prefinish"), I(f, d);
    });
  }
  function E(f, d) {
    !d.prefinished && !d.finalCalled && (typeof f._final == "function" && !d.destroyed ? (d.pendingcb++, d.finalCalled = !0, re.nextTick(Q, f, d)) : (d.prefinished = !0, f.emit("prefinish")));
  }
  function I(f, d) {
    var S = G(d);
    if (S && (E(f, d), d.pendingcb === 0 && (d.finished = !0, f.emit("finish"), d.autoDestroy))) {
      var B = f._readableState;
      (!B || B.autoDestroy && B.endEmitted) && f.destroy();
    }
    return S;
  }
  function g(f, d, S) {
    d.ending = !0, I(f, d), S && (d.finished ? re.nextTick(S) : f.once("finish", S)), d.ended = !0, f.writable = !1;
  }
  function _(f, d, S) {
    var B = f.entry;
    for (f.entry = null; B; ) {
      var U = B.callback;
      d.pendingcb--, U(S), B = B.next;
    }
    d.corkedRequestsFree.next = f;
  }
  return Object.defineProperty(Z.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(d) {
      this._writableState && (this._writableState.destroyed = d);
    }
  }), Z.prototype.destroy = b.destroy, Z.prototype._undestroy = b.undestroy, Z.prototype._destroy = function(f, d) {
    d(f);
  }, Tr;
}
var Br, ui;
function ht() {
  if (ui) return Br;
  ui = 1;
  var e = Object.keys || function(R) {
    var l = [];
    for (var x in R) l.push(x);
    return l;
  };
  Br = h;
  var r = yo(), i = ho();
  Ke(h, r);
  for (var o = e(i.prototype), c = 0; c < o.length; c++) {
    var u = o[c];
    h.prototype[u] || (h.prototype[u] = i.prototype[u]);
  }
  function h(R) {
    if (!(this instanceof h)) return new h(R);
    r.call(this, R), i.call(this, R), this.allowHalfOpen = !0, R && (R.readable === !1 && (this.readable = !1), R.writable === !1 && (this.writable = !1), R.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", v)));
  }
  Object.defineProperty(h.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(h.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(h.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function v() {
    this._writableState.ended || re.nextTick(b, this);
  }
  function b(R) {
    R.end();
  }
  return Object.defineProperty(h.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(l) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = l, this._writableState.destroyed = l);
    }
  }), Br;
}
var xr = {}, _t = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var fi;
function mf() {
  return fi || (fi = 1, function(e, r) {
    var i = kt, o = i.Buffer;
    function c(h, v) {
      for (var b in h)
        v[b] = h[b];
    }
    o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? e.exports = i : (c(i, r), r.Buffer = u);
    function u(h, v, b) {
      return o(h, v, b);
    }
    u.prototype = Object.create(o.prototype), c(o, u), u.from = function(h, v, b) {
      if (typeof h == "number")
        throw new TypeError("Argument must not be a number");
      return o(h, v, b);
    }, u.alloc = function(h, v, b) {
      if (typeof h != "number")
        throw new TypeError("Argument must be a number");
      var R = o(h);
      return v !== void 0 ? typeof b == "string" ? R.fill(v, b) : R.fill(v) : R.fill(0), R;
    }, u.allocUnsafe = function(h) {
      if (typeof h != "number")
        throw new TypeError("Argument must be a number");
      return o(h);
    }, u.allocUnsafeSlow = function(h) {
      if (typeof h != "number")
        throw new TypeError("Argument must be a number");
      return i.SlowBuffer(h);
    };
  }(_t, _t.exports)), _t.exports;
}
var si;
function ci() {
  if (si) return xr;
  si = 1;
  var e = mf().Buffer, r = e.isEncoding || function(m) {
    switch (m = "" + m, m && m.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function i(m) {
    if (!m) return "utf8";
    for (var w; ; )
      switch (m) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return m;
        default:
          if (w) return;
          m = ("" + m).toLowerCase(), w = !0;
      }
  }
  function o(m) {
    var w = i(m);
    if (typeof w != "string" && (e.isEncoding === r || !r(m))) throw new Error("Unknown encoding: " + m);
    return w || m;
  }
  xr.StringDecoder = c;
  function c(m) {
    this.encoding = o(m);
    var w;
    switch (this.encoding) {
      case "utf16le":
        this.text = x, this.end = P, w = 4;
        break;
      case "utf8":
        this.fillLast = b, w = 4;
        break;
      case "base64":
        this.text = N, this.end = L, w = 3;
        break;
      default:
        this.write = V, this.end = W;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(w);
  }
  c.prototype.write = function(m) {
    if (m.length === 0) return "";
    var w, j;
    if (this.lastNeed) {
      if (w = this.fillLast(m), w === void 0) return "";
      j = this.lastNeed, this.lastNeed = 0;
    } else
      j = 0;
    return j < m.length ? w ? w + this.text(m, j) : this.text(m, j) : w || "";
  }, c.prototype.end = l, c.prototype.text = R, c.prototype.fillLast = function(m) {
    if (this.lastNeed <= m.length)
      return m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, m.length), this.lastNeed -= m.length;
  };
  function u(m) {
    return m <= 127 ? 0 : m >> 5 === 6 ? 2 : m >> 4 === 14 ? 3 : m >> 3 === 30 ? 4 : m >> 6 === 2 ? -1 : -2;
  }
  function h(m, w, j) {
    var M = w.length - 1;
    if (M < j) return 0;
    var $ = u(w[M]);
    return $ >= 0 ? ($ > 0 && (m.lastNeed = $ - 1), $) : --M < j || $ === -2 ? 0 : ($ = u(w[M]), $ >= 0 ? ($ > 0 && (m.lastNeed = $ - 2), $) : --M < j || $ === -2 ? 0 : ($ = u(w[M]), $ >= 0 ? ($ > 0 && ($ === 2 ? $ = 0 : m.lastNeed = $ - 3), $) : 0));
  }
  function v(m, w, j) {
    if ((w[0] & 192) !== 128)
      return m.lastNeed = 0, "�";
    if (m.lastNeed > 1 && w.length > 1) {
      if ((w[1] & 192) !== 128)
        return m.lastNeed = 1, "�";
      if (m.lastNeed > 2 && w.length > 2 && (w[2] & 192) !== 128)
        return m.lastNeed = 2, "�";
    }
  }
  function b(m) {
    var w = this.lastTotal - this.lastNeed, j = v(this, m);
    if (j !== void 0) return j;
    if (this.lastNeed <= m.length)
      return m.copy(this.lastChar, w, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    m.copy(this.lastChar, w, 0, m.length), this.lastNeed -= m.length;
  }
  function R(m, w) {
    var j = h(this, m, w);
    if (!this.lastNeed) return m.toString("utf8", w);
    this.lastTotal = j;
    var M = m.length - (j - this.lastNeed);
    return m.copy(this.lastChar, 0, M), m.toString("utf8", w, M);
  }
  function l(m) {
    var w = m && m.length ? this.write(m) : "";
    return this.lastNeed ? w + "�" : w;
  }
  function x(m, w) {
    if ((m.length - w) % 2 === 0) {
      var j = m.toString("utf16le", w);
      if (j) {
        var M = j.charCodeAt(j.length - 1);
        if (M >= 55296 && M <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1], j.slice(0, -1);
      }
      return j;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = m[m.length - 1], m.toString("utf16le", w, m.length - 1);
  }
  function P(m) {
    var w = m && m.length ? this.write(m) : "";
    if (this.lastNeed) {
      var j = this.lastTotal - this.lastNeed;
      return w + this.lastChar.toString("utf16le", 0, j);
    }
    return w;
  }
  function N(m, w) {
    var j = (m.length - w) % 3;
    return j === 0 ? m.toString("base64", w) : (this.lastNeed = 3 - j, this.lastTotal = 3, j === 1 ? this.lastChar[0] = m[m.length - 1] : (this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1]), m.toString("base64", w, m.length - j));
  }
  function L(m) {
    var w = m && m.length ? this.write(m) : "";
    return this.lastNeed ? w + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : w;
  }
  function V(m) {
    return m.toString(this.encoding);
  }
  function W(m) {
    return m && m.length ? this.write(m) : "";
  }
  return xr;
}
var Fr, li;
function hn() {
  if (li) return Fr;
  li = 1;
  var e = yt().codes.ERR_STREAM_PREMATURE_CLOSE;
  function r(u) {
    var h = !1;
    return function() {
      if (!h) {
        h = !0;
        for (var v = arguments.length, b = new Array(v), R = 0; R < v; R++)
          b[R] = arguments[R];
        u.apply(this, b);
      }
    };
  }
  function i() {
  }
  function o(u) {
    return u.setHeader && typeof u.abort == "function";
  }
  function c(u, h, v) {
    if (typeof h == "function") return c(u, null, h);
    h || (h = {}), v = r(v || i);
    var b = h.readable || h.readable !== !1 && u.readable, R = h.writable || h.writable !== !1 && u.writable, l = function() {
      u.writable || P();
    }, x = u._writableState && u._writableState.finished, P = function() {
      R = !1, x = !0, b || v.call(u);
    }, N = u._readableState && u._readableState.endEmitted, L = function() {
      b = !1, N = !0, R || v.call(u);
    }, V = function(j) {
      v.call(u, j);
    }, W = function() {
      var j;
      if (b && !N)
        return (!u._readableState || !u._readableState.ended) && (j = new e()), v.call(u, j);
      if (R && !x)
        return (!u._writableState || !u._writableState.ended) && (j = new e()), v.call(u, j);
    }, m = function() {
      u.req.on("finish", P);
    };
    return o(u) ? (u.on("complete", P), u.on("abort", W), u.req ? m() : u.on("request", m)) : R && !u._writableState && (u.on("end", l), u.on("close", l)), u.on("end", L), u.on("finish", P), h.error !== !1 && u.on("error", V), u.on("close", W), function() {
      u.removeListener("complete", P), u.removeListener("abort", W), u.removeListener("request", m), u.req && u.req.removeListener("finish", P), u.removeListener("end", l), u.removeListener("close", l), u.removeListener("finish", P), u.removeListener("end", L), u.removeListener("error", V), u.removeListener("close", W);
    };
  }
  return Fr = c, Fr;
}
var Nr, pi;
function wf() {
  if (pi) return Nr;
  pi = 1;
  var e;
  function r(j, M, $) {
    return M = i(M), M in j ? Object.defineProperty(j, M, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : j[M] = $, j;
  }
  function i(j) {
    var M = o(j, "string");
    return typeof M == "symbol" ? M : String(M);
  }
  function o(j, M) {
    if (typeof j != "object" || j === null) return j;
    var $ = j[Symbol.toPrimitive];
    if ($ !== void 0) {
      var J = $.call(j, M || "default");
      if (typeof J != "object") return J;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (M === "string" ? String : Number)(j);
  }
  var c = hn(), u = Symbol("lastResolve"), h = Symbol("lastReject"), v = Symbol("error"), b = Symbol("ended"), R = Symbol("lastPromise"), l = Symbol("handlePromise"), x = Symbol("stream");
  function P(j, M) {
    return {
      value: j,
      done: M
    };
  }
  function N(j) {
    var M = j[u];
    if (M !== null) {
      var $ = j[x].read();
      $ !== null && (j[R] = null, j[u] = null, j[h] = null, M(P($, !1)));
    }
  }
  function L(j) {
    re.nextTick(N, j);
  }
  function V(j, M) {
    return function($, J) {
      j.then(function() {
        if (M[b]) {
          $(P(void 0, !0));
          return;
        }
        M[l]($, J);
      }, J);
    };
  }
  var W = Object.getPrototypeOf(function() {
  }), m = Object.setPrototypeOf((e = {
    get stream() {
      return this[x];
    },
    next: function() {
      var M = this, $ = this[v];
      if ($ !== null)
        return Promise.reject($);
      if (this[b])
        return Promise.resolve(P(void 0, !0));
      if (this[x].destroyed)
        return new Promise(function(z, ce) {
          re.nextTick(function() {
            M[v] ? ce(M[v]) : z(P(void 0, !0));
          });
        });
      var J = this[R], X;
      if (J)
        X = new Promise(V(J, this));
      else {
        var Z = this[x].read();
        if (Z !== null)
          return Promise.resolve(P(Z, !1));
        X = new Promise(this[l]);
      }
      return this[R] = X, X;
    }
  }, r(e, Symbol.asyncIterator, function() {
    return this;
  }), r(e, "return", function() {
    var M = this;
    return new Promise(function($, J) {
      M[x].destroy(null, function(X) {
        if (X) {
          J(X);
          return;
        }
        $(P(void 0, !0));
      });
    });
  }), e), W), w = function(M) {
    var $, J = Object.create(m, ($ = {}, r($, x, {
      value: M,
      writable: !0
    }), r($, u, {
      value: null,
      writable: !0
    }), r($, h, {
      value: null,
      writable: !0
    }), r($, v, {
      value: null,
      writable: !0
    }), r($, b, {
      value: M._readableState.endEmitted,
      writable: !0
    }), r($, l, {
      value: function(Z, z) {
        var ce = J[x].read();
        ce ? (J[R] = null, J[u] = null, J[h] = null, Z(P(ce, !1))) : (J[u] = Z, J[h] = z);
      },
      writable: !0
    }), $));
    return J[R] = null, c(M, function(X) {
      if (X && X.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var Z = J[h];
        Z !== null && (J[R] = null, J[u] = null, J[h] = null, Z(X)), J[v] = X;
        return;
      }
      var z = J[u];
      z !== null && (J[R] = null, J[u] = null, J[h] = null, z(P(void 0, !0))), J[b] = !0;
    }), M.on("readable", L.bind(null, J)), J;
  };
  return Nr = w, Nr;
}
var Mr, hi;
function Ef() {
  return hi || (hi = 1, Mr = function() {
    throw new Error("Readable.from is not available in the browser");
  }), Mr;
}
var Lr, yi;
function yo() {
  if (yi) return Lr;
  yi = 1, Lr = z;
  var e;
  z.ReadableState = Z, pn.EventEmitter;
  var r = function(y, D) {
    return y.listeners(D).length;
  }, i = co(), o = kt.Buffer, c = (typeof He < "u" ? He : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function u(s) {
    return o.from(s);
  }
  function h(s) {
    return o.isBuffer(s) || s instanceof c;
  }
  var v = Le, b;
  v && v.debuglog ? b = v.debuglog("stream") : b = function() {
  };
  var R = vf(), l = lo(), x = po(), P = x.getHighWaterMark, N = yt().codes, L = N.ERR_INVALID_ARG_TYPE, V = N.ERR_STREAM_PUSH_AFTER_EOF, W = N.ERR_METHOD_NOT_IMPLEMENTED, m = N.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, w, j, M;
  Ke(z, i);
  var $ = l.errorOrDestroy, J = ["error", "close", "destroy", "pause", "resume"];
  function X(s, y, D) {
    if (typeof s.prependListener == "function") return s.prependListener(y, D);
    !s._events || !s._events[y] ? s.on(y, D) : Array.isArray(s._events[y]) ? s._events[y].unshift(D) : s._events[y] = [D, s._events[y]];
  }
  function Z(s, y, D) {
    e = e || ht(), s = s || {}, typeof D != "boolean" && (D = y instanceof e), this.objectMode = !!s.objectMode, D && (this.objectMode = this.objectMode || !!s.readableObjectMode), this.highWaterMark = P(this, s, "readableHighWaterMark", D), this.buffer = new R(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = s.emitClose !== !1, this.autoDestroy = !!s.autoDestroy, this.destroyed = !1, this.defaultEncoding = s.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, s.encoding && (w || (w = ci().StringDecoder), this.decoder = new w(s.encoding), this.encoding = s.encoding);
  }
  function z(s) {
    if (e = e || ht(), !(this instanceof z)) return new z(s);
    var y = this instanceof e;
    this._readableState = new Z(s, this, y), this.readable = !0, s && (typeof s.read == "function" && (this._read = s.read), typeof s.destroy == "function" && (this._destroy = s.destroy)), i.call(this);
  }
  Object.defineProperty(z.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(y) {
      this._readableState && (this._readableState.destroyed = y);
    }
  }), z.prototype.destroy = l.destroy, z.prototype._undestroy = l.undestroy, z.prototype._destroy = function(s, y) {
    y(s);
  }, z.prototype.push = function(s, y) {
    var D = this._readableState, H;
    return D.objectMode ? H = !0 : typeof s == "string" && (y = y || D.defaultEncoding, y !== D.encoding && (s = o.from(s, y), y = ""), H = !0), ce(this, s, y, !1, H);
  }, z.prototype.unshift = function(s) {
    return ce(this, s, null, !0, !1);
  };
  function ce(s, y, D, H, ue) {
    b("readableAddChunk", y);
    var te = s._readableState;
    if (y === null)
      te.reading = !1, we(s, te);
    else {
      var oe;
      if (ue || (oe = ie(te, y)), oe)
        $(s, oe);
      else if (te.objectMode || y && y.length > 0)
        if (typeof y != "string" && !te.objectMode && Object.getPrototypeOf(y) !== o.prototype && (y = u(y)), H)
          te.endEmitted ? $(s, new m()) : de(s, te, y, !0);
        else if (te.ended)
          $(s, new V());
        else {
          if (te.destroyed)
            return !1;
          te.reading = !1, te.decoder && !D ? (y = te.decoder.write(y), te.objectMode || y.length !== 0 ? de(s, te, y, !1) : q(s, te)) : de(s, te, y, !1);
        }
      else H || (te.reading = !1, q(s, te));
    }
    return !te.ended && (te.length < te.highWaterMark || te.length === 0);
  }
  function de(s, y, D, H) {
    y.flowing && y.length === 0 && !y.sync ? (y.awaitDrain = 0, s.emit("data", D)) : (y.length += y.objectMode ? 1 : D.length, H ? y.buffer.unshift(D) : y.buffer.push(D), y.needReadable && _e(s)), q(s, y);
  }
  function ie(s, y) {
    var D;
    return !h(y) && typeof y != "string" && y !== void 0 && !s.objectMode && (D = new L("chunk", ["string", "Buffer", "Uint8Array"], y)), D;
  }
  z.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, z.prototype.setEncoding = function(s) {
    w || (w = ci().StringDecoder);
    var y = new w(s);
    this._readableState.decoder = y, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var D = this._readableState.buffer.head, H = ""; D !== null; )
      H += y.write(D.data), D = D.next;
    return this._readableState.buffer.clear(), H !== "" && this._readableState.buffer.push(H), this._readableState.length = H.length, this;
  };
  var he = 1073741824;
  function Se(s) {
    return s >= he ? s = he : (s--, s |= s >>> 1, s |= s >>> 2, s |= s >>> 4, s |= s >>> 8, s |= s >>> 16, s++), s;
  }
  function Oe(s, y) {
    return s <= 0 || y.length === 0 && y.ended ? 0 : y.objectMode ? 1 : s !== s ? y.flowing && y.length ? y.buffer.head.data.length : y.length : (s > y.highWaterMark && (y.highWaterMark = Se(s)), s <= y.length ? s : y.ended ? y.length : (y.needReadable = !0, 0));
  }
  z.prototype.read = function(s) {
    b("read", s), s = parseInt(s, 10);
    var y = this._readableState, D = s;
    if (s !== 0 && (y.emittedReadable = !1), s === 0 && y.needReadable && ((y.highWaterMark !== 0 ? y.length >= y.highWaterMark : y.length > 0) || y.ended))
      return b("read: emitReadable", y.length, y.ended), y.length === 0 && y.ended ? S(this) : _e(this), null;
    if (s = Oe(s, y), s === 0 && y.ended)
      return y.length === 0 && S(this), null;
    var H = y.needReadable;
    b("need readable", H), (y.length === 0 || y.length - s < y.highWaterMark) && (H = !0, b("length less than watermark", H)), y.ended || y.reading ? (H = !1, b("reading or ended", H)) : H && (b("do read"), y.reading = !0, y.sync = !0, y.length === 0 && (y.needReadable = !0), this._read(y.highWaterMark), y.sync = !1, y.reading || (s = Oe(D, y)));
    var ue;
    return s > 0 ? ue = d(s, y) : ue = null, ue === null ? (y.needReadable = y.length <= y.highWaterMark, s = 0) : (y.length -= s, y.awaitDrain = 0), y.length === 0 && (y.ended || (y.needReadable = !0), D !== s && y.ended && S(this)), ue !== null && this.emit("data", ue), ue;
  };
  function we(s, y) {
    if (b("onEofChunk"), !y.ended) {
      if (y.decoder) {
        var D = y.decoder.end();
        D && D.length && (y.buffer.push(D), y.length += y.objectMode ? 1 : D.length);
      }
      y.ended = !0, y.sync ? _e(s) : (y.needReadable = !1, y.emittedReadable || (y.emittedReadable = !0, be(s)));
    }
  }
  function _e(s) {
    var y = s._readableState;
    b("emitReadable", y.needReadable, y.emittedReadable), y.needReadable = !1, y.emittedReadable || (b("emitReadable", y.flowing), y.emittedReadable = !0, re.nextTick(be, s));
  }
  function be(s) {
    var y = s._readableState;
    b("emitReadable_", y.destroyed, y.length, y.ended), !y.destroyed && (y.length || y.ended) && (s.emit("readable"), y.emittedReadable = !1), y.needReadable = !y.flowing && !y.ended && y.length <= y.highWaterMark, f(s);
  }
  function q(s, y) {
    y.readingMore || (y.readingMore = !0, re.nextTick(G, s, y));
  }
  function G(s, y) {
    for (; !y.reading && !y.ended && (y.length < y.highWaterMark || y.flowing && y.length === 0); ) {
      var D = y.length;
      if (b("maybeReadMore read 0"), s.read(0), D === y.length)
        break;
    }
    y.readingMore = !1;
  }
  z.prototype._read = function(s) {
    $(this, new W("_read()"));
  }, z.prototype.pipe = function(s, y) {
    var D = this, H = this._readableState;
    switch (H.pipesCount) {
      case 0:
        H.pipes = s;
        break;
      case 1:
        H.pipes = [H.pipes, s];
        break;
      default:
        H.pipes.push(s);
        break;
    }
    H.pipesCount += 1, b("pipe count=%d opts=%j", H.pipesCount, y);
    var ue = (!y || y.end !== !1) && s !== re.stdout && s !== re.stderr, te = ue ? me : Y;
    H.endEmitted ? re.nextTick(te) : D.once("end", te), s.on("unpipe", oe);
    function oe(ee, K) {
      b("onunpipe"), ee === D && K && K.hasUnpiped === !1 && (K.hasUnpiped = !0, Ie());
    }
    function me() {
      b("onend"), s.end();
    }
    var C = Q(D);
    s.on("drain", C);
    var xe = !1;
    function Ie() {
      b("cleanup"), s.removeListener("close", O), s.removeListener("finish", T), s.removeListener("drain", C), s.removeListener("error", Te), s.removeListener("unpipe", oe), D.removeListener("end", me), D.removeListener("end", Y), D.removeListener("data", Fe), xe = !0, H.awaitDrain && (!s._writableState || s._writableState.needDrain) && C();
    }
    D.on("data", Fe);
    function Fe(ee) {
      b("ondata");
      var K = s.write(ee);
      b("dest.write", K), K === !1 && ((H.pipesCount === 1 && H.pipes === s || H.pipesCount > 1 && U(H.pipes, s) !== -1) && !xe && (b("false write response, pause", H.awaitDrain), H.awaitDrain++), D.pause());
    }
    function Te(ee) {
      b("onerror", ee), Y(), s.removeListener("error", Te), r(s, "error") === 0 && $(s, ee);
    }
    X(s, "error", Te);
    function O() {
      s.removeListener("finish", T), Y();
    }
    s.once("close", O);
    function T() {
      b("onfinish"), s.removeListener("close", O), Y();
    }
    s.once("finish", T);
    function Y() {
      b("unpipe"), D.unpipe(s);
    }
    return s.emit("pipe", D), H.flowing || (b("pipe resume"), D.resume()), s;
  };
  function Q(s) {
    return function() {
      var D = s._readableState;
      b("pipeOnDrain", D.awaitDrain), D.awaitDrain && D.awaitDrain--, D.awaitDrain === 0 && r(s, "data") && (D.flowing = !0, f(s));
    };
  }
  z.prototype.unpipe = function(s) {
    var y = this._readableState, D = {
      hasUnpiped: !1
    };
    if (y.pipesCount === 0) return this;
    if (y.pipesCount === 1)
      return s && s !== y.pipes ? this : (s || (s = y.pipes), y.pipes = null, y.pipesCount = 0, y.flowing = !1, s && s.emit("unpipe", this, D), this);
    if (!s) {
      var H = y.pipes, ue = y.pipesCount;
      y.pipes = null, y.pipesCount = 0, y.flowing = !1;
      for (var te = 0; te < ue; te++) H[te].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var oe = U(y.pipes, s);
    return oe === -1 ? this : (y.pipes.splice(oe, 1), y.pipesCount -= 1, y.pipesCount === 1 && (y.pipes = y.pipes[0]), s.emit("unpipe", this, D), this);
  }, z.prototype.on = function(s, y) {
    var D = i.prototype.on.call(this, s, y), H = this._readableState;
    return s === "data" ? (H.readableListening = this.listenerCount("readable") > 0, H.flowing !== !1 && this.resume()) : s === "readable" && !H.endEmitted && !H.readableListening && (H.readableListening = H.needReadable = !0, H.flowing = !1, H.emittedReadable = !1, b("on readable", H.length, H.reading), H.length ? _e(this) : H.reading || re.nextTick(I, this)), D;
  }, z.prototype.addListener = z.prototype.on, z.prototype.removeListener = function(s, y) {
    var D = i.prototype.removeListener.call(this, s, y);
    return s === "readable" && re.nextTick(E, this), D;
  }, z.prototype.removeAllListeners = function(s) {
    var y = i.prototype.removeAllListeners.apply(this, arguments);
    return (s === "readable" || s === void 0) && re.nextTick(E, this), y;
  };
  function E(s) {
    var y = s._readableState;
    y.readableListening = s.listenerCount("readable") > 0, y.resumeScheduled && !y.paused ? y.flowing = !0 : s.listenerCount("data") > 0 && s.resume();
  }
  function I(s) {
    b("readable nexttick read 0"), s.read(0);
  }
  z.prototype.resume = function() {
    var s = this._readableState;
    return s.flowing || (b("resume"), s.flowing = !s.readableListening, g(this, s)), s.paused = !1, this;
  };
  function g(s, y) {
    y.resumeScheduled || (y.resumeScheduled = !0, re.nextTick(_, s, y));
  }
  function _(s, y) {
    b("resume", y.reading), y.reading || s.read(0), y.resumeScheduled = !1, s.emit("resume"), f(s), y.flowing && !y.reading && s.read(0);
  }
  z.prototype.pause = function() {
    return b("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (b("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function f(s) {
    var y = s._readableState;
    for (b("flow", y.flowing); y.flowing && s.read() !== null; ) ;
  }
  z.prototype.wrap = function(s) {
    var y = this, D = this._readableState, H = !1;
    s.on("end", function() {
      if (b("wrapped end"), D.decoder && !D.ended) {
        var oe = D.decoder.end();
        oe && oe.length && y.push(oe);
      }
      y.push(null);
    }), s.on("data", function(oe) {
      if (b("wrapped data"), D.decoder && (oe = D.decoder.write(oe)), !(D.objectMode && oe == null) && !(!D.objectMode && (!oe || !oe.length))) {
        var me = y.push(oe);
        me || (H = !0, s.pause());
      }
    });
    for (var ue in s)
      this[ue] === void 0 && typeof s[ue] == "function" && (this[ue] = /* @__PURE__ */ function(me) {
        return function() {
          return s[me].apply(s, arguments);
        };
      }(ue));
    for (var te = 0; te < J.length; te++)
      s.on(J[te], this.emit.bind(this, J[te]));
    return this._read = function(oe) {
      b("wrapped _read", oe), H && (H = !1, s.resume());
    }, this;
  }, typeof Symbol == "function" && (z.prototype[Symbol.asyncIterator] = function() {
    return j === void 0 && (j = wf()), j(this);
  }), Object.defineProperty(z.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(z.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(z.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(y) {
      this._readableState && (this._readableState.flowing = y);
    }
  }), z._fromList = d, Object.defineProperty(z.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function d(s, y) {
    if (y.length === 0) return null;
    var D;
    return y.objectMode ? D = y.buffer.shift() : !s || s >= y.length ? (y.decoder ? D = y.buffer.join("") : y.buffer.length === 1 ? D = y.buffer.first() : D = y.buffer.concat(y.length), y.buffer.clear()) : D = y.buffer.consume(s, y.decoder), D;
  }
  function S(s) {
    var y = s._readableState;
    b("endReadable", y.endEmitted), y.endEmitted || (y.ended = !0, re.nextTick(B, y, s));
  }
  function B(s, y) {
    if (b("endReadableNT", s.endEmitted, s.length), !s.endEmitted && s.length === 0 && (s.endEmitted = !0, y.readable = !1, y.emit("end"), s.autoDestroy)) {
      var D = y._writableState;
      (!D || D.autoDestroy && D.finished) && y.destroy();
    }
  }
  typeof Symbol == "function" && (z.from = function(s, y) {
    return M === void 0 && (M = Ef()), M(z, s, y);
  });
  function U(s, y) {
    for (var D = 0, H = s.length; D < H; D++)
      if (s[D] === y) return D;
    return -1;
  }
  return Lr;
}
var Dr, di;
function go() {
  if (di) return Dr;
  di = 1, Dr = v;
  var e = yt().codes, r = e.ERR_METHOD_NOT_IMPLEMENTED, i = e.ERR_MULTIPLE_CALLBACK, o = e.ERR_TRANSFORM_ALREADY_TRANSFORMING, c = e.ERR_TRANSFORM_WITH_LENGTH_0, u = ht();
  Ke(v, u);
  function h(l, x) {
    var P = this._transformState;
    P.transforming = !1;
    var N = P.writecb;
    if (N === null)
      return this.emit("error", new i());
    P.writechunk = null, P.writecb = null, x != null && this.push(x), N(l);
    var L = this._readableState;
    L.reading = !1, (L.needReadable || L.length < L.highWaterMark) && this._read(L.highWaterMark);
  }
  function v(l) {
    if (!(this instanceof v)) return new v(l);
    u.call(this, l), this._transformState = {
      afterTransform: h.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, l && (typeof l.transform == "function" && (this._transform = l.transform), typeof l.flush == "function" && (this._flush = l.flush)), this.on("prefinish", b);
  }
  function b() {
    var l = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(x, P) {
      R(l, x, P);
    }) : R(this, null, null);
  }
  v.prototype.push = function(l, x) {
    return this._transformState.needTransform = !1, u.prototype.push.call(this, l, x);
  }, v.prototype._transform = function(l, x, P) {
    P(new r("_transform()"));
  }, v.prototype._write = function(l, x, P) {
    var N = this._transformState;
    if (N.writecb = P, N.writechunk = l, N.writeencoding = x, !N.transforming) {
      var L = this._readableState;
      (N.needTransform || L.needReadable || L.length < L.highWaterMark) && this._read(L.highWaterMark);
    }
  }, v.prototype._read = function(l) {
    var x = this._transformState;
    x.writechunk !== null && !x.transforming ? (x.transforming = !0, this._transform(x.writechunk, x.writeencoding, x.afterTransform)) : x.needTransform = !0;
  }, v.prototype._destroy = function(l, x) {
    u.prototype._destroy.call(this, l, function(P) {
      x(P);
    });
  };
  function R(l, x, P) {
    if (x) return l.emit("error", x);
    if (P != null && l.push(P), l._writableState.length) throw new c();
    if (l._transformState.transforming) throw new o();
    return l.push(null);
  }
  return Dr;
}
var Ur, gi;
function Sf() {
  if (gi) return Ur;
  gi = 1, Ur = r;
  var e = go();
  Ke(r, e);
  function r(i) {
    if (!(this instanceof r)) return new r(i);
    e.call(this, i);
  }
  return r.prototype._transform = function(i, o, c) {
    c(null, i);
  }, Ur;
}
var $r, vi;
function _f() {
  if (vi) return $r;
  vi = 1;
  var e;
  function r(P) {
    var N = !1;
    return function() {
      N || (N = !0, P.apply(void 0, arguments));
    };
  }
  var i = yt().codes, o = i.ERR_MISSING_ARGS, c = i.ERR_STREAM_DESTROYED;
  function u(P) {
    if (P) throw P;
  }
  function h(P) {
    return P.setHeader && typeof P.abort == "function";
  }
  function v(P, N, L, V) {
    V = r(V);
    var W = !1;
    P.on("close", function() {
      W = !0;
    }), e === void 0 && (e = hn()), e(P, {
      readable: N,
      writable: L
    }, function(w) {
      if (w) return V(w);
      W = !0, V();
    });
    var m = !1;
    return function(w) {
      if (!W && !m) {
        if (m = !0, h(P)) return P.abort();
        if (typeof P.destroy == "function") return P.destroy();
        V(w || new c("pipe"));
      }
    };
  }
  function b(P) {
    P();
  }
  function R(P, N) {
    return P.pipe(N);
  }
  function l(P) {
    return !P.length || typeof P[P.length - 1] != "function" ? u : P.pop();
  }
  function x() {
    for (var P = arguments.length, N = new Array(P), L = 0; L < P; L++)
      N[L] = arguments[L];
    var V = l(N);
    if (Array.isArray(N[0]) && (N = N[0]), N.length < 2)
      throw new o("streams");
    var W, m = N.map(function(w, j) {
      var M = j < N.length - 1, $ = j > 0;
      return v(w, M, $, function(J) {
        W || (W = J), J && m.forEach(b), !M && (m.forEach(b), V(W));
      });
    });
    return N.reduce(R);
  }
  return $r = x, $r;
}
var Af = Me, yn = pn.EventEmitter, Rf = Ke;
Rf(Me, yn);
Me.Readable = yo();
Me.Writable = ho();
Me.Duplex = ht();
Me.Transform = go();
Me.PassThrough = Sf();
Me.finished = hn();
Me.pipeline = _f();
Me.Stream = Me;
function Me() {
  yn.call(this);
}
Me.prototype.pipe = function(e, r) {
  var i = this;
  function o(l) {
    e.writable && e.write(l) === !1 && i.pause && i.pause();
  }
  i.on("data", o);
  function c() {
    i.readable && i.resume && i.resume();
  }
  e.on("drain", c), !e._isStdio && (!r || r.end !== !1) && (i.on("end", h), i.on("close", v));
  var u = !1;
  function h() {
    u || (u = !0, e.end());
  }
  function v() {
    u || (u = !0, typeof e.destroy == "function" && e.destroy());
  }
  function b(l) {
    if (R(), yn.listenerCount(this, "error") === 0)
      throw l;
  }
  i.on("error", b), e.on("error", b);
  function R() {
    i.removeListener("data", o), e.removeListener("drain", c), i.removeListener("end", h), i.removeListener("close", v), i.removeListener("error", b), e.removeListener("error", b), i.removeListener("end", R), i.removeListener("close", R), e.removeListener("close", R);
  }
  return i.on("end", R), i.on("close", R), e.on("close", R), e.emit("pipe", i), e;
};
var Bt = Ut(), Of = Af.Stream, Pf = Le, jf = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
function kr(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function We(e, r, i, o, c) {
  throw new Bt.AssertionError({
    message: Pf.format("%s (%s) is required", e, r),
    actual: c === void 0 ? typeof o : c(o),
    expected: r,
    operator: i || "===",
    stackStartFunction: We.caller
  });
}
function Cr(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function rt() {
}
var gt = {
  bool: {
    check: function(e) {
      return typeof e == "boolean";
    }
  },
  func: {
    check: function(e) {
      return typeof e == "function";
    }
  },
  string: {
    check: function(e) {
      return typeof e == "string";
    }
  },
  object: {
    check: function(e) {
      return typeof e == "object" && e !== null;
    }
  },
  number: {
    check: function(e) {
      return typeof e == "number" && !isNaN(e);
    }
  },
  finite: {
    check: function(e) {
      return typeof e == "number" && !isNaN(e) && isFinite(e);
    }
  },
  buffer: {
    check: function(e) {
      return Qr.isBuffer(e);
    },
    operator: "Buffer.isBuffer"
  },
  array: {
    check: function(e) {
      return Array.isArray(e);
    },
    operator: "Array.isArray"
  },
  stream: {
    check: function(e) {
      return e instanceof Of;
    },
    operator: "instanceof",
    actual: Cr
  },
  date: {
    check: function(e) {
      return e instanceof Date;
    },
    operator: "instanceof",
    actual: Cr
  },
  regexp: {
    check: function(e) {
      return e instanceof RegExp;
    },
    operator: "instanceof",
    actual: Cr
  },
  uuid: {
    check: function(e) {
      return typeof e == "string" && jf.test(e);
    },
    operator: "isUUID"
  }
};
function vo(e) {
  var r = Object.keys(gt), i;
  return re.env.NODE_NDEBUG ? i = rt : i = function(o, c) {
    o || We(c, "true", o);
  }, r.forEach(function(o) {
    if (e) {
      i[o] = rt;
      return;
    }
    var c = gt[o];
    i[o] = function(u, h) {
      c.check(u) || We(h, o, c.operator, u, c.actual);
    };
  }), r.forEach(function(o) {
    var c = "optional" + kr(o);
    if (e) {
      i[c] = rt;
      return;
    }
    var u = gt[o];
    i[c] = function(h, v) {
      h != null && (u.check(h) || We(v, o, u.operator, h, u.actual));
    };
  }), r.forEach(function(o) {
    var c = "arrayOf" + kr(o);
    if (e) {
      i[c] = rt;
      return;
    }
    var u = gt[o], h = "[" + o + "]";
    i[c] = function(v, b) {
      Array.isArray(v) || We(b, h, u.operator, v, u.actual);
      var R;
      for (R = 0; R < v.length; R++)
        u.check(v[R]) || We(b, h, u.operator, v, u.actual);
    };
  }), r.forEach(function(o) {
    var c = "optionalArrayOf" + kr(o);
    if (e) {
      i[c] = rt;
      return;
    }
    var u = gt[o], h = "[" + o + "]";
    i[c] = function(v, b) {
      if (v != null) {
        Array.isArray(v) || We(b, h, u.operator, v, u.actual);
        var R;
        for (R = 0; R < v.length; R++)
          u.check(v[R]) || We(b, h, u.operator, v, u.actual);
      }
    };
  }), Object.keys(Bt).forEach(function(o) {
    if (o === "AssertionError") {
      i[o] = Bt[o];
      return;
    }
    if (e) {
      i[o] = rt;
      return;
    }
    i[o] = Bt[o];
  }), i._setExports = vo, i;
}
var If = vo(re.env.NODE_NDEBUG), Vt = {}, bt = Ut(), Tf = Le;
Vt.sprintf = dn;
Vt.printf = Bf;
Vt.fprintf = bo;
function dn(e) {
  var r = [
    "([^%]*)",
    /* normal text */
    "%",
    /* start of format */
    "(['\\-+ #0]*?)",
    /* flags (optional) */
    "([1-9]\\d*)?",
    /* width (optional) */
    "(\\.([1-9]\\d*))?",
    /* precision (optional) */
    "[lhjztL]*?",
    /* length mods (ignored) */
    "([diouxXfFeEgGaAcCsSp%jr])"
    /* conversion */
  ].join(""), i = new RegExp(r), o = Array.prototype.slice.call(arguments, 1), c = e, u, h, v, b, R, l, x, P, N, L = "", V = 1, W = 0, m, w;
  for (bt.equal(
    "string",
    typeof c,
    "first argument must be a format string"
  ); (N = i.exec(c)) !== null; ) {
    if (L += N[1], c = c.substring(N[0].length), w = N[0].substring(N[1].length), m = W + N[1].length + 1, W += N[0].length, u = N[2] || "", h = N[3] || 0, v = N[4] || "", b = N[6], R = !1, x = !1, l = " ", b == "%") {
      L += "%";
      continue;
    }
    if (o.length === 0)
      throw vt(
        e,
        m,
        w,
        "has no matching argument (too few arguments passed)"
      );
    if (P = o.shift(), V++, u.match(/[\' #]/))
      throw vt(
        e,
        m,
        w,
        "uses unsupported flags"
      );
    if (v.length > 0)
      throw vt(
        e,
        m,
        w,
        "uses non-zero precision (not supported)"
      );
    switch (u.match(/-/) && (R = !0), u.match(/0/) && (l = "0"), u.match(/\+/) && (x = !0), b) {
      case "s":
        if (P == null)
          throw vt(
            e,
            m,
            w,
            "attempted to print undefined or null as a string (argument " + V + " to sprintf)"
          );
        L += qr(l, h, R, P.toString());
        break;
      case "d":
        P = Math.floor(P);
      case "f":
        x = x && P > 0 ? "+" : "", L += x + qr(
          l,
          h,
          R,
          P.toString()
        );
        break;
      case "x":
        L += qr(l, h, R, P.toString(16));
        break;
      case "j":
        h === 0 && (h = 10), L += Tf.inspect(P, !1, h);
        break;
      case "r":
        L += mo(P);
        break;
      default:
        throw vt(
          e,
          m,
          w,
          "is not supported"
        );
    }
  }
  return L += c, L;
}
function vt(e, r, i, o) {
  return bt.equal(typeof e, "string"), bt.equal(typeof i, "string"), bt.equal(typeof r, "number"), bt.equal(typeof o, "string"), new Error('format string "' + e + '": conversion specifier "' + i + '" at character ' + r + " " + o);
}
function Bf() {
  var e = Array.prototype.slice.call(arguments);
  e.unshift(re.stdout), bo.apply(null, e);
}
function bo(e) {
  var r = Array.prototype.slice.call(arguments, 1);
  return e.write(dn.apply(this, r));
}
function qr(e, r, i, o) {
  for (var c = o; c.length < r; )
    i ? c += e : c = e + c;
  return c;
}
function mo(e) {
  var r;
  if (!(e instanceof Error))
    throw new Error(dn("invalid type for %%r: %j", e));
  if (r = "EXCEPTION: " + e.constructor.name + ": " + e.stack, e.cause && typeof e.cause == "function") {
    var i = e.cause();
    i && (r += `
Caused by: ` + mo(i));
  }
  return r;
}
var Be = {};
function xf(e) {
  return Array.isArray ? Array.isArray(e) : Ht(e) === "[object Array]";
}
Be.isArray = xf;
function Ff(e) {
  return typeof e == "boolean";
}
Be.isBoolean = Ff;
function Nf(e) {
  return e === null;
}
Be.isNull = Nf;
function Mf(e) {
  return e == null;
}
Be.isNullOrUndefined = Mf;
function Lf(e) {
  return typeof e == "number";
}
Be.isNumber = Lf;
function Df(e) {
  return typeof e == "string";
}
Be.isString = Df;
function Uf(e) {
  return typeof e == "symbol";
}
Be.isSymbol = Uf;
function $f(e) {
  return e === void 0;
}
Be.isUndefined = $f;
function kf(e) {
  return Ht(e) === "[object RegExp]";
}
Be.isRegExp = kf;
function Cf(e) {
  return typeof e == "object" && e !== null;
}
Be.isObject = Cf;
function qf(e) {
  return Ht(e) === "[object Date]";
}
Be.isDate = qf;
function Wf(e) {
  return Ht(e) === "[object Error]" || e instanceof Error;
}
Be.isError = Wf;
function Gf(e) {
  return typeof e == "function";
}
Be.isFunction = Gf;
function Vf(e) {
  return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || // ES6 symbol
  typeof e > "u";
}
Be.isPrimitive = Vf;
Be.isBuffer = Qr.isBuffer;
function Ht(e) {
  return Object.prototype.toString.call(e);
}
var Re = If, zt = Le, Hf = Vt, De = Be.isError, zf = Hf.sprintf, Yf = le;
le.VError = le;
le.SError = mt;
le.WError = Ve;
le.MultiError = dt;
function gn(e) {
  var r, i, o, c, u;
  if (Re.object(e, "args"), Re.bool(e.strict, "args.strict"), Re.array(e.argv, "args.argv"), r = e.argv, r.length === 0)
    i = {}, o = [];
  else if (De(r[0]))
    i = { cause: r[0] }, o = r.slice(1);
  else if (typeof r[0] == "object") {
    i = {};
    for (u in r[0])
      i[u] = r[0][u];
    o = r.slice(1);
  } else
    Re.string(
      r[0],
      "first argument to VError, SError, or WError constructor must be a string, object, or Error"
    ), i = {}, o = r;
  return Re.object(i), !i.strict && !e.strict && (o = o.map(function(h) {
    return h === null ? "null" : h === void 0 ? "undefined" : h;
  })), o.length === 0 ? c = "" : c = zf.apply(null, o), {
    options: i,
    shortmessage: c
  };
}
function le() {
  var e, r, i, o, c, u, h;
  if (e = Array.prototype.slice.call(arguments, 0), !(this instanceof le))
    return r = Object.create(le.prototype), le.apply(r, arguments), r;
  if (i = gn({
    argv: e,
    strict: !1
  }), i.options.name && (Re.string(
    i.options.name,
    `error's "name" must be a string`
  ), this.name = i.options.name), this.jse_shortmsg = i.shortmessage, u = i.shortmessage, o = i.options.cause, o && (Re.ok(De(o), "cause is not an Error"), this.jse_cause = o, i.options.skipCauseMessage || (u += ": " + o.message)), this.jse_info = {}, i.options.info)
    for (h in i.options.info)
      this.jse_info[h] = i.options.info[h];
  return this.message = u, Error.call(this, u), Error.captureStackTrace && (c = i.options.constructorOpt || this.constructor, Error.captureStackTrace(this, c)), this;
}
zt.inherits(le, Error);
le.prototype.name = "VError";
le.prototype.toString = function() {
  var r = this.hasOwnProperty("name") && this.name || this.constructor.name || this.constructor.prototype.name;
  return this.message && (r += ": " + this.message), r;
};
le.prototype.cause = function() {
  var r = le.cause(this);
  return r === null ? void 0 : r;
};
le.cause = function(e) {
  return Re.ok(De(e), "err must be an Error"), De(e.jse_cause) ? e.jse_cause : null;
};
le.info = function(e) {
  var r, i, o;
  if (Re.ok(De(e), "err must be an Error"), i = le.cause(e), i !== null ? r = le.info(i) : r = {}, typeof e.jse_info == "object" && e.jse_info !== null)
    for (o in e.jse_info)
      r[o] = e.jse_info[o];
  return r;
};
le.findCauseByName = function(e, r) {
  var i;
  for (Re.ok(De(e), "err must be an Error"), Re.string(r, "name"), Re.ok(r.length > 0, "name cannot be empty"), i = e; i !== null; i = le.cause(i))
    if (Re.ok(De(i)), i.name == r)
      return i;
  return null;
};
le.hasCauseWithName = function(e, r) {
  return le.findCauseByName(e, r) !== null;
};
le.fullStack = function(e) {
  Re.ok(De(e), "err must be an Error");
  var r = le.cause(e);
  return r ? e.stack + `
caused by: ` + le.fullStack(r) : e.stack;
};
le.errorFromList = function(e) {
  return Re.arrayOfObject(e, "errors"), e.length === 0 ? null : (e.forEach(function(r) {
    Re.ok(De(r));
  }), e.length == 1 ? e[0] : new dt(e));
};
le.errorForEach = function(e, r) {
  Re.ok(De(e), "err must be an Error"), Re.func(r, "func"), e instanceof dt ? e.errors().forEach(function(o) {
    r(o);
  }) : r(e);
};
function mt() {
  var e, r, i, o;
  return e = Array.prototype.slice.call(arguments, 0), this instanceof mt ? (i = gn({
    argv: e,
    strict: !0
  }), o = i.options, le.call(this, o, "%s", i.shortmessage), this) : (r = Object.create(mt.prototype), mt.apply(r, arguments), r);
}
zt.inherits(mt, le);
function dt(e) {
  Re.array(e, "list of errors"), Re.ok(e.length > 0, "must be at least one error"), this.ase_errors = e, le.call(this, {
    cause: e[0]
  }, "first of %d error%s", e.length, e.length == 1 ? "" : "s");
}
zt.inherits(dt, le);
dt.prototype.name = "MultiError";
dt.prototype.errors = function() {
  return this.ase_errors.slice(0);
};
function Ve() {
  var e, r, i, o;
  return e = Array.prototype.slice.call(arguments, 0), this instanceof Ve ? (i = gn({
    argv: e,
    strict: !1
  }), o = i.options, o.skipCauseMessage = !0, le.call(this, o, "%s", i.shortmessage), this) : (r = Object.create(Ve.prototype), Ve.apply(r, e), r);
}
zt.inherits(Ve, le);
Ve.prototype.name = "WError";
Ve.prototype.toString = function() {
  var r = this.hasOwnProperty("name") && this.name || this.constructor.name || this.constructor.prototype.name;
  return this.message && (r += ": " + this.message), this.jse_cause && this.jse_cause.message && (r += "; caused by " + this.jse_cause.toString()), r;
};
Ve.prototype.cause = function(r) {
  return De(r) && (this.jse_cause = r), this.jse_cause;
};
const Yt = /* @__PURE__ */ wo(Yf);
class Xf extends Yt {
  constructor(r, i) {
    super(
      {
        name: "PolicyNotFoundError",
        info: {
          policy: r
        },
        cause: i
      },
      `Policy "${r}" not found`
    );
  }
}
class Kf extends Yt {
  constructor(r, i) {
    super(
      {
        name: "FileNotFoundError",
        info: {
          filename: r
        },
        cause: i
      },
      `File "${r}" not found`
    );
  }
}
class Zf extends Yt {
  constructor(r, i, o) {
    super(
      {
        name: "PasswordGenerationError",
        info: {
          policy: JSON.stringify(r),
          timeout: i,
          triedPasswords: o
        }
      },
      "Exceeded timeout while trying to generate a password. Does the policy contradict itself?"
    );
  }
}
class Qf extends Yt {
  constructor() {
    super(
      { name: "CryptographicInsecurityError" },
      "No cryptographically secure generator available, abort password-generation"
    );
  }
}
export {
  Qr as B,
  Qf as C,
  Kf as F,
  Zf as P,
  Xf as a,
  Eo as b,
  He as c,
  wo as g,
  re as p,
  kt as r,
  Le as u
};
